import React, { Suspense, useState, useEffect, useRef } from "react";
import store from "./../redux_store/store/index";
import axios from "axios";
import {
  updatecontrolrights,
  addauditoption,
  SheetandProtocolOrders,
} from "./../redux_store/actions/index";
import $ from "jquery";
import * as translation from "react-multi-lang";
import AuditActionEnum, { AuditModuleNameEnum } from "./AuditActionEnum";
import CryptoJS from "crypto-js";
import ReactHtmlParser from "react-html-parser";
import pako, { gzip } from "pako";
import { Protocolscreenenum, isMultitenant, modelList, month as montharray, zeroPad, isJQspread } from "./Constance";
import * as FileSaver from "file-saver";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import KendoCombobox from "../controls/KendoCombobox";
import KendoDatepicker from "../controls/KendoDatepicker";
import KendoGridView from "../controls/KendoGridView";
// import TextBox from "../controls/TextBox";
// import { CardBody } from "reactstrap";
// import { Collapse } from "reactstrap";
import { Row, Col, Card, FormGroup, FormLabel } from "react-bootstrap";
import { Container } from "reactstrap";
import { Label } from "reactstrap";
import { Button } from "reactstrap";
import { ContentPanel, ReadOnlyText } from "../custom_modules/inventory/components/App.styles";
import { convertDateFormat, convertExtensionToIcon } from "../helpers/helperMethods";
import { saveAs } from "@progress/kendo-file-saver";
import { Editor, EditorTools, EditorUtils } from '@progress/kendo-react-editor';
import { Workbook } from "@progress/kendo-ooxml";
const {
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Subscript,
  Superscript
} = EditorTools;
const useInternationalization = React.lazy(() => import("@progress/kendo-react-intl"));
// const axios = require("axios");



function userdetails() {
  let objdat = {},
    rtnObj = {};

  objdat["sUserStatus"] = "";
  rtnObj["ActiveUserDetails"] = objdat;
  return rtnObj;
}

function addShowClass(e) {
  $(".filterBlock").hasClass("clsFilters");
  $(".filterBlock").toggleClass("show");
  $(".filterByBtn").toggleClass("active");
  $(".filter-top-group").toggleClass("active");
}

function showOrderBlock(e) {
  $(".leftcontainer").hasClass("clsdisplayblock");
  $(".leftcontainer").toggleClass("show");
  $(".createOrderBtn").toggleClass("active");
}

function PercentageCalculator(Totalcount, count) {
  let percentage = (count / Totalcount) * 100;
  return percentage;
}

function SPCCalculation(xvalue, yvalue, Subgroupcount) {
  let CalculatedValue = {};
  let count = yvalue !== undefined && yvalue.length > 0 ? yvalue.length : 0;
  let average = 0;
  let sum = 0;
  if (yvalue !== undefined && yvalue.length > 0) {
    for (let ycount = 0; ycount < yvalue.length; ycount++) {
      let value = yvalue[ycount];
      let value1 = value === null ? "" : value.toString().replace(",", ".");
      sum += parseFloat(value1);
    }
  }
  /* yvalue.reduce(function(a, b) {
    return a + b;
  }, 0);*/
  average = sum / count;
  CalculatedValue.avegare = average;
  let startvalue = 0;
  let endvalue = 0;
  if (xvalue !== undefined && xvalue.length > 0) {
    startvalue = xvalue[0];
    endvalue = xvalue[xvalue.length - 1];
  }
  CalculatedValue.centerXval = [startvalue, endvalue];
  CalculatedValue.centerYval = [average, average];

  let upperband2time = average + 2 * (average / 1.128);
  let upperband3time = average + 3 * (average / 1.128);

  CalculatedValue.Upper2Xval = [startvalue, endvalue];
  CalculatedValue.Upper2Yval = [upperband2time, upperband2time];

  CalculatedValue.Upper3Xval = [startvalue, endvalue];
  CalculatedValue.Upper3Yval = [upperband3time, upperband3time];

  let lowerband2time = average - 2 * (average / 1.128);
  let lowerband3time = average - 3 * (average / 1.128);

  CalculatedValue.Lower2Xval = [startvalue, endvalue];
  CalculatedValue.Lower2Yval = [lowerband2time, lowerband2time];

  CalculatedValue.Lower3Xval = [startvalue, endvalue];
  CalculatedValue.Lower3Yval = [lowerband3time, lowerband3time];

  return CalculatedValue;
}

function convertdoubledigitdate(day, month) {
  var newDate;

  if (day !== undefined && day >= 1) {
    newDate = day.toString();
    // day = Number(day.trim());
    // return day;
  }

  if (month !== undefined && month >= 1) {
    newDate = month.toString();
    // day = Number(day.trim());
    // return month;
  }

  return newDate;
}

function convertdoubledigittime(hour, min, secounds) {
  if (hour.toString().length === 1) {
    hour = "0" + hour.toString();
    // day = Number(day.trim());
  }
  if (min.toString().length === 1) {
    min = "0" + min.toString();
    // day = Number(day.trim());
  }
  if (secounds.toString().length === 1) {
    secounds = "0" + secounds.toString();
    // day = Number(day.trim());
  }
  let time = hour + ":" + min + ":" + secounds;
  return time;
}

function convertfulldateformat(year, month, day) {
  if (month.toString().length === 1) {
    month = "0" + month.toString();
  }
  if (day.toString().length === 1) {
    day = "0" + day.toString();
  }
  let fullyear = year.toString() + month + day;
  return fullyear;
}

function AuditTrailValidation(ModuleName, ScreenName, TaskName) {
  let auditConfig = store.getState().audit.auditoption;

  let auditarray = auditConfig.AuditConfig;
  if (auditarray === undefined) {
    return false;
  }
  let val = auditarray.findIndex(
    (e) =>
      e.modulename === ModuleName &&
      e.screenname === ScreenName &&
      e.taskname === TaskName
  );
  let audiVal = false;

  if (val > -1) {
    if (auditarray[val].manualaudittrail === 1) {
      audiVal = true;
    }
  }
  return audiVal;
}

function generateLink(ordercode, screen, activekey, openfrom) {
  let link = "";
  // this.path = window.location.href.toString();
  let encryptedbatchcode = CF_encryptionData(ordercode).EncryptData;

  let detail = "";
  if (screen === "Sheet") {
    detail = CF_encryptionData(
      (sessionStorage.getItem("tenantid") !== undefined &&
        sessionStorage.getItem("tenantid") !== null &&
        sessionStorage.getItem("tenantid") !== ""
        ? sessionStorage.getItem("tenantid")
        : "-1") +
      "//" +
      screen
    ).EncryptData;
  } else {
    detail = CF_encryptionData(
      (sessionStorage.getItem("tenantid") !== undefined &&
        sessionStorage.getItem("tenantid") !== null &&
        sessionStorage.getItem("tenantid") !== ""
        ? sessionStorage.getItem("tenantid")
        : "-1") +
      "//" +
      screen +
      "//" +
      activekey +
      "//" +
      sessionStorage.getItem("Protocol_Userworkflows")
    ).EncryptData;
  }

  /**
   * don't remove below commented code
   *
   */

  // start

  // let encryptedbatchid = CF_encryptionData("VALIDATE1000004").EncryptData;
  // const userObject = {
  //   usercode: sessionStorage.getItem("User"),
  //   username: sessionStorage.getItem("Username"),
  //   userfullname: sessionStorage.getItem("Userfullname"),
  //   password: 'gyX57EHs08KuakyVhFVvGQ==',
  //   lsusergroup: {
  //       usergroupcode: sessionStorage.getItem("multiusergroups"),
  //       usergroupname: sessionStorage.getItem("usergroupname"),
  //   },
  //   lssitemaster:{
  //     sitecode:sessionStorage.getItem('sSiteCode')
  //   }
  // }
  // let encrypteduser = CF_encryptionData(userObject).EncryptData;

  // end

  const baseURL =
    isMultitenant === 1 || isMultitenant === 2
      ? window.location.origin.toString()
      : window.location?.pathname.includes("/ELN") ? window.location.origin.toString() + "/ELN" : window.location.origin.toString();

  link =
    baseURL +
    "/vieworder" +
    '#{"orderid":"' +
    encryptedbatchcode +
    '","d":"' +
    detail +
    '","openfrom":"' +
    openfrom +
    /**
     * don't remove below commented code
     *
     */
    // '","user":"' +
    // encrypteduser +
    // '","batchid":"' +
    // encryptedbatchid +
    '"}';

  return link;
}

function ControlRights(ModuleName, DisplayTopic) {
  let screencontrol = store.getState().Menu.Controlrights.rights;

  let val = -1;

  let rights = false;
  let save = false;
  let edit = false;
  let del = false;
  let val1 = -1;
  if (screencontrol !== undefined) {
    val = screencontrol.findIndex(
      (e) => e.modulename === ModuleName && e.displaytopic === DisplayTopic
    );
    val1 = screencontrol.filter(
      (e) => e.modulename === ModuleName && e.screenname === DisplayTopic
    );
  }

  if (val > -1) {
    if (screencontrol[val].sallow.trim() === "1") {
      rights = true;
      if (screencontrol[val].screate.trim() === "1") {
        save = true;
      } else {
        save = false;
      }
      if (screencontrol[val].sedit.trim() === "1") {
        edit = true;
      } else {
        edit = false;
      }
      if (screencontrol[val].sdelete.trim() === "1") {
        del = true;
      } else {
        del = false;
      }
    } else if (val1.length > 0) {
      val1.map((item) => {
        if (item.sallow.trim() === "1") {
          rights = true;
          if (item.screate.trim() === "1") {
            save = true;
          } else {
            save = false;
          }
          if (item.sedit.trim() === "1") {
            edit = true;
          } else {
            edit = false;
          }
          if (item.sdelete.trim() === "1") {
            del = true;
          } else {
            del = false;
          }
          return true;
        } else {
          return false;
        }
      });
    }
  } else if (val1.length > 0) {
    val1.map((item) => {
      if (item.sallow.trim() === "1") {
        rights = true;
        if (item.screate.trim() === "1") {
          save = true;
        } else {
          save = false;
        }
        if (item.sedit.trim() === "1") {
          edit = true;
        } else {
          edit = false;
        }
        if (item.sdelete.trim() === "1") {
          del = true;
        } else {
          del = false;
        }
        return true;
      } else {
        return false;
      }
    });
  }

  let objdat = {},
    rtnObj = {};

  objdat["rights"] = rights;
  objdat["save"] = save;
  objdat["edit"] = edit;
  objdat["del"] = del;
  rtnObj["UserGroupRights"] = objdat;

  return rtnObj;
}

function onGetUserControlRights(screen) {

  const getRights = (screenName, taskName) => {
    const rights = ControlRightsOnOrdersTask(screenName, taskName);
    return rights.UserGroupRights.rights;
  };

  const screenName = screen === 'Sheet' ? 'IDS_SCN_SHEETORDERS' : 'IDS_SCN_PROTOCOLORDERS';

  return {
    share: getRights(screenName, 'IDS_TSK_SHARE'),
    copy: getRights(screenName, 'IDS_TSK_COPYLINK'),
    cancel: getRights(screenName, 'IDS_TSK_CANCELORDER'),
    clone: getRights(screenName, 'IDS_TSK_CLONEORDER'),
  };
};

function ControlRightsOnOrdersTask(screenName, DisplayTopic) {
  let screencontrol = store.getState().Menu.Controlrights.rights;

  if (!screencontrol) {
    return { UserGroupRights: { rights: false, save: false, edit: false, del: false } };
  } else {
    const val = screencontrol.findIndex((e) => e.screenname === screenName && e.displaytopic === DisplayTopic);

    if (val === -1) {
      return { UserGroupRights: { rights: false, save: false, edit: false, del: false } };
    }

    const control = screencontrol[val];

    const rights = control.sallow.trim() === "1";
    const save = control.screate.trim() === "1";
    const edit = control.sedit.trim() === "1";
    const del = control.sdelete.trim() === "1";

    return {
      UserGroupRights: {
        rights,
        save,
        edit,
        del
      }
    };
  }
}

function Servicecallforuserrightscallback(url, data, callback) {
  Servicecalls(url, data,
    (response) => {
      response.User = sessionStorage.User;
      store.dispatch(updatecontrolrights(response));
      callback();
    }, (response) => { });
}

function AuditTrailValidationOnScreen(ModuleName, ScreenName) {
  const { auditoption } = store.getState().audit;

  if (!auditoption || !auditoption.AuditConfig) {
    return {}; // Return an empty object if auditoption or AuditConfig is not defined
  }

  const filteredTasks = auditoption.AuditConfig
    .filter(({ modulename, screenname }) => modulename === ModuleName && screenname === ScreenName)
    .reduce((result, { taskname, manualaudittrail }) => {
      manualaudittrail = parseInt(manualaudittrail) !== 0;
      result[taskname] = manualaudittrail;
      return result;
    }, {});

  return filteredTasks;
}

function SubMenuRights(ModuleName, DisplayTopic) {
  let screeenRights = store.getState().Menu.Controlrights.rights;

  let rights = false;

  if (screeenRights !== undefined) {

    let val1 = screeenRights.filter((e) => e.modulename === ModuleName && (e.screenname === DisplayTopic || e.displaytopic === DisplayTopic));

    val1.map((item) => {
      if (item.sallow.trim() === "1") {
        rights = true;
        return true;
      } else {
        return false;
      }
    });
  }
  if (DisplayTopic === "IDS_SCN_EQUIPMENTPARAMS" || DisplayTopic === "IDS_SCN_SequenceGeneratorMASTER") {
    rights = true;
  }
  return rights;
}
/**
 * 
 * @param {*} ModuleName 
 * @param {*} DisplayTopic 
 * @returns 
 */
function SubMenuRightsonScreenViews(ModuleName, DisplayTopic, isload) {
  let screeenRights = store.getState().Menu.Controlrights.rights;

  let rights = false;

  if (screeenRights !== undefined) {

    let valScreenView = screeenRights.filter((e) => e.modulename === ModuleName && e.screenname === DisplayTopic && e.displaytopic === "IDS_TSK_SCREENVIEW");

    if (valScreenView[0]?.sallow !== undefined) {

      if (valScreenView[0]?.sallow?.trim() === "1") {
        rights = true;
      } else {
        // if (DisplayTopic === 'IDS_SCN_MATERIALMGMT' && valScreenView[0]?.sallow?.trim() === "0") {
        //   valScreenView = screeenRights.filter((e) => e.modulename === ModuleName && e.screenname === "IDS_SCN_SAMPLEMGMT" && e.displaytopic === "IDS_TSK_SCREENVIEW");

        //   if (valScreenView[0]?.sallow?.trim() === "1") {
        //     rights = true;
        //   }
        // }

        if (isload === true) {
          valScreenView = screeenRights.filter((e) => e.modulename === ModuleName && e.displaytopic === "IDS_TSK_SCREENVIEW" && e?.sallow?.trim() === "1");
          if (valScreenView[0]?.sallow?.trim() === "1") {
            rights = true;
          }
        }

        // if (DisplayTopic === 'IDS_SCN_USERGROUP' && valScreenView[0]?.sallow?.trim() === "0") {

        //   valScreenView = screeenRights.filter(
        //     (e) =>
        //       (e.modulename === ModuleName && e.screenname === "IDS_SCN_USERMASTER" && e.displaytopic === "IDS_TSK_SCREENVIEW")
        //       ||
        //       (e.modulename === ModuleName && e.screenname === "IDS_SCN_USERRIGHTS" && e.displaytopic === "IDS_TSK_SCREENVIEW")
        //   );

        //   if (valScreenView[0]?.sallow?.trim() === "1") {
        //     rights = true;
        //   }
        // }
      }

    } else {
      let val1 = screeenRights.filter((e) => e.modulename === ModuleName && (e.screenname === DisplayTopic || e.displaytopic === DisplayTopic));

      val1.map((item) => {
        if (item.sallow.trim() === "1") {
          rights = true;
          return true;
        } else {
          return false;
        }
      });
    }

    if (Number(sessionStorage.multiusergroups) === 1 && DisplayTopic === "IDS_SCN_SequenceGeneratorMASTER") {
      rights = true;
    }
  } else {
    rights = false;
  }
  return rights;
}

/**
 * 
 * @param {*} ModuleName 
 * @param {*} DisplayTopic 
 * @returns 
 */
function getSubMenuRightsonScreenViews(ModuleName, DisplayTopic) {
  let screeenRights = store.getState().Menu.Controlrights.rights;

  let rights = false;

  if (screeenRights !== undefined) {

    let valScreenView = screeenRights.filter((e) => e.modulename === ModuleName && e.screenname === DisplayTopic
      && e.displaytopic === "IDS_TSK_SCREENVIEW");

    if (valScreenView[0]?.sallow !== undefined) {

      if (valScreenView[0]?.sallow?.trim() === "1") {
        rights = true;
      } else {
        rights = false;
      }
    }
  }
  return rights;
}

function getModuleRihtsOnOrderModule(ModuleName) {
  let isRightsSetted = false;
  let modelLst = modelList();
  let returnObj = {};

  // for (let index = 0; index < modelLst.mainMenu.length; index++) {
  //   for (let menu of modelLst.modelLst[modelLst.mainMenu[index]]) {
  //     if (!isRightsSetted) {
  //       isRightsSetted = SubMenuRightsonScreenViews(menu.accordianNavTitle, menu.name);
  //       if (isRightsSetted) {
  //         returnObj = menu;
  //       }
  //       break;
  //     }
  //   }
  //   if (isRightsSetted) break;
  // }

  modelLst.mainMenu.forEach(key => {
    const records = modelLst.modelLst[key];
    if (!isRightsSetted && records && Array.isArray(records)) {
      console.log(`Records for ${key}:`);
      records.forEach(record => {
        if (!isRightsSetted) {
          isRightsSetted = SubMenuRightsonScreenViews(record.accordianNavTitle, record.name);
          if (isRightsSetted) {
            returnObj = record;
          }
        }
      });
    }
  });

  return returnObj;
}

function ModuleRights(ModuleName, ScreenName) {
  let screencontrol = store.getState().Menu.Controlrights.rights;
  let rights = false;
  if (screencontrol !== undefined) {
    if (ModuleName !== "IDS_MDL_ORDERS") {
      let val = screencontrol.findIndex(
        (e) => e.modulename === ModuleName && e.sallow.trim() === "1"
      );

      if (val > -1) {
        if (screencontrol[val].sallow.trim() === "1") {
          rights = true;
        }
      }
    } else if (ModuleName === "IDS_MDL_ORDERS") {
      let val = screencontrol.findIndex(
        (e) =>
          e.modulename === ModuleName &&
          e.screenname === ScreenName &&
          e.sallow.trim() === "1"
      );

      if (val > -1) {
        if (screencontrol[val].sallow.trim() === "1") {
          rights = true;
        }
      }
    }
  }

  return rights;
}

function mainModuleRights(ModuleName) {

  let screencontrol = store.getState().Menu.Controlrights.rights;
  let rights = false;
  if (screencontrol !== undefined) {

    let val = screencontrol.findIndex(
      (e) => (e.modulename === ModuleName && e.displaytopic === "IDS_TSK_SCREENVIEW" && e.sallow.trim() === "1")
    );

    if (val > -1) {
      if (screencontrol[val].sallow.trim() === "1") {
        rights = true;
      }
    }
  }
  return rights;
}

function IsJSON(str) {
  if (str === undefined || str === null) {
    return false;
  }
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

function isINT(value) {
  let val = Number.isInteger(value);

  return val;
}

function killSessionLogout() {
  $.session.remove("User");
  $.session.remove("Username");
  $.session.remove("name");
  $.session.remove("Usersite");
  $.session.remove("Usersitename");
  $.session.remove("usergroupname");
  $.session.remove("idletime");
}

function Silentauditobject(
  ManipulationType,
  ModuleName,
  objA,
  objB,
  TableName
) {
  if (ModuleName === "Sheet Orders") {
    ModuleName = isMultitenant === 2 ? "IDS_LBL_LABSHEETTASKS" : "Sheet Order";
  } else if (ModuleName === "Sheet Templates") {
    ModuleName = "Sheet Templates";
  } else if (ModuleName === "Protocol Orders") {
    ModuleName = isMultitenant === 2 ? "IDS_LBL_PROTOCOLTASKS" : "Protocol Orders"
  }

  let comments = "";
  if (objA !== undefined || objB !== undefined) {
    comments = compareObjs(objA, objB);
  }

  if (ManipulationType === "IDS_TSK_DELETE" || ManipulationType === "update") {
    comments = compareObjsOperation(objA, objB, ManipulationType, ModuleName);
  }

  let name = $.session.get("name");

  let Audit = {
    lssitemaster: parseInt($.session.get("Usersite")),
    lsuserMaster: parseInt($.session.get("User")),
    transactiondate: GetutcDate(new Date()),
    moduleName: AuditModuleNameEnum[ModuleName],
    manipulatetype: translation.t(
      "compareObjs." + AuditActionEnum[ManipulationType]
    ),
    comments,
    actions: AuditActionEnum[ManipulationType],
    systemcoments:
      "Audittrail.Audittrailhistory.Audittype.IDS_AUDIT_SYSTEMGENERATED",
    username: name,
    tableName: TableName,
  };
  return Audit;
}

function SilentauditobjectForOrder(
  ManipulationType,
  ModuleName,
  objA,
  objB,
  TableName,
  auditKey
) {
  if (ModuleName === "Sheet Orders") {
    ModuleName = "Sheet Order";
  } else if (ModuleName === "Sheet Templates") {
    ModuleName = "Sheet Templates";
  }

  let comments = "";
  if (objA !== undefined || objB !== undefined) {
    comments = compareObjs(objA, objB);
  }

  if (ManipulationType === "IDS_TSK_DELETE" || ManipulationType === "update") {
    comments = compareObjsOperation(objA, objB, ManipulationType, ModuleName);
  }

  let name = $.session.get("name");

  let Audit = {
    lssitemaster: parseInt($.session.get("Usersite")),
    lsuserMaster: parseInt($.session.get("User")),
    transactiondate: GetutcDate(new Date()),
    moduleName: AuditModuleNameEnum[ModuleName],
    manipulatetype: translation.t(
      "compareObjs." + AuditActionEnum[ManipulationType]
    ),
    comments,
    actions: AuditActionEnum[ManipulationType],
    systemcoments:
      "Audittrail.Audittrailhistory.Audittype.IDS_AUDIT_SYSTEMGENERATED",
    username: name,
    tableName: TableName,
    batchcode: auditKey !== undefined ? auditKey : "",
  };
  return Audit;
}

function onAuditHandler(ManipulationType, ModuleName, objA, tableName) {
  if (ModuleName === "Sheet Orders") {
    ModuleName = isMultitenant === 2 ? "IDS_LBL_LABSHEETTASKS" : "Sheet Order";
  } else if (ModuleName === "Sheet Templates") {
    ModuleName = "Sheet Templates";
  } if (ModuleName === "Protocol Orders") {
    ModuleName = isMultitenant === 2 ? "IDS_LBL_PROTOCOLTASKS" : "Protocol Orders"
  }

  let comments = objA;
  // let name = store.getState().Loggeduser.username;
  let name = $.session.get("name");
  let Audit = {
    lssitemaster: parseInt($.session.get("Usersite")),
    lsuserMaster: parseInt($.session.get("User")),
    transactiondate: GetutcDate(new Date()),
    moduleName: AuditModuleNameEnum[ModuleName],
    manipulatetype: translation.t(
      "compareObjs." + AuditActionEnum[ManipulationType]
    ),
    comments,
    actions: AuditActionEnum[ManipulationType],
    systemcoments:
      "Audittrail.Audittrailhistory.Audittype.IDS_AUDIT_SYSTEMGENERATED",
    username: name,
    tableName: tableName,
  };

  return Audit;
}

function Silentauditobjectonlogout(
  ManipulationType,
  lsuser,
  ModuleName,
  objA,
  objB
) {
  if (ModuleName === "Sheet Orders") {
    ModuleName = "Sheet Order";
  } else if (ModuleName === "Sheet Templates") {
    ModuleName = "Sheet Templates";
  }

  let comments = "";
  if (objA !== undefined || objB !== undefined) {
    comments = compareObjs(objA, objB);
  }
  let name = $.session.get("name");

  let Audit = {
    lssitemaster: lsuser.lssitemaster
      ? lsuser.lssitemaster.sitecode
      : parseInt($.session.get("Usersite")),
    lsuserMaster: lsuser.usercode,
    transactiondate: GetutcDate(new Date()),
    moduleName: AuditModuleNameEnum[ModuleName],
    manipulatetype: translation.t(
      "compareObjs." + AuditActionEnum[ManipulationType]
    ),
    comments,
    actions: translation.t("compareObjs." + AuditActionEnum[ManipulationType]),
    systemcoments:
      "Audittrail.Audittrailhistory.Audittype.IDS_AUDIT_SYSTEMGENERATED",
    username: name,
  };
  return Audit;
}

function Manualauditobject(ManipulationType, ModuleName) {
  if (ModuleName === "Sheet Orders") {
    ModuleName = "Sheet Order";
  } else if (ModuleName === "Sheet Templates") {
    ModuleName = "Sheet Templates";
  }
  let Audit1 = {
    lssitemaster: parseInt($.session.get("Usersite")),
    lsuserMaster: parseInt($.session.get("User")),
    transactiondate: GetutcDate(new Date()),
    moduleName: AuditModuleNameEnum[ModuleName],
    manipulatetype: translation.t(
      "compareObjs." + AuditActionEnum[ManipulationType]
    ),
    actions: AuditActionEnum[ManipulationType],
    systemcoments:
      "Audittrail.Audittrailhistory.Audittype.IDS_AUDIT_USERGENERATED",
  };
  return Audit1;
}

function GetUtcDateFormat(dateval) {
  var date = new Date(dateval);
  var month = (date.getMonth() + 1).toString().padStart(2, '0');
  var day = date.getDate().toString().padStart(2, '0');
  var hours = date.getHours().toString().padStart(2, '0');
  var minutes = date.getMinutes().toString().padStart(2, '0');
  var seconds = date.getSeconds().toString().padStart(2, '0');

  var dateformat = date.getFullYear() + "." + month + "." + day + " "
    + hours + ":" + minutes + ":" + seconds;
  return dateformat;
}

function GetutcDate(dateval) {
  var date = new Date(dateval);
  var now_utc = Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
  return now_utc;
}

function GetutctoDate(dateval) {
  var date = new Date(dateval);
  let settime = new Date();
  var now_utc = Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    settime.getUTCHours(),
    settime.getUTCMinutes(),
    settime.getUTCSeconds()
  );
  return now_utc;
}

function GetutcDateoncurenttime(dateval) {
  var datetime = new Date();
  var date = new Date(dateval);
  var now_utc = Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    datetime.getUTCHours(),
    datetime.getUTCMinutes(),
    datetime.getUTCSeconds()
  );
  return new Date(now_utc);
}

function convertUTCDateToLocalDate(date) {
  var now_utc = new Date(date.toISOString());
  return now_utc;
}

function GetutcDateaudi(dateval) {
  var date = new Date(dateval);
  // var nowUtc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 12, 1, 0);
  var nowUtc = new Date(date.setHours(0, 0, 1, 0));
  // var nowUtc = new Date(dateval.setUTCHours(0, 0, 0, 0) + dateval.getTimezoneOffset() * 60000);
  return nowUtc;
}

function GetTabActiveOrNot() {
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) {
      console.log("Tab is inactive");
      return true;
    } else {
      console.log("Tab is active");
      return false;
    }
  });
}



function compareData(fieldname, dataA, dataB) {
  let transField = translation.t("Common.IDS_AUDIT_" + fieldname);
  if (dataB !== undefined) {
    if (transField.includes("Common.")) {
      transField = "";
      return "";
    } else {
      // transField += ": ";
      return dataA !== dataB
        ? transField +
        ": " +
        translation.t("Common.IDS_AUDIT_WASCHANGEDTO", {
          from: dataA,
          to: dataB,
        })
        : transField +
        ": " +
        translation.t("Common.IDS_LBL_UPDATED", { param: "" });
    }
    // return dataA !== dataB ? transField + translation.t("compareObjs.ID_WASCHANGEDTO", { from: dataA, to: dataB }) : "";
  } else {
    return "";
  }
}

function predefineddatabase(databasename) {
  var dbname = [
    "template1",
    "template0",
    "postgres",
    "sales",
    "database",
    "CLASS",
    "DATA",
  ];
  let init = 0;
  let warningmsg = "";
  for (init; init < dbname.length; init++) {
    if (databasename.toLowerCase() === dbname[init].toLowerCase()) {
      warningmsg = translation.t("Organisation.IDS_LBL_WARMSG");
    }
  }
  return warningmsg;
}

function generateComment(obj) {
  let commentArray = [];
  Object.entries(obj).map((objEntries) => {
    if (obj[objEntries[0]] !== null && typeof obj[objEntries[0]] === "object") {
      Object.entries(obj[objEntries[0]]).map((objAentries) => {
        let tempKey = translation.t("compareObjs.ID_" + objAentries[0]);
        if (!tempKey.includes("compareObjs.")) {
          commentArray.push(
            translation.t("Common.IDS_AUDIT_KEYANDVALUE", {
              KeyVal: tempKey,

              ValueVal: objAentries[1],
            })
          );
        } else {
          commentArray.push(
            translation.t("Common.IDS_AUDIT_KEYANDVALUE", {
              KeyVal: objAentries[0],
              ValueVal: objEntries[1],
            })
          );
        }
        return undefined;
      });
    } else {
      if (objEntries[1] !== "") {
        let tempKey = translation.t("compareObjs.ID_" + objEntries[0]);
        if (!tempKey.includes("compareObjs.")) {
          commentArray.push(
            translation.t("Common.IDS_AUDIT_KEYANDVALUE", {
              KeyVal: tempKey,
              user: $.session.get("Username"),
              ValueVal: objEntries[1],
            })
          );
        } else {
          commentArray.push(
            translation.t("Common.IDS_AUDIT_KEYANDVALUE", {
              KeyVal: objEntries[0],
              user: $.session.get("Username"),
              ValueVal: objEntries[1],
            })
          );
        }
      }
    }
    return undefined;
  });
  return commentArray;
}

function compareObjs(objA, objB) {
  let returnComment = "";
  if (typeof objA === "string") {
    returnComment = objA;
  } else {
    objA = objA || {};
    objB = objB || {};
    if (
      Object.entries(objA).length > 0 &&
      objA !== undefined &&
      Object.entries(objB).length > 0 &&
      objB !== undefined
    ) {
      if (
        typeof objA === "object" &&
        Object.entries(objA)[0][0] !== 0 &&
        Object.entries(objA)[0][0] !== "0"
      ) {
        const objAkeys = Object.keys(objA).sort();
        const objBkeys = Object.keys(objB).sort();
        let commentArray = [];
        let isEditedItem = true;
        if (objAkeys.join(", ") === objBkeys.join(", ")) {
          isEditedItem = true;
        } else {
          let present = objBkeys.find((keyName) => objAkeys.includes(keyName));
          // if (present.length > 0) {
          if (present > 0) {
            isEditedItem = true;
          } else {
            isEditedItem = false;
          }
        }
        if (isEditedItem) {
          objAkeys.map((objKey) =>
            typeof objA[objKey] === "object" && typeof objB[objKey] === "object"
              ? Object.entries(objA[objKey]).map((objAentries) =>
                commentArray.push(
                  compareData(
                    objAentries[0],
                    objA[objKey][objAentries[0]],
                    objB[objKey][objAentries[0]]
                  )
                )
              )
              : commentArray.push(
                compareData(objKey, objA[objKey], objB[objKey])
              )
          );
        } else {
          commentArray = generateComment(objB);
        }
        returnComment = commentArray
          .filter((string) => string !== "")
          .join(", ");
      }
    } else if (
      objA !== undefined &&
      Object.entries(objA).length > 0 &&
      (objB === undefined || Object.entries(objB).length === 0)
    ) {
      let commentArray = [];
      commentArray = generateComment(objA);
      returnComment = commentArray.join(", ");
    } else if (
      (Object.entries(objA).length === 0 || objA === undefined) &&
      (Object.entries(objB).length === 0 || objB === undefined)
    ) {
      returnComment = translation.t("compareObjs.IDS_BOTHOBJECTCANNOTBEEMPTY");
    }
  }
  return returnComment;
}

function compareObjsOperation(objA, objB, ManipulationType, ModuleName) {
  let returnComment = "";
  if (typeof objA === "string") {
    returnComment = objA;
  } else {
    objA = objA || {};
    objB = objB || {};
    if (
      Object.entries(objA).length > 0 &&
      objA !== undefined &&
      Object.entries(objB).length > 0 &&
      objB !== undefined
    ) {
      if (
        typeof objA === "object" &&
        Object.entries(objA)[0][0] !== 0 &&
        Object.entries(objA)[0][0] !== "0"
      ) {
        const objAkeys = Object.keys(objA).sort();
        const objBkeys = Object.keys(objB).sort();
        let commentArray = [];
        let isEditedItem = true;
        if (objAkeys.join(", ") === objBkeys.join(", ")) {
          isEditedItem = true;
        } else {
          let present = objBkeys.find((keyName) => objAkeys.includes(keyName));
          // if (present.length > 0) {
          if (present > 0) {
            isEditedItem = true;
          } else {
            isEditedItem = false;
          }
        }
        if (isEditedItem) {
          objAkeys.map((objKey) =>
            typeof objA[objKey] === "object" && typeof objB[objKey] === "object"
              ? Object.entries(objA[objKey]).map((objAentries) =>
                commentArray.push(
                  compareData(
                    objAentries[0],
                    objA[objKey][objAentries[0]],
                    objB[objKey][objAentries[0]]
                  )
                )
              )
              : commentArray.push(
                compareData(objKey, objA[objKey], objB[objKey])
              )
          );
        } else {
          commentArray = generateComment(objB);
        }
        returnComment = commentArray
          .filter((string) => string !== "")
          .join(", ");
      }
    } else if (
      objA !== undefined &&
      Object.entries(objA).length > 0 &&
      (objB === undefined || Object.entries(objB).length === 0)
    ) {
      if (ManipulationType === "delete") {
        // returnComment = translation.t("compareObjs.IDS_DELETEREQ", {
        //   user1: Object.values(objA)[0],
        //   user2: ModuleName,
        // });
      } else {
        let commentArray = [];
        commentArray = generateComment(objA);
        returnComment = commentArray.join(", ");
      }
    } else if (
      (Object.entries(objA).length === 0 || objA === undefined) &&
      (Object.entries(objB).length === 0 || objB === undefined)
    ) {
      returnComment = translation.t("compareObjs.IDS_BOTHOBJECTCANNOTBEEMPTY");
    }
  }
  return returnComment;
}

function orderType(order) {
  switch (order) {
    case 0:
      return "Lims Order";
    case 2:
      return isMultitenant === 2 ? translation.t("Dashboard.IDS_LBL_ELNTASKS") : translation.t("Orders.Sheetorders.IDS_LBL_ELNORDERNEW");
    case 3:
      return isMultitenant === 2 ? translation.t("Dashboard.IDS_LBL_RESEARCHACTASKS") : translation.t("Orders.Sheetorders.IDS_LBL_RESEARCHORDERNEW");
    case 4:
      return isMultitenant === 2 ? translation.t("Dashboard.IDS_LBL_EXCELTASKS") : translation.t("Orders.Sheetorders.IDS_LBL_EXCELMANAGEMENT", { screenname: isMultitenant === 2 ? translation.t("Dashboard.IDS_LBL_TASKS") : translation.t("Dashboard.IDS_LBL_ORDERS") });
    case 5:
      return translation.t("Orders.Sheetorders.IDS_LBL_EVALUATION");
    default:
      return "-";
  }
}

function orderTypeforprotocol(protocolorder) {
  switch (protocolorder) {
    case 1:
      return translation.t("Orders.Protocolorders.IDS_LBL_ELNPROTO", { screenname: isMultitenant === 2 ? translation.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS") : translation.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDER") });
    case 2:
      return translation.t("Orders.Protocolorders.IDS_LBL_DYNAMICPROTO", { screenname: isMultitenant === 2 ? translation.t("Orders.Protocolorders.IDS_LBL_PROTOCOLTASKS") : translation.t("Orders.Protocolorders.IDS_LBL_PROTOCOLORDER") });
    default:
      return "-";
  }
}

function returnMIMEtype(extension) {
  switch (extension) {
    case ".aac":
      return "audio/aac";
    case ".abw":
      return "application/x-abiword";
    case ".arc":
      return "application/x-freearc";
    case ".avi":
      return "video/x-msvideo";
    case ".azw":
      return "application/vnd.amazon.ebook";
    case ".bin":
      return "application/octet-stream";
    case ".bmp":
      return "image/bmp";
    case ".bz":
      return "application/x-bzip";
    case ".bz2":
      return "application/x-bzip2";
    case ".csh":
      return "application/x-csh";
    case ".css":
      return "text/css";
    case ".csv":
      return "text/csv";
    case ".doc":
      return "application/msword";
    case ".docx":
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    case ".eot":
      return "application/vnd.ms-fontobject";
    case ".epub":
      return "application/epub+zip";
    case ".gz":
      return "application/gzip";
    case ".gif":
      return "image/gif";
    case ".htm":
      return "text/html";
    case ".html":
      return "text/html";
    case ".ico":
      return "image/vnd.microsoft.icon";
    case ".ics":
      return "text/calendar";
    case ".jar":
      return "application/java-archive";
    case ".jpeg":
      return "image/jpeg";
    case ".jpg":
      return "image/jpeg";
    case ".js":
      return "text/javascript";
    case ".json":
      return "application/json";
    case ".jsonld":
      return "application/ld+json";
    case ".mid":
      return "audio/midi";
    case ".midi":
      return "audio/x-midi";
    case ".mj":
      return "text/javascript";
    case ".mp3":
      return "audio/mpeg";
    case ".mpeg":
      return "video/mpeg";
    case ".mpkg":
      return "application/vnd.apple.installer+xml";
    case ".odp":
      return "application/vnd.oasis.opendocument.presentation";
    case ".ods":
      return "application/vnd.oasis.opendocument.spreadsheet";
    case ".odt":
      return "application/vnd.oasis.opendocument.text";
    case ".oga":
      return "audio/ogg";
    case ".ogv":
      return "video/ogg";
    case ".ogx":
      return "application/ogg";
    case ".opus":
      return "audio/opus";
    case ".otf":
      return "font/otf";
    case ".png":
      return "image/png";
    case ".pdf":
      return "application/pdf";
    case ".php":
      return "application/x-httpd-php";
    case ".ppt":
      return "application/vnd.ms-powerpoint";
    case ".pptx":
      return "application/vnd.openxmlformats-officedocument.presentationml.presentation";
    case ".rar":
      return "application/vnd.rar";
    case ".rtf":
      return "application/rtf";
    case ".sh":
      return "application/x-sh";
    case ".svg":
      return "image/svg+xml";
    case ".swf":
      return "application/x-shockwave-flash";
    case ".tar":
      return "application/x-tar";
    case ".tif":
      return "image/tiff";
    case ".tiff":
      return "image/tiff";
    case ".ts":
      return "video/mp2t";
    case ".ttf":
      return "font/ttf";
    case ".txt":
      return "text/plain";
    case ".vsd":
      return "application/vnd.visio";
    case ".wav":
      return "audio/wav";
    case ".weba":
      return "audio/webm";
    case ".webm":
      return "video/webm";
    case ".webp":
      return "image/webp";
    case ".woff":
      return "font/woff";
    case ".woff2":
      return "font/woff2";
    case ".xhtml":
      return "application/xhtml+xml";
    case ".xls":
      return "application/vnd.ms-excel";
    case ".xlsx":
      return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    case ".xml":
      return "text/xml";
    case ".xul":
      return "application/vnd.mozilla.xul+xml";
    case ".zip":
      return "application/zip";
    case ".3gp":
      return "video/3gpp";
    case ".3g2":
      return "video/3gpp2";
    case ".7z":
      return "application/x-7z-compressed";
    default:
      return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  }
}

function returnICON(extension) {
  switch (extension) {
    case ".aac":
      return "images/FileIcons/aac.svg";
    case ".abw":
      return "images/FileIcons/docs.svg";
    case ".arc":
      return "images/FileIcons/docs.svg";
    case ".avi":
      return "images/FileIcons/avi.svg";
    case ".azw":
      return "images/FileIcons/docs.svg";
    case ".bin":
      return "images/FileIcons/bin.svg";
    case ".bmp":
      return "images/FileIcons/bmp.svg";
    case ".bz":
      return "images/FileIcons/docs.svg";
    case ".bz2":
      return "images/FileIcons/docs.svg";
    case ".csh":
      return "images/FileIcons/csh.svg";
    case ".css":
      return "images/FileIcons/file.svg";
    case ".csv":
      return "images/FileIcons/csv.svg";
    case ".doc":
      return "images/FileIcons/doc.svg";
    case ".docx":
      return "images/FileIcons/doc.svg";
    case ".eot":
      return "images/FileIcons/docs.svg";
    case ".epub":
      return "images/FileIcons/docs.svg";
    case ".gz":
      return "images/FileIcons/docs.svg";
    case ".gif":
      return "images/FileIcons/gif.svg";
    case ".htm":
      return "images/FileIcons/htm.svg";
    case ".html":
      return "images/FileIcons/html.svg";
    case ".ico":
      return "images/FileIcons/ico.svg";
    case ".ics":
      return "images/FileIcons/docs.svg";
    case ".jar":
      return "images/FileIcons/jar.svg";
    case ".jpeg":
      return "images/FileIcons/image.svg";
    case ".jpg":
      return "images/FileIcons/image.svg";
    case ".js":
      return "images/FileIcons/js.svg";
    case ".json":
      return "images/FileIcons/json.svg";
    case ".jsonld":
      return "images/FileIcons/docs.svg";
    case ".mid":
      return "images/FileIcons/docs.svg";
    case ".midi":
      return "images/FileIcons/docs.svg";
    case ".mj":
      return "images/FileIcons/docs.svg";
    case ".mp3":
      return "images/FileIcons/mp3.svg";
    case ".mpeg":
      return "images/FileIcons/mpeg.svg";
    case ".mpkg":
      return "images/FileIcons/docs.svg";
    case ".odp":
      return "images/FileIcons/odp.svg";
    case ".ods":
      return "images/FileIcons/docs.svg";
    case ".odt":
      return "images/FileIcons/odt.svg";
    case ".oga":
      return "images/FileIcons/docs.svg";
    case ".ogv":
      return "images/FileIcons/docs.svg";
    case ".ogx":
      return "images/FileIcons/docs.svg";
    case ".opus":
      return "images/FileIcons/docs.svg";
    case ".otf":
      return "images/FileIcons/otf.svg";
    case ".png":
      return "images/FileIcons/png.svg";
    case ".pdf":
      return "images/FileIcons/pdf.svg";
    case ".php":
      return "images/FileIcons/php.svg";
    case ".ppt":
      return "images/FileIcons/ppt.svg";
    case ".pptx":
      return "images/FileIcons/pptx.svg";
    case ".rar":
      return "images/FileIcons/rar.svg";
    case ".rtf":
      return "images/FileIcons/rtf.svg";
    case ".sh":
      return "images/FileIcons/sh.svg";
    case ".svg":
      return "images/FileIcons/svg.svg";
    case ".swf":
      return "images/FileIcons/swf.svg";
    case ".tar":
      return "images/FileIcons/tar.svg";
    case ".tif":
      return "images/FileIcons/tif.svg";
    case ".tiff":
      return "images/FileIcons/tiff.svg";
    case ".ts":
      return "images/FileIcons/ts.svg";
    case ".ttf":
      return "images/FileIcons/ttf.svg";
    case ".txt":
      return "images/FileIcons/txt.svg";
    case ".vsd":
      return "images/FileIcons/docs.svg";
    case ".wav":
      return "images/FileIcons/wav.svg";
    case ".weba":
      return "images/FileIcons/docs.svg";
    case ".webm":
      return "images/FileIcons/docs.svg";
    case ".webp":
      return "images/FileIcons/docs.svg";
    case ".woff":
      return "images/FileIcons/docs.svg";
    case ".woff2":
      return "images/FileIcons/docs.svg";
    case ".xhtml":
      return "images/FileIcons/xhtml.svg";
    case ".xls":
      return "images/FileIcons/xls.svg";
    case ".xlsx":
      return "images/FileIcons/xlsx.svg";
    case ".xml":
      return "images/FileIcons/xml.svg";
    case ".xul":
      return "images/FileIcons/docs.svg";
    case ".zip":
      return "images/FileIcons/zip.svg";
    case ".3gp":
      return "images/FileIcons/3gp.svg";
    case ".3g2":
      return "images/FileIcons/3g2.svg";
    case ".7z":
      return "images/FileIcons/7z.svg";
    default:
      return "images/FileIcons/docs.svg";
  }
}

function extractValuefromsheet(sheet) {
  let sheetcontent = [];
  let sheetvalue = [];
  let sheetparameter = [];
  if (!IsJSON(sheet)) {
    sheetcontent = sheet;
  } else {
    sheetcontent = JSON.parse(sheet);
  }

  if (
    sheetcontent !== undefined &&
    sheetcontent.sheets !== undefined &&
    sheetcontent.sheets !== null &&
    sheetcontent.sheets.length > 0
  ) {
    sheetcontent.sheets.map((objsheet) => {
      if (
        objsheet.rows !== undefined &&
        objsheet.rows !== null &&
        objsheet.rows.length > 0
      ) {
        objsheet.rows.map((objrows) => {
          if (objrows !== undefined && objrows !== null) {
            if (
              objrows.cells !== undefined &&
              objrows.cells !== null &&
              objrows.cells.length > 0
            ) {
              objrows.cells.map((objcells) => {
                if (
                  objcells.value !== undefined &&
                  objcells.value !== null &&
                  objcells.value.toString().trim() !== ""
                ) {
                  sheetvalue.push(objcells.value);
                }
                if (
                  objcells.tag !== undefined &&
                  objcells.tag !== null &&
                  objcells.tag.trim() !== ""
                ) {
                  let tagvalue = JSON.parse(objcells.tag);
                  if (
                    tagvalue !== undefined &&
                    tagvalue !== null &&
                    tagvalue.ParameterName !== undefined &&
                    tagvalue.ParameterName !== null &&
                    tagvalue.ParameterName.trim() !== ""
                  )
                    sheetparameter.push(tagvalue.ParameterName);
                }
                return objcells.value;
              });
            }
          }
          return objrows;
        });
      }
      return objsheet;
    });
  }

  return {
    contentvalues: JSON.stringify(sheetvalue),
    contentparameter: JSON.stringify(sheetparameter),
  };
}

// function convertUTCDateToLocalDate(date) {
//   var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
//   var dateutc = newDate.toLocaleString();

//   return dateutc;
// }

function CF_encryptionData(Data) {
  const salt = CryptoJS.lib.WordArray.random(128 / 8);
  const key = CryptoJS.PBKDF2("AGARAM_SDMS_SCRT", salt, {
    keySize: 128 / 32,
    iterations: 100,
  });
  const iv = CryptoJS.lib.WordArray.random(128 / 8);
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(Data), key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });
  // salt, iv will be hex 32 in length
  // append them to the ciphertext for use  in decryption
  const transitmessage = salt.toString() + iv.toString() + encrypted.toString();
  const ct = {
    EncryptData: transitmessage,
  };
  return ct;
}

function CF_decrypt(encryptedAES) {
  //const salt = CryptoJS.lib.WordArray.random(128 / 8);
  //const iv = CryptoJS.lib.WordArray.random(128 / 8);

  var salt = CryptoJS.enc.Hex.parse(encryptedAES.substr(0, 32));
  var iv = CryptoJS.enc.Hex.parse(encryptedAES.substr(32, 32));
  var encrypted = encryptedAES.substring(64);

  var key = CryptoJS.PBKDF2("AGARAM_SDMS_SCRT", salt, {
    keySize: 128 / 32,
    iterations: 100,
  });

  var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
}

function extractValueforDynamiccombo(sheet, tagvalue) {
  let sheetcontent = [];
  let sheetvalue = [];
  let sheetvalueAbovedefault = [];
  let tag = {};
  let sheetindex = 1;
  if (!IsJSON(sheet)) {
    sheetcontent = sheet;
  } else {
    sheetcontent = JSON.parse(sheet);
  }

  if (!IsJSON(tagvalue)) {
    tag = tagvalue;
  } else {
    tag = JSON.parse(tagvalue);
  }

  if (
    sheetcontent !== undefined &&
    sheetcontent.sheets !== undefined &&
    sheetcontent.sheets !== null &&
    sheetcontent.sheets.length > 0 &&
    tag !== undefined &&
    sheetcontent.sheets.length >= parseInt(tag.datafromsheet)
  ) {
    sheetcontent.sheets.map((objsheet) => {
      if (
        sheetindex === parseInt(tag.datafromsheet) &&
        objsheet.rows !== undefined &&
        objsheet.rows !== null &&
        objsheet.rows.length > 0
      ) {
        objsheet.rows.map((objrows) => {
          if (objrows !== undefined && objrows !== null) {
            if (
              objrows.index >= parseInt(tag.datarangefrom) - 1 &&
              objrows.cells !== undefined &&
              objrows.cells !== null &&
              objrows.cells.length > 0
            ) {
              if (objrows.index < 200) {
                objrows.cells.map((objcells) => {
                  if (
                    objcells.index === parseInt(tag.datacolumn) - 1 &&
                    objcells.value !== undefined &&
                    objcells.value !== null &&
                    objcells.value.toString().trim() !== ""
                  ) {
                    sheetvalue.push({
                      datavalue: objcells.value,
                      datadisplay: objcells.value,
                      rowindex: objrows.index,
                    });
                  }
                  return objcells.value;
                });
              } else {
                objrows.cells.map((objcells) => {
                  if (
                    objcells.index === parseInt(tag.datacolumn) - 1 &&
                    objcells.value !== undefined &&
                    objcells.value !== null &&
                    objcells.value.toString().trim() !== ""
                  ) {
                    sheetvalueAbovedefault.push({
                      datavalue: objcells.value,
                      datadisplay: objcells.value,
                      rowindex: objrows.index,
                    });
                  }
                  return objcells.value;
                });
              }
            }
          }
          return objrows;
        });
      }
      sheetindex++;
      return objsheet;
    });
  }

  let returnarray = [];
  if (sheetvalueAbovedefault.length > 0) {
    returnarray = sheetvalue.concat(sheetvalueAbovedefault);
  } else {
    returnarray = sheetvalue;
  }
  returnarray.sort((a, b) => parseInt(a.rowindex) - parseInt(b.rowindex));
  returnarray.reverse();
  return returnarray;
}

async function linkSheetLogin(orderdetails) {
  let ELNurl = window.appUrl.ELN;
  const decryptTenentID = JSON.parse(CF_decrypt(orderdetails.t));
  const decryptUserID = JSON.parse(CF_decrypt(orderdetails.u));
  const decryptGroupCode = JSON.parse(CF_decrypt(orderdetails.uc));
  const decryptGroupName = JSON.parse(CF_decrypt(orderdetails.ug));
  const decryptSiteName = JSON.parse(CF_decrypt(orderdetails.sn));
  const decryptSiteCode = JSON.parse(CF_decrypt(orderdetails.sc));
  // const decryptLogginID = JSON.parse(CF_decrypt(orderdetails.l));
  const decrypttoken = JSON.parse(CF_decrypt(orderdetails.k));
  let decryptloggedfrom = "";
  if (orderdetails.lf !== undefined) {
    decryptloggedfrom = JSON.parse(CF_decrypt(orderdetails.lf));
  }

  let decryptazuretoken = "";
  if (orderdetails.at !== undefined) {
    if (CF_decrypt(orderdetails.at) !== "") {
      decryptazuretoken = JSON.parse(CF_decrypt(orderdetails.at));
    }
  }

  $.session.set("usergroupname", decryptGroupName);
  $.session.set("multiusergroups", decryptGroupCode);
  $.session.set("Usersite", decryptSiteCode);
  $.session.set("Usersitename", decryptSiteName);
  $.session.set("User", Number(decryptUserID));
  $.session.set("tenantcode", decryptTenentID);
  $.session.set("Token", decrypttoken);
  $.session.set("tenantid", decryptTenentID);

  $.session.set("loggedfrom", decryptloggedfrom);
  $.session.set("azuretoken", decryptazuretoken);

  let tenantObj = { name: decryptTenentID };

  var response = await axios
    .post(
      "" + ELNurl + "/multitenant/ValidatetenantByName",
      await gzip(JSON.stringify(tenantObj)),
      {
        headers: {
          "X-TenantID": "MAIN",
          Accept: "application/json",
          "Content-Type": "application/json",
          "Content-Encoding": "gzip",
        },
      }
    )

    .then(async (res) => {
      let response = await formatdata(res.data);
      if (response !== undefined && response !== null) {
        let status =
          response.objResponse !== undefined && response.objResponse !== null
            ? response.objResponse.status
            : false;

        if (status) {
          $.session.set("tenantcode", response.id);
          $.session.set("tenantid", response.name);
          $.session.set("tenantdomain", response.tenantid);
          $.session.set("loginfrom", response.loginfrom);
          $.session.set("noofusers", response.noofusers);
          $.session.set("User", Number(decryptUserID));
          sessionStorage.setItem("licencetype", response.licencetype);
          sessionStorage.setItem("__lock", "1");

          let userObject = { usercode: Number(decryptUserID) };

          Servicecalls(
            "" + ELNurl + "/User/getUserOnCode",
            userObject,
            (res) => {
              Serviceprojectdetails(
                "" + ELNurl +
                "/Instrument/Getuserprojects",
                { usercode: $.session.get("User"), lssitemaster: { sitecode: $.session.get("Usersite") } }
              );

              let response = res;
              if (response !== undefined && response !== null) {
                $.session.set("User", response.usercode);
                $.session.set("Username", response.username);
                $.session.set("Usersite", response.lssitemaster.sitecode);
                $.session.set("Usersitename", response.lssitemaster.sitename);
                $.session.set(
                  "usergroupname",
                  response.multiusergroupcode[0].lsusergroup.usergroupname
                );
                $.session.set(
                  "userpasscodeencrypted",
                  response.encryptedpassword
                );

                if ($.session.get("loggedfrom") === "1") {
                  $.session.set("azuretoken", response.password);
                }
              }
            },
            (res) => { }
          );
        } else {
        }
      }
    })
    .catch((error) => { });

  return response;
}

async function linkSheetnontenantLogin(orderdetails) {
  let ELNurl = window.appUrl.ELN;
  const decryptGroupCode = JSON.parse(CF_decrypt(orderdetails.uc));
  const decryptGroupName = JSON.parse(CF_decrypt(orderdetails.ug));
  const decryptSiteName = JSON.parse(CF_decrypt(orderdetails.sn));
  const decryptSiteCode = JSON.parse(CF_decrypt(orderdetails.sc));
  const decryptUserID = JSON.parse(CF_decrypt(orderdetails.u));
  // const decryptLogginID = JSON.parse(CF_decrypt(orderdetails.l));
  const decrypttoken = JSON.parse(CF_decrypt(orderdetails.k));

  $.session.set("usergroupname", decryptGroupName);
  $.session.set("multiusergroups", decryptGroupCode);
  $.session.set("Usersite", decryptSiteCode);
  $.session.set("Usersitename", decryptSiteName);
  $.session.set("User", Number(decryptUserID));
  $.session.set("Token", decrypttoken);

  $.session.set("User", Number(decryptUserID));

  let userObject = { usercode: Number(decryptUserID) };

  Servicecalls(
    "" + ELNurl + "/User/getUserOnCode",
    userObject,
    (res) => {
      Serviceprojectdetails(
        "" + ELNurl +
        "/Instrument/Getuserprojects",
        { usercode: $.session.get("User"), lssitemaster: { sitecode: $.session.get("Usersite") } }
      );

      let response = res;

      if (response !== undefined && response !== null) {
        $.session.set("User", response.usercode);
        $.session.set("Username", response.username);
        $.session.set("Usersite", response.lssitemaster.sitecode);
        $.session.set("Usersitename", response.lssitemaster.sitename);
        // $.session.set("usergroupname", response.lsusergroup.usergroupname);
        $.session.set(
          "usergroupname",
          response.multiusergroupcode[0].lsusergroup.usergroupname
        );
        $.session.set("ServerDateFormat", response.dformat);
        $.session.set("userpasscodeencrypted", response.encryptedpassword);

        if ($.session.get("loggedfrom") === "1") {
          $.session.set("azuretoken", response.password);
        }
      }
    },
    (res) => { }
  );
}

async function linkOTPLogin(orderdetails) {
  let ELNurl = window.appUrl.ELN;
  const decryptTenentID = orderdetails.t;

  let tenantObj = { name: decryptTenentID };

  ServicecallsMAIN(
    "" + ELNurl + "/multitenant/ValidatetenantByName",
    tenantObj,
    onValidatetenantByNameSuccess.bind(this),
    onValidatetenantByNameFailure.bind(this)
  );
}

async function onValidatetenantByNameSuccess(res) {
  let response = await formatdata(res);
  if (response !== undefined && response !== null) {
    $.session.set("tenantcode", response.id);
    $.session.set("tenantid", response.name);
    $.session.set("tenantdomain", response.tenantid);
    $.session.set("loginfrom", response.loginfrom);
    $.session.set("noofusers", response.noofusers);
    sessionStorage.setItem("licencetype", response.licencetype);
    sessionStorage.setItem("__lock", "1");
  }
}

async function onValidatetenantByNameFailure(res) { }

async function linkLIMSLogin(orderdetails) {
  let ELNurl = window.appUrl.ELN;

  let userObject = {
    username: orderdetails.username,
    password: orderdetails.password,
  };

  ServicecallsMAIN(
    "" + ELNurl + "/Login/LinkLogin",
    userObject,
    onLinkLoginSuccess.bind(this),
    onValidatetenantByNameFailure.bind(this)
  );
}

async function onLinkLoginSuccess(res) {
  let ELNurl = window.appUrl.ELN;
  let response = await formatdata(res);
  if (response !== undefined && response !== null) {
    $.session.set("User", response.usercode);
    $.session.set("Username", response.username);
    $.session.set("Usersite", response.lssitemaster.sitecode);
    $.session.set("Usersitename", response.lssitemaster.sitename);
    // $.session.set("usergroupname", response.lsusergroup.usergroupname);
    $.session.set(
      "usergroupname",
      response.multiusergroupcode[0].lsusergroup.usergroupname
    );

    $.session.set("ServerDateFormat", response.dformat);

    let passobject = {
      username: response.username,
      lssitemaster: response.lssitemaster,
    };

    Servicecalls(
      "" + ELNurl + "/Login/limsloginusertokengenarate",
      passobject,
      (response) => {
        let token = "Bearer " + response.token;
        $.session.set("Token", token);
      },
      (response) => { }
    );
  }
}

function capitalizeFirstLetter(stringvalue) {
  return stringvalue.charAt(0).toUpperCase() + stringvalue.slice(1);
}

function isNumericvalue(value) {
  let decimal = getDecimalSeparator();
  const regexpint = /^[0-9\b]+$/;

  if (value.length === 1 && value === decimal) {
    return false;
  } else if (value.length > 1 && value.split(decimal).length > 2) {
    return false;
  } else if (
    !regexpint.test(value) &&
    value.charAt(value.length - 1) === decimal
  ) {
    return true;
  } else if (!regexpint.test(value.replace(decimal, ""))) {
    return false;
  }

  return true;
}

function getDecimalSeparator() {
  let locale = localStorage.getItem("ElnLang");
  const numberWithDecimalSeparator = 1.1;
  return Intl.NumberFormat(locale)
    .formatToParts(numberWithDecimalSeparator)
    .find((part) => part.type === "decimal").value;
}

function replacedecimalwithdot(value) {
  let decimal = getDecimalSeparator();
  return value.replace(decimal, ".");
}

function replacedotwithdecimal(value) {
  let decimal = getDecimalSeparator();
  return value.replace(".", decimal);
}

const _MS_PER_DAY = 1000 * 60 * 60 * 24;

// a and b are javascript Date objects
function dateDiffInDays(a, b) {
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

function setDateAsuserDefined(dateGet, dateformat) {
  let date;
  let dformat = dateformat;
  let dateValue;

  if (dateGet !== null && dateGet.toString() === "Invalid Date") {
    dateValue = new Date();
  } else {
    dateValue = new Date(dateGet);
  }

  const formatterMonth = new Intl.DateTimeFormat("en", { month: "short" });
  const formatterDay = new Intl.DateTimeFormat("en", { weekday: "short" });
  let montname;
  let dayname;

  try {
    montname = formatterMonth.format(new Date(dateValue));
    dayname = formatterDay.format(new Date(dateValue));
  } catch { }

  let getHours = dateValue.getHours() + "";
  let getMinutes = dateValue.getMinutes() + "";
  let getSeconds = dateValue.getSeconds() + "";

  let day = dateValue.getDate() + "";
  let year = dateValue.getFullYear();
  let lastTwoDigits = year % 100;
  let shortyear = lastTwoDigits.toString().padStart(2, '0');
  let monthAsNum = dateValue.getMonth() + 1 + "";

  // if (monthAsNum.trim().length === 1) {
  //   if (Number(monthAsNum.trim()) !== 9) {
  //     monthAsNum = "0" + (Number(monthAsNum.trim()) + 1);
  //     monthAsNum = monthAsNum.trim();
  //   } else {
  //     monthAsNum = Number(monthAsNum.trim()) + 1;
  //   }
  // }

  if (monthAsNum.trim().length === 1) {
    monthAsNum = "0" + monthAsNum.trim();
  }

  if (day.trim().length === 1) {
    day = "0" + Number(day.trim());
    day = day.trim();
  }
  if (getHours.trim().length === 1) {
    getHours = "0" + Number(getHours.trim());
    getHours = getHours.trim();
  }
  if (getMinutes.trim().length === 1) {
    getMinutes = "0" + Number(getMinutes.trim());
    getMinutes = getMinutes.trim();
  }
  if (getSeconds.trim().length === 1) {
    getSeconds = "0" + Number(getSeconds.trim());
    getSeconds = getSeconds.trim();
  }

  // let time = getHours +" :" + getMinutes + getSeconds
  date = dayname + " " + montname + " " + day + " " + year;

  if (dformat === "Mon-DD-YYYY HH:mm:ss") {
    //(Feb 17, 2009)
    date = montname + "-" + day + "-" + year;
  } else if (dformat === "Yr, Month D HH:mm:ss") {
    // 2009, February 17
    date = year + ", " + montname + " " + day;
  } else if (dformat === "D Month, Yr HH:mm:ss") {
    // 17 February, 2009
    date = day + " " + montname + ", " + year;
  } else if (dformat === "Month D, Yr HH:mm:ss") {
    // February 17, 2009
    date = montname + " " + day + ", " + year;
  } else if (dformat === "MM/DD/YY HH:mm:ss") {
    // 02 / 17 / 2009
    date = monthAsNum + "/" + day + "/" + year;
  } else if (dformat === "YYYY-MM-DD HH:mm:ss") {
    // 2022-01-28
    date = year + "-" + monthAsNum + "-" + day;
  } else if (dformat === "YY/MM/DD HH:mm:ss") {
    date = year + "/" + monthAsNum + "/" + day;
  } else if (dformat === "dd / MM / yyyy HH:mm:ss") {
    date = day + "/" + monthAsNum + "/" + year;
  } else if (dformat === "dd-MM-yy HH:mm:ss") {
    date = day + "-" + monthAsNum + "-" + shortyear;
  } else if (dformat === "dd-MM-yy") {
    return (date = day + "-" + monthAsNum + "-" + shortyear);
  } else if (dformat === "dd-MM-yy HH:mm:ss") {
    date = day + "-" + monthAsNum + "-" + year; // + " " + getHours + ":" + getMinutes;
  } else if (dformat === "dd-MM-yyyy HH:mm:ss") {
    date = day + "-" + monthAsNum + "-" + year;
    //  +
    // " " +
    // getHours +
    // ":" +
    // getMinutes +
    // ":" +
    // getSeconds;
  } else if (dformat === "yyyy. M. d HH:mm:ss") {
    date = year + "." + monthAsNum + "." + day;
  } else if (dformat === "UTC Format") {
    // let ampm = getHours >= 12 ? 'pm' : 'am';
    // let temp = " ";
    // date = day + "-" + monthAsNum + "-" + year + temp + getHours + ":" + getMinutes + ":" + getSeconds + temp + ampm + temp + "UTC";
    const dateutc = dateValue;
    // date =dateValue.toUTCString();
    //  Fri, 30 Oct 2020 11:13:4 GMT
    date =
      dayname +
      ", " +
      day +
      " " +
      montname +
      " " +
      year +
      " " +
      dateutc.getUTCHours() +
      ":" +
      dateutc.getUTCMinutes() +
      ":" +
      dateutc.getUTCSeconds() +
      " GMT";
    return date;
  } else if (dformat === "GMT Format") {
    date = dateValue.toGMTString();
    return date;
  }
  // else if (dformat === "ISO Format") {
  //   date = new Date(dateGet).toISOString();
  // }
  var timezone = "";
  // let userAgent = navigator.userAgent;
  // if (userAgent.match(/edg/i)) {
  timezone = new Date()
    .toLocaleTimeString("en-us", { timeZoneName: "short" })
    .split(" ")[2];
  if (timezone === undefined) {
    timezone = new Date()
      .toLocaleTimeString("en-us", { timeZoneName: "short" })
      .split(" ")[1];
  }

  // } else {
  //
  // }

  date =
    date +
    " " +
    getHours +
    ":" +
    getMinutes +
    ":" +
    getSeconds +
    " " +
    timezone;

  return date;
}

function setDateDetails(dateGet, dateformat, needdate, needtime) {
  let date;
  let dformat = dateformat;
  let dateValue;

  if (dateGet !== null && dateGet.toString() === "Invalid Date") {
    dateValue = new Date();
  } else {
    dateValue = new Date(dateGet);
  }

  const formatterMonth = new Intl.DateTimeFormat("en", { month: "short" });
  const formatterDay = new Intl.DateTimeFormat("en", { weekday: "short" });
  let montname;
  let dayname;

  try {
    montname = formatterMonth.format(new Date(dateValue));
    dayname = formatterDay.format(new Date(dateValue));
  } catch { }

  let getHours = dateValue.getHours() + "";
  let getMinutes = dateValue.getMinutes() + "";
  let getSeconds = dateValue.getSeconds() + "";

  let day = dateValue.getDate() + "";
  let year = dateValue.getFullYear();
  let monthAsNum = dateValue.getMonth() + 1 + "";

  if (monthAsNum.trim().length === 1) {
    monthAsNum = "0" + monthAsNum.trim();
  }

  if (day.trim().length === 1) {
    day = "0" + Number(day.trim());
    day = day.trim();
  }
  if (getHours.trim().length === 1) {
    getHours = "0" + Number(getHours.trim());
    getHours = getHours.trim();
  }
  if (getMinutes.trim().length === 1) {
    getMinutes = "0" + Number(getMinutes.trim());
    getMinutes = getMinutes.trim();
  }
  if (getSeconds.trim().length === 1) {
    getSeconds = "0" + Number(getSeconds.trim());
    getSeconds = getSeconds.trim();
  }

  // let time = getHours +" :" + getMinutes + getSeconds
  date = dayname + " " + montname + " " + day + " " + year;

  if (dformat === "Mon-DD-YYYY HH:mm:ss") {
    //(Feb 17, 2009)
    date = montname + "-" + day + "-" + year;
  } else if (dformat === "Yr, Month D HH:mm:ss") {
    // 2009, February 17
    date = year + ", " + montname + " " + day;
  } else if (dformat === "D Month, Yr HH:mm:ss") {
    // 17 February, 2009
    date = day + " " + montname + ", " + year;
  } else if (dformat === "Month D, Yr HH:mm:ss") {
    // February 17, 2009
    date = montname + " " + day + ", " + year;
  } else if (dformat === "MM/DD/YY HH:mm:ss") {
    // 02 / 17 / 2009
    date = monthAsNum + "/" + day + "/" + year;
  } else if (dformat === "YYYY-MM-DD HH:mm:ss") {
    // 2022-01-28
    date = year + "-" + monthAsNum + "-" + day;
  } else if (dformat === "YY/MM/DD HH:mm:ss") {
    date = year + "/" + monthAsNum + "/" + day;
  } else if (dformat === "dd / MM / yyyy HH:mm:ss") {
    date = day + "/" + monthAsNum + "/" + year;
  } else if (dformat === "dd-MM-yy HH:mm:ss") {
    date = day + "-" + monthAsNum + "-" + year;
  } else if (dformat === "dd-MM-yy") {
    return (date = day + "-" + monthAsNum + "-" + year);
  } else if (dformat === "dd-MM-yy HH:mm:ss") {
    date = day + "-" + monthAsNum + "-" + year; // + " " + getHours + ":" + getMinutes;
  } else if (dformat === "dd-MM-yyyy HH:mm:ss") {
    date = day + "-" + monthAsNum + "-" + year;
    //  +
    // " " +
    // getHours +
    // ":" +
    // getMinutes +
    // ":" +
    // getSeconds;
  } else if (dformat === "yyyy. M. d HH:mm:ss") {
    date = year + "." + monthAsNum + "." + day;
  } else if (dformat === "UTC Format") {
    // let ampm = getHours >= 12 ? 'pm' : 'am';
    // let temp = " ";
    // date = day + "-" + monthAsNum + "-" + year + temp + getHours + ":" + getMinutes + ":" + getSeconds + temp + ampm + temp + "UTC";
    const dateutc = dateValue;
    // date =dateValue.toUTCString();
    //  Fri, 30 Oct 2020 11:13:4 GMT
    date =
      dayname +
      ", " +
      day +
      " " +
      montname +
      " " +
      year +
      " " +
      dateutc.getUTCHours() +
      ":" +
      dateutc.getUTCMinutes() +
      ":" +
      dateutc.getUTCSeconds() +
      " GMT";
    return date;
  } else if (dformat === "GMT Format") {
    date = dateValue.toGMTString();
    return date;
  }
  // else if (dformat === "ISO Format") {
  //   date = new Date(dateGet).toISOString();
  // }
  var timezone = "";
  // let userAgent = navigator.userAgent;
  // if (userAgent.match(/edg/i)) {
  timezone = new Date()
    .toLocaleTimeString("en-us", { timeZoneName: "short" })
    .split(" ")[2];
  if (timezone === undefined) {
    timezone = new Date()
      .toLocaleTimeString("en-us", { timeZoneName: "short" })
      .split(" ")[1];
  }

  // } else {
  //
  // }

  let datevalue = "";

  if (needdate) {
    datevalue += date;
  }

  if (needtime) {
    datevalue += " " +
      getHours +
      ":" +
      getMinutes +
      ":" +
      getSeconds +
      " " +
      timezone;
  }

  return datevalue;
}

function AuditDatetimeDefined(dateGet, dateformat) {
  let date;
  let dformat = dateformat;

  if (dateGet !== null && dateGet.toString() === "Invalid Date") {
    date = new Date(new Date());
  } else {
    date = new Date(dateGet);
  }

  const formatterMonth = new Intl.DateTimeFormat("en", { month: "short" });
  const formatterDay = new Intl.DateTimeFormat("en", { weekday: "short" });
  const montname = formatterMonth.format(new Date(date));
  const dayname = formatterDay.format(new Date(date));

  const getHours = date.getHours();
  const getMinutes = date.getMinutes();
  const getSeconds = date.getSeconds();

  let day = date.getDate();
  let year = date.getFullYear();

  day = convertdoubledigitdate(day, undefined);
  let month = new Date(dateGet).getMonth() + 1;
  month = convertdoubledigitdate(undefined, month);

  let time = getHours + ":" + getMinutes + ":" + getSeconds;
  date = dayname + " " + montname + " " + day + " " + year;

  if (dformat === "Mon-DD-YYYY HH:mm:ss") {
    //(Feb 17, 2009)
    date = montname + "-" + day + "-" + year + " " + time;
  } else if (dformat === "Yr, Month D HH:mm:ss") {
    // 2009, February 17
    date = year + ", " + montname + " " + day + " " + time;
  } else if (dformat === "D Month, Yr HH:mm:ss") {
    // 17 February, 2009
    date = day + " " + montname + ", " + year + " " + time;
  } else if (dformat === "Month D, Yr HH:mm:ss") {
    // February 17, 2009
    date = montname + " " + day + ", " + year + " " + time;
  } else if (dformat === "MM/DD/YY HH:mm:ss") {
    // 02 / 17 / 2009
    date =
      new Date(dateGet).getMonth() + 1 + "/" + day + "/" + year + " " + time;
  } else if (dformat === "YY/MM/DD HH:mm:ss") {
    date =
      // year + "/" + (new Date(dateGet).getMonth() + 1) + "/" + day + " " + time;
      year + "/" + month + "/" + day + " " + time;
  } else if (dformat === "dd / MM / yyyy HH:mm:ss") {
    date =
      // day + "/" + (new Date(dateGet).getMonth() + 1) + "/" + year + " " + time;
      day + "/" + month + "/" + year + " " + time;
  } else if (dformat === "dd-MM-yy HH:mm:ss") {
    date =
      // day + "-" + (new Date(dateGet).getMonth() + 1) + "-" + year + " " + time;
      day + "-" + month + "-" + year + " " + time;
  } else if (dformat === "dd-MM-yy HH:mm:ss") {
    date =
      day +
      "-" +
      // (new Date(dateGet).getMonth() + 1) +
      month +
      "-" +
      year +
      " " +
      getHours +
      ":" +
      getMinutes +
      ":" +
      getSeconds;
  } else if (dformat === "dd-MM-yyyy HH:mm:ss") {
    date =
      day +
      "-" +
      // (new Date(dateGet).getMonth() + 1) +
      month +
      "-" +
      year +
      " " +
      getHours +
      ":" +
      getMinutes +
      ":" +
      getSeconds;
  } else if (dformat === "yyyy. M. d HH:mm:ss") {
    date =
      // year + "." + (new Date(dateGet).getMonth() + 1) + "." + day + " " + time;
      year + "." + month + "." + day + " " + time;
  } else if (dformat === "UTC Format") {
    // date = new Date(dateGet).toUTCString();
    const dateutc = dateGet;
    // date =dateValue.toUTCString();
    //  Fri, 30 Oct 2020 11:13:4 GMT
    date =
      dayname +
      ", " +
      day +
      " " +
      montname +
      " " +
      year +
      " " +
      dateutc.getUTCHours() +
      ":" +
      dateutc.getUTCMinutes() +
      ":" +
      dateutc.getUTCSeconds() +
      " GMT";
    return date;
  } else if (dformat === "GMT Format") {
    date = new Date(dateGet).toGMTString();
  } else if (dformat === "MM-dd-yyyy hh:mm:ss") {
    date =
      // new Date(dateGet).getMonth() +
      // 1 +
      month +
      "-" +
      day +
      "-" +
      year +
      " " +
      getHours +
      ":" +
      getMinutes +
      ":" +
      getSeconds;
  }
  // else if (dformat === "ISO Format") {
  //   date = new Date(dateGet).toISOString();
  // }
  else if (dformat === "m/d/yyyy") {
    date = (new Date(dateGet).getMonth() + 1) + "/" + new Date(dateGet).getDate() + "/" + new Date(dateGet).getFullYear();
  }

  return date;
}

function setDateTimeAsuserDefined(dateGet, dateformat) {
  let date;
  let dformat = dateformat;

  if (dateGet !== null && dateGet.toString() === "Invalid Date") {
    date = new Date(new Date());
  } else {
    date = new Date(dateGet);
  }

  const formatterMonth = new Intl.DateTimeFormat("en", { month: "short" });
  const formatterDay = new Intl.DateTimeFormat("en", { weekday: "short" });
  const montname = formatterMonth.format(new Date(date));
  const dayname = formatterDay.format(new Date(date));

  let day = date.getDate();
  let year = date.getFullYear();

  let hour = addZero(date.getHours());
  let minute = addZero(date.getMinutes());
  let secound = addZero(date.getSeconds());

  date = dayname + " " + montname + " " + day + " " + year;

  if (dformat === "Mon-DD-YYYY HH:mm:ss") {
    //(Feb 17, 2009)
    date =
      montname +
      "-" +
      day +
      "-" +
      year +
      " " +
      hour +
      ":" +
      minute +
      ":" +
      secound;
  } else if (dformat === "Yr, Month D HH:mm:ss") {
    // 2009, February 17
    date =
      year +
      ", " +
      montname +
      " " +
      day +
      " " +
      hour +
      ":" +
      minute +
      ":" +
      secound;
  } else if (dformat === "D Month, Yr HH:mm:ss") {
    // 17 February, 2009
    date =
      day +
      " " +
      montname +
      ", " +
      year +
      " " +
      hour +
      ":" +
      minute +
      ":" +
      secound;
  } else if (dformat === "Month D, Yr HH:mm:ss") {
    // February 17, 2009
    date =
      montname +
      " " +
      day +
      ", " +
      year +
      " " +
      hour +
      ":" +
      minute +
      ":" +
      secound;
  } else if (dformat === "MM/DD/YY HH:mm:ss") {
    // 02 / 17 / 2009
    date =
      new Date(dateGet).getMonth() +
      1 +
      "/" +
      day +
      "/" +
      year +
      " " +
      hour +
      ":" +
      minute +
      ":" +
      secound;
  } else if (dformat === "YY/MM/DD HH:mm:ss") {
    date =
      year +
      "/" +
      (new Date(dateGet).getMonth() + 1) +
      "/" +
      day +
      " " +
      hour +
      ":" +
      minute +
      ":" +
      secound;
  } else if (dformat === "dd / MM / yyyy HH:mm:ss") {
    date =
      day +
      "/" +
      (new Date(dateGet).getMonth() + 1) +
      "/" +
      year +
      " " +
      hour +
      ":" +
      minute +
      ":" +
      secound;
  }
  return date;
}

function addZero(i) {
  if (i < 10) {
    i = "0" + i;
  }
  return i;
}

async function Servicecalls(
  url,
  data,
  success,
  failure,
  auditurl,
  auditdata,
  auditsuccess,
  auditfailure
) {
  if (data) {
    axios
      .post(url, await gzip(JSON.stringify(data)), {
        headers: {
          Authorization: $.session.get("Token"),
          "X-TenantID": $.session.get("tenantid"),
          Accept: "application/json",
          "Content-Type": "application/json",
          "Content-Encoding": "gzip",
        },
        responseType: "arraybuffer",
      })
      .then((response) => {
        if (
          auditurl !== undefined &&
          auditdata !== undefined &&
          auditsuccess !== undefined &&
          auditfailure
        ) {
          Servicecalls(auditurl, auditdata, auditsuccess, auditfailure);
        }
        const compressedData = new Uint8Array(response.data);
        const decompressedData = pako.inflate(compressedData, { to: "string" });
        success(formatdata(decompressedData && JSON.parse(decompressedData)), data);
      })
      .catch((error) => {
        failure(error);
      });
  }
}

function Servicecallsforfiles(
  url,
  data,
  success,
  failure,
  auditurl,
  auditdata,
  auditsuccess,
  auditfailure
) {
  axios
    .post(url, data, {
      headers: {
        Authorization: $.session.get("Token"),
        "X-TenantID": $.session.get("tenantid"),
        Accept: "application/json",
      },
      responseType: "arraybuffer",
    })
    .then((response) => {
      if (
        auditurl !== undefined &&
        auditdata !== undefined &&
        auditsuccess !== undefined &&
        auditfailure
      ) {
        Servicecalls(auditurl, auditdata, auditsuccess, auditfailure);
      }
      const compressedData = new Uint8Array(response.data);
      const decompressedData = pako.inflate(compressedData, { to: "string" });
      success(formatdata(JSON.parse(decompressedData)), data);
    })
    .catch((error) => {
      failure(error);
    });
}

function ServicecallsforSDMS(
  url,
  data,
  success,
  failure,
  auditurl,
  auditdata,
  auditsuccess,
  auditfailure
) {
  axios
    .post(url, data, {
      headers: {
        Authorization: $.session.get("Token"),
        "X-TenantID": $.session.get("tenantid"),
        Accept: "application/json",
      },
    })
    .then((response) => {
      if (
        auditurl !== undefined &&
        auditdata !== undefined &&
        auditsuccess !== undefined &&
        auditfailure
      ) {
        Servicecalls(auditurl, auditdata, auditsuccess, auditfailure);
      }
      success(formatdata(response.data));
    })
    .catch((error) => {
      failure(error);
    });
}

function Servicecallsforwithougzip(
  url,
  data,
  success,
  failure,
  auditurl,
  auditdata,
  auditsuccess,
  auditfailure
) {
  axios
    .post(url, data, {
      headers: {
        Authorization: $.session.get("Token"),
        "X-TenantID": $.session.get("tenantid"),
        Accept: "application/json",
      },
      // responseType: 'arraybuffer'
    })
    .then((response) => {
      // const compressedData = new Uint8Array(response.data);
      // const decompressedData = pako.inflate(compressedData, { to: 'string' });
      // success(formatdata(JSON.parse(decompressedData)), data);

      if (
        auditurl !== undefined &&
        auditdata !== undefined &&
        auditsuccess !== undefined &&
        auditfailure
      ) {
        Servicecalls(auditurl, auditdata, auditsuccess, auditfailure);
      }
      success(formatdata(response.data));
    })
    .catch((error) => {
      failure(error);
    });
}

async function ServicecallsMAIN(url, data, success, failure) {
  axios
    .post(url, await gzip(JSON.stringify(data)), {
      headers: {
        Authorization: $.session.get("Token"),
        "X-TenantID": "MAIN",
        Accept: "application/json",
        "Content-Type": "application/json",
        "Content-Encoding": "gzip",
      },
      responseType: "arraybuffer",
    })
    .then((response) => {
      const compressedData = new Uint8Array(response.data);
      const decompressedData = pako.inflate(compressedData, { to: "string" });
      success(formatdata(JSON.parse(decompressedData)));
    })
    .catch((error) => {
      failure(error);
    });
}
async function ServicecallsToken(url, data, success, failure) {
  axios
    .post(url, await gzip(JSON.stringify(data)), {
      headers: {
        // Authorization: $.session.get("Token"),
        "X-TenantID": "MAIN",
        Accept: "application/json",
        "Content-Type": "application/json",
        "Content-Encoding": "gzip",
      },
      responseType: "arraybuffer",
    })
    .then((response) => {
      const compressedData = new Uint8Array(response.data);
      const decompressedData = pako.inflate(compressedData, { to: "string" });
      success(formatdata(JSON.parse(decompressedData)));
    })
    .catch((error) => {
      failure(error);
    });
}

function Serviceuserworkflowdetails(url, data) {
  if (data?.usergroupcode !== undefined && data?.usergroupcode !== null) {
    Servicecalls(url, data, (response) => {
      $.session.set("Userworkflows", JSON.stringify(response?.Sheet_Order));
      sessionStorage.setItem("Protocol_Userworkflows", JSON.stringify(response?.Protocol_Order))
    }, (response) => { });
  }
}

function Serviceprojectteam(url, data, returnstatefunction) {
  // let teams = false;
  // let returnservice = undefined;
  Servicecalls(url, data, returnstatefunction,
    // (response) => {
    //   returnstatefunction(response)
    //   // return teams = response;
    //   // returnservice = true
    // },
    (response) => {
      // returnservice = false
    }
  );
}

function Serviceforuserrights(url, data) {
  Servicecalls(url, data,
    (response) => {
      response.User = sessionStorage.User;
      store.dispatch(updatecontrolrights(response));
    }, (response) => { });
}

function Serviceforauditconfig(url, data) {
  Servicecalls(url, data,
    (response) => {
      console.log(response);

      // if(response.AuditConfig !== undefined){
      //   store.dispatch(addauditoption(response.AuditConfig)); 
      // }else{
      //   store.dispatch(addauditoption(response)); 
      // }

      store.dispatch(addauditoption(response));

      const state = store.getState();
      console.log("State after dispatch:", state.audit.auditoption);
    },
    (response) => { });
}

function Serviceforusersettings(url, data) {
  Servicecalls(
    url,
    data,
    (response) => {
      store.getState().Loggeduser.dformat =
        response !== undefined && response !== null
          ? response.dformat
          : "dd/MM/yyyy";

      $.session.set(
        "userDefinedDate",
        response !== undefined && response !== null
          ? response.dformat
          : "dd/MM/yyyy"
      );

      $.session.set(
        "ServerDateFormat",
        response !== undefined && response !== null
          ? response.dformat
          : "dd/MM/yyyy"
      );
    },
    (response) => { }
  );
}

async function Serviceforserverdateformat(url, data) {
  Servicecalls(
    url,
    data,
    (response) => {
      $.session.set("ServerDateFormat", response.serverDateFormat);
    },
    (response) => { }
  );
}

async function ServiceforMainFormUserLicense(url, data) {
  Servicecalls(
    url,
    data,
    (response) => {
      $.session.set("isLicensed", response);
    },
    (response) => { }
  );
}

async function Serviceprojectdetails(url, data) {
  Servicecalls(
    url,
    data,
    (response) => {
      $.session.set("Userprojects", JSON.stringify(uniq(response.project)));
      $.session.set("Userteam", JSON.stringify(response.team));
      $.session.set("teamusercode", JSON.stringify(response.teamuser));
    },
    (response) => { }
  );
}

async function Servicesequencedetails(url) {
  Servicecalls(
    url,
    {},
    (response) => {

      localStorage.setItem("elnsequence", JSON.stringify(response));
    },
    (response) => { }
  );
}

function Getteamfromsession() {
  let teamvalue = null;
  let sessionvalue = $.session.get("Userteam");

  if (
    sessionvalue !== undefined &&
    sessionvalue !== null &&
    sessionvalue !== ""
  ) {
    let teamcodes = JSON.parse(sessionvalue);

    if (teamcodes !== undefined && teamcodes !== null && teamcodes.length > 0) {
      teamvalue = [];
      for (let index = 0; index < teamcodes.length; index++) {
        teamvalue.push({ teamcode: teamcodes[index] });
      }
    }
  }

  return teamvalue;
}

function Getteamusersfromsession() {
  let teamuservalue = null;
  let sessionvalue = $.session.get("teamusercode");

  if (
    sessionvalue !== undefined &&
    sessionvalue !== "undefined" &&
    sessionvalue !== null &&
    sessionvalue !== ""
  ) {
    let teamusercodes = JSON.parse(sessionvalue);

    if (
      teamusercodes !== undefined &&
      teamusercodes !== null &&
      teamusercodes.length > 0
    ) {
      teamuservalue = [];
      if (teamusercodes.length > 0) {
        teamusercodes.map((items) => {
          teamuservalue.push({ usercode: items });
          return items;
        });
      }
      // for (let index = 0; index < teamusercodes.length; index++) {
      //   teamuservalue.push({ usercode: teamusercodes[index] });
      // }
    }
  }

  return teamuservalue;
}

function Getuserprojectfromsession() {
  let projectvalue = null;
  let sessionvalue = $.session.get("Userprojects");

  if (
    sessionvalue !== undefined &&
    sessionvalue !== null &&
    sessionvalue !== ""
  ) {
    let projectcodes = JSON.parse(sessionvalue);

    if (
      projectcodes !== undefined &&
      projectcodes !== null &&
      projectcodes.length > 0
    ) {
      projectvalue = [];
      for (let index = 0; index < projectcodes.length; index++) {
        projectvalue.push({ projectcode: projectcodes[index] });
      }
    }
  }

  return projectvalue;
}


async function GetSheetorders(details) {
  let ELNurl = window.appUrl.ELN;
  let response = await new Promise((resolve, reject) => {
    let passObjDet = {
      batchcode: details.ordercode,
      objLoggeduser: store.getState().Loggeduser,
      ismultitenant: isMultitenant,
      lstproject: Getuserprojectfromsession(),
      lstworkflow: Getuserworkflowfromsession(),
      openfor: "screen"
    };
    Servicecalls(
      "" + ELNurl + "/Instrument/Getsingleorder",
      passObjDet,
      (responce) => {
        if (responce !== undefined) {
          responce.createdby = responce?.lsuserMaster;
          resolve(responce);
        } else {
          resolve(null);
        }
      },
      (error) => {
        reject(error);
      }
    );
  });
  return response;
}


function Getuserworkflowfromsession() {
  let workflowvalue = null;
  let sessionvalue = $.session.get("Userworkflows");

  if (
    sessionvalue !== undefined &&
    sessionvalue !== null &&
    sessionvalue !== ""
  ) {
    let workflowcodes = JSON.parse(sessionvalue);

    if (
      workflowcodes !== undefined &&
      workflowcodes !== null &&
      workflowcodes.length > 0
    ) {
      workflowvalue = [];
      for (let index = 0; index < workflowcodes.length; index++) {
        workflowvalue.push({ workflowcode: workflowcodes[index] });
      }
    }
  }

  return workflowvalue;
}
function Getprotocoluserworkflowfromsession() {
  let workflowvalue = null;
  let sessionvalue = $.session.get("Protocol_Userworkflows");

  if (
    sessionvalue !== undefined &&
    sessionvalue !== null &&
    sessionvalue !== ""
  ) {
    let workflowcodes = JSON.parse(sessionvalue);

    if (
      workflowcodes !== undefined &&
      workflowcodes !== null &&
      workflowcodes.length > 0
    ) {
      workflowvalue = [];
      for (let index = 0; index < workflowcodes.length; index++) {
        workflowvalue.push({ workflowcode: workflowcodes[index] });
      }
    }
  }

  return workflowvalue;
}
//subscription plan
function valiadateTenantPackage() {
  let packagetype = $.session.get("packagetype");
  //Free
  if (packagetype === "1") return "1";
  //Standard
  if (packagetype === "2") return "2";
  //Premium
  if (packagetype === "3") return "3";

  return "1";
}

function formatprotocolsteps(stepinfo) {
  let record = [];
  const doc = ReactHtmlParser(stepinfo);

  for (var i = 0; i < doc.length; i++) {
    if (
      doc[i].props !== undefined &&
      doc[i].props.children !== undefined &&
      doc[i].props.children.length > 0
    ) {
      for (let j = 0; j < doc[i].props.children.length; j++) {
        if (
          doc[i].props.children[j] !== undefined &&
          doc[i].props.children[j].type !== undefined
        ) {
          if (doc[i].props.children[j].type === "table") {
            if (
              doc[i].props.style !== undefined &&
              doc[i].props.style.width !== undefined
            ) {
              let width = doc[i].props.style.width.substring(
                0,
                doc[i].props.style.width.length - 2
              );
              let modifiedwidth = parseInt(width) * 100;
              doc[i].props.style.width = modifiedwidth + "px";
            }
          }
        }
      }
    }

    let container = <div key={"ckpreviewkey_" + i}>{doc[i]}</div>;
    record.push(container);
  }

  return record;
}

//help
async function onHelpClick(link, path) {
  let dataLink = link.toLowerCase();
  let ELNurl = window.appUrl.ELN;
  ServicecallsToken(
    "" + ELNurl + "/helpdocument/getnodeonpage",
    { dataLink },
    onHelpClickSuccess.bind(path, this),
    onHelpClickFailure.bind(this)
  );
}

async function onHelpClickSuccess(path, res) {
  let node = res;
  if (node !== undefined && node !== null) {
    path = "/help#" + node.nodecode;
  } else {
    path = "/help";
  }
}
async function onHelpClickFailure(res) { }

function uniq(valArray) {
  var prims = { boolean: {}, number: {}, string: {} },
    objs = [];

  return valArray.filter(function (item) {
    var type = typeof item;
    if (type in prims)
      return prims[type].hasOwnProperty(item)
        ? false
        : (prims[type][item] = true);
    else return objs.indexOf(item) >= 0 ? false : objs.push(item);
  });
}

function decryptdata(object) {
  var key = CryptoJS.enc.Latin1.parse("1234567812345678");
  var iv = CryptoJS.enc.Latin1.parse("1234567812345678");

  var decrypted = CryptoJS.AES.decrypt(object.data.toString(), key, {
    iv: iv,
    padding: CryptoJS.pad.ZeroPadding,
  });
  var decryptedstring = decrypted.toString(CryptoJS.enc.Utf8);
  let lastoccuranceofbrace = decryptedstring.lastIndexOf("}");
  let lastoccuranceofarray = decryptedstring.lastIndexOf("]");
  let lastindex = decryptedstring.length;
  if (
    lastoccuranceofbrace !== undefined &&
    lastoccuranceofbrace > -1 &&
    lastoccuranceofarray !== undefined &&
    lastoccuranceofarray > -1
  ) {
    if (lastoccuranceofbrace > lastoccuranceofarray) {
      lastindex = lastoccuranceofbrace + 1;
    } else {
      lastindex = lastoccuranceofarray + 1;
    }
  } else if (lastoccuranceofbrace !== undefined && lastoccuranceofbrace > -1) {
    lastindex = lastoccuranceofbrace + 1;
  } else if (lastoccuranceofarray !== undefined && lastoccuranceofarray > -1) {
    lastindex = lastoccuranceofarray + 1;
  }

  var formattedstring = decryptedstring.substring(0, lastindex);
  return JSON.parse(formattedstring);
}

function encryptdata(data) {
  var key = CryptoJS.enc.Latin1.parse("1234567812345678");
  var iv = CryptoJS.enc.Latin1.parse("1234567812345678");
  var encrypted = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding,
  });

  // var decrypted = CryptoJS.AES.decrypt(encrypted, key, { iv: iv, padding: CryptoJS.pad.ZeroPadding });

  return { data: encrypted.toString() };
}

function formatdata(object) {
  try {
    // let data = object.data;
    // let compressData = object.data;
    // compressData = compressData.split('').map(function (e) {
    //   return e.charCodeAt(0);
    // });
    // let binData = new Uint8Array(compressData);
    // let datauncom = inflate(binData);
    // return String.fromCharCode.apply(null, new Uint16Array(datauncom));

    // var key = CryptoJS.enc.Latin1.parse('1234567812345678');
    // var iv = CryptoJS.enc.Latin1.parse('1234567812345678');

    // var decrypted = CryptoJS.AES.decrypt(object.toString(), key, { iv: iv, padding: CryptoJS.pad.ZeroPadding });
    // var decryptedstring = decrypted.toString(CryptoJS.enc.Utf8);
    // let lastoccuranceofbrace = decryptedstring.lastIndexOf('}');
    // let lastoccuranceofarray = decryptedstring.lastIndexOf(']');
    // let lastindex = decryptedstring.length;
    // if (lastoccuranceofbrace !== undefined && lastoccuranceofbrace > -1 &&
    //   lastoccuranceofarray !== undefined && lastoccuranceofarray > -1) {
    //   if (lastoccuranceofbrace > lastoccuranceofarray) {
    //     lastindex = lastoccuranceofbrace + 1;
    //   }
    //   else {
    //     lastindex = lastoccuranceofarray + 1;
    //   }
    // }
    // else if (lastoccuranceofbrace !== undefined && lastoccuranceofbrace > -1) {
    //   lastindex = lastoccuranceofbrace + 1;
    // }
    // else if (lastoccuranceofarray !== undefined && lastoccuranceofarray > -1) {
    //   lastindex = lastoccuranceofarray + 1;
    // }

    // var formattedstring = decryptedstring.substring(0, lastindex);
    return object;
  } catch (err) { }
  // return object;
}

function rangearray(start, end) {
  return Array(end - start + 1)
    .fill()
    .map((_, idx) => start + idx);
}

function validatesheetforversioning(originalsheet, range, data) {
  let doversion = false;
  let topLeftrow = range._ref.topLeft.row;
  let bottomRightrow = range._ref.bottomRight.row;
  let topLeftcol = range._ref.topLeft.col;
  let bottomRightcol = range._ref.bottomRight.col;
  let sheetname = range._sheet._sheetName;

  let originalsheets = originalsheet.sheets;

  var row = rangearray(topLeftrow, bottomRightrow);
  var col = rangearray(topLeftcol, bottomRightcol);

  if (
    originalsheets !== undefined &&
    originalsheets !== null &&
    originalsheets.length > 0
  ) {
    let sheetindex = -1;

    sheetindex = originalsheets.findIndex((sheet) => sheet.name === sheetname);
    if (sheetindex > -1) {
      row.forEach((rcount) => {
        col.forEach((ccount) => {
          originalsheets[sheetindex].rows.map((obj) => {
            if (obj.index === rcount) {
              obj.cells.map((objcell) => {
                if (objcell.index === ccount) {
                  if (objcell.tag !== undefined) {
                    let tagvalue = JSON.parse(objcell.tag);
                    if (
                      tagvalue.fieldname !== undefined &&
                      objcell.value !== "[" + tagvalue.fieldname + "]" &&
                      objcell.value !== data
                    ) {
                      doversion = true;
                    } else if (
                      tagvalue.Chemical !== undefined &&
                      tagvalue.Chemical &&
                      objcell.value !== data
                    ) {
                      doversion = true;
                    }
                  } else if (objcell.value !== data) {
                    doversion = true;
                  }
                }
                return objcell;
              });
            }
            return obj;
          });
        });
      });
    } else {
      doversion = false;
    }
  }

  return doversion;
}

function restrictSheetEditonFields(originalsheetdata) {
  let originalsheet = originalsheetdata.sheets;

  if (
    originalsheet !== undefined &&
    originalsheet !== null &&
    originalsheet.length > 0
  ) {
    originalsheet.map((objsheet, index) => {
      if (objsheet.name.trim() !== "Lims Batch") {
        objsheet.rows.map((objrow, rowindex) => {
          objrow.cells.map((objcell, colindex) => {
            if (objcell.tag !== undefined && objcell.tag !== null) {
              let tag = JSON.parse(objcell.tag);
              if (tag !== undefined && tag !== null) {
                objcell.enable = true;
              }
            }
            return objcell;
          });
          return objrow;
        });
      }
      return objsheet;
    });
  }
  return originalsheetdata;
}

function checkChangesinSheet(originalsheetdata, versionedsheetdata) {
  let doVersion = false;

  if (
    originalsheetdata !== undefined &&
    versionedsheetdata !== undefined &&
    originalsheetdata.sheets !== undefined &&
    versionedsheetdata.sheets !== undefined
  ) {
    let originalsheet = originalsheetdata.sheets;
    let versionedsheet = versionedsheetdata.sheets;

    if (
      originalsheet !== undefined &&
      originalsheet !== null &&
      originalsheet.length > 0 &&
      versionedsheet !== undefined &&
      versionedsheet !== null &&
      versionedsheet.length > 0
    ) {
      versionedsheet?.filter((sheet) => sheet.name !== "Chart")?.map((objsheet, index) => {
        if (
          objsheet.rows !== undefined &&
          objsheet.rows.length > 0 &&
          objsheet.name.trim() !== "Lims Batch"
        ) {
          objsheet.rows.map((objrow, rowindex) => {
            if (objrow.cells !== undefined && objrow.cells.length > 0) {
              objrow.cells.map((objcell, colindex) => {
                let rowindexval = -1;

                if (
                  originalsheet[index] !== undefined &&
                  originalsheet[index].rows !== undefined
                ) {
                  rowindexval = originalsheet[index].rows.findIndex(
                    (row) => row.index === objrow.index
                  );
                }

                let colindexval = -1;
                if (
                  rowindexval > -1 &&
                  originalsheet[index].rows[rowindexval].cells !== undefined
                ) {
                  colindexval = originalsheet[index].rows[
                    rowindexval
                  ].cells.findIndex((col) => col.index === objcell.index);
                }

                if (colindexval !== -1) {
                  if (
                    originalsheet[index] !== undefined &&
                    originalsheet[index].rows[rowindexval] !== undefined &&
                    originalsheet[index].rows[rowindexval].cells[
                    colindexval
                    ] !== undefined
                  ) {
                    if (objcell.tag !== undefined) {
                      let tagvalue = JSON.parse(objcell.tag);

                      if (tagvalue !== undefined && tagvalue !== null) {
                        if (
                          tagvalue.FieldCode !== undefined &&
                          tagvalue.FieldCode !== null &&
                          tagvalue.FieldCode === "LINK" &&
                          tagvalue.Linktosheet !== undefined &&
                          tagvalue.Linktosheet !== null &&
                          tagvalue.Linktosheet === true
                        ) {
                          if (
                            originalsheet[index].rows[rowindexval].cells[colindexval].value !== undefined &&
                            originalsheet[index].rows[rowindexval].cells[colindexval].value.toString().trim() !== "" &&
                            originalsheet[index].rows[rowindexval].cells[colindexval].value !== objcell.value &&
                            originalsheet[index].rows[rowindexval].cells[colindexval].value !== "[" + tagvalue.fieldname + "]" &&
                            objcell.value !== undefined &&
                            typeof objcell.value !== "object"
                          ) {
                            doVersion = true;
                          }
                        } else if (
                          originalsheet[index].rows[rowindexval].cells[colindexval].value !== undefined &&
                          originalsheet[index].rows[rowindexval].cells[colindexval].value !== objcell.value &&
                          originalsheet[index].rows[rowindexval].cells[colindexval].value !== "[" + tagvalue.fieldname + "]" &&
                          objcell.value !== undefined &&
                          objcell.formula === undefined &&
                          typeof objcell.value !== "object"
                        ) {
                          doVersion = true;
                        }
                        //dont remove below code

                        // else if(originalsheet[index].rows[rowindexval].cells[colindexval].value !== undefined && objcell.value === undefined){
                        //   // after deleting new cell come here
                        //   if (
                        //     (originalsheet[index].rows[rowindexval].cells[colindexval].value !== undefined &&
                        //     originalsheet[index].rows[rowindexval].cells[colindexval].value !== tagvalue.value &&
                        //     originalsheet[index].rows[rowindexval].cells[colindexval].value !== "[" + tagvalue.fieldname + "]" &&
                        //     tagvalue.value !== undefined &&  objcell.formula === undefined && typeof objcell.value !== "object") === true
                        //   ) {
                        //     doVersion = true;
                        //   }
                        // }else if(objcell.value !== undefined && originalsheet[index].rows[rowindexval].cells[colindexval].value === undefined){
                        //   // making entry on deleted cell
                        //   let tagvalue1 = JSON.parse(originalsheet[index].rows[rowindexval].cells[colindexval].tag);
                        //   console.log(tagvalue1.value)
                        //   console.log(objcell.value)
                        //   if (
                        //     (tagvalue1 !== null && (tagvalue1.value !== objcell.value) &&
                        //     tagvalue1.value !== "[" + tagvalue1.fieldname + "]" &&
                        //     objcell.value !== undefined && objcell.formula === undefined &&
                        //     typeof objcell.value !== "object") === true
                        //   ) {
                        //     console.log(((tagvalue1.value !== objcell.value)  &&
                        //     tagvalue1.value !== "[" + tagvalue1.fieldname + "]" &&
                        //     objcell.value !== undefined && objcell.formula === undefined &&
                        //     typeof objcell.value !== "object") === true)
                        //     doVersion = true;
                        //   }
                        // }
                      }
                    } else if (
                      objcell.value !== undefined &&
                      originalsheet[index].rows[rowindexval] !== undefined &&
                      originalsheet[index].rows[rowindexval].cells[colindexval] !== undefined &&
                      originalsheet[index].rows[rowindexval].cells[colindexval].value !== undefined &&
                      objcell.value !== originalsheet[index].rows[rowindexval].cells[colindexval].value &&
                      typeof originalsheet[index].rows[rowindexval].cells[colindexval].value !== "object" &&
                      objcell.formula === undefined &&
                      typeof objcell.value !== "object"
                    ) {
                      doVersion = true;
                    }
                  } else if (
                    objcell.value !== undefined &&
                    objcell.formula === undefined &&
                    typeof objcell.value !== "object"
                  ) {
                    doVersion = true;
                  }
                }
                return objcell;
              });
            }
            return objrow;
          });
        }
        return objsheet;
      });
    }
  }
  return doVersion;
}

function checkChangesinSheetReact(originalsheetdata, versionedsheetdata, fields) {
  let doVersion = false;

  if (
    originalsheetdata !== undefined &&
    versionedsheetdata !== undefined &&
    originalsheetdata.sheets !== undefined &&
    versionedsheetdata.sheets !== undefined
  ) {
    let originalsheet = originalsheetdata.sheets;
    let versionedsheet = versionedsheetdata.sheets;

    if (
      originalsheet !== undefined &&
      originalsheet !== null &&
      originalsheet.length > 0 &&
      versionedsheet !== undefined &&
      versionedsheet !== null &&
      versionedsheet.length > 0
    ) {
      versionedsheet?.filter((sheet) => sheet.name !== "Chart")?.map((objsheet, index) => {
        if (
          objsheet.rows !== undefined &&
          objsheet.rows.length > 0 &&
          objsheet.name.trim() !== "Lims Batch"
        ) {
          objsheet.rows.map((objrow, rowindex) => {
            if (objrow.cells !== undefined && objrow.cells.length > 0) {
              objrow.cells.map((objcell, colindex) => {
                let rowindexval = -1;

                if (
                  originalsheet[index] !== undefined &&
                  originalsheet[index].rows !== undefined
                ) {
                  rowindexval = originalsheet[index].rows.findIndex(
                    (row) => row.index === objrow.index
                  );
                }

                let colindexval = -1;
                if (
                  rowindexval > -1 &&
                  originalsheet[index].rows[rowindexval].cells !== undefined
                ) {
                  colindexval = originalsheet[index].rows[
                    rowindexval
                  ].cells.findIndex((col) => col.index === objcell.index);
                }

                if (colindexval !== -1) {
                  if (
                    originalsheet[index] !== undefined &&
                    originalsheet[index].rows[rowindexval] !== undefined &&
                    originalsheet[index].rows[rowindexval].cells[
                    colindexval
                    ] !== undefined
                  ) {
                    let tagCell = fields.filter((x) => x.topLeftrow === rowindexval && x.topLeftcol === colindexval && x.sheetindex === index)
                    // if (objcell.tag !== undefined) {
                    if (tagCell !== undefined) {
                      // let tagvalue = JSON.parse(objcell.tag);

                      let tagvalue = tagCell.length > 0 ? JSON.parse(tagCell[0].tag) : undefined;
                      if (tagvalue !== undefined && tagvalue !== null) {
                        if (
                          tagvalue.FieldCode !== undefined &&
                          tagvalue.FieldCode !== null &&
                          tagvalue.FieldCode === "LINK" &&
                          tagvalue.Linktosheet !== undefined &&
                          tagvalue.Linktosheet !== null &&
                          tagvalue.Linktosheet === true
                        ) {
                          if (
                            originalsheet[index].rows[rowindexval].cells[colindexval].value !== undefined &&
                            originalsheet[index].rows[rowindexval].cells[colindexval].value.toString().trim() !== "" &&
                            originalsheet[index].rows[rowindexval].cells[colindexval].value !== objcell.value &&
                            originalsheet[index].rows[rowindexval].cells[colindexval].value !== "[" + tagvalue.fieldname + "]" &&
                            objcell.value !== undefined &&
                            typeof objcell.value !== "object"
                          ) {
                            doVersion = true;
                          }
                        } else if (
                          originalsheet[index].rows[rowindexval].cells[colindexval].value !== undefined &&
                          originalsheet[index].rows[rowindexval].cells[colindexval].value !== objcell.value &&
                          originalsheet[index].rows[rowindexval].cells[colindexval].value !== "[" + tagvalue.fieldname + "]" &&
                          objcell.value !== undefined &&
                          objcell.formula === undefined &&
                          typeof objcell.value !== "object"
                        ) {
                          doVersion = true;
                        }
                        //dont remove below code

                        // else if(originalsheet[index].rows[rowindexval].cells[colindexval].value !== undefined && objcell.value === undefined){
                        //   // after deleting new cell come here
                        //   if (
                        //     (originalsheet[index].rows[rowindexval].cells[colindexval].value !== undefined &&
                        //     originalsheet[index].rows[rowindexval].cells[colindexval].value !== tagvalue.value &&
                        //     originalsheet[index].rows[rowindexval].cells[colindexval].value !== "[" + tagvalue.fieldname + "]" &&
                        //     tagvalue.value !== undefined &&  objcell.formula === undefined && typeof objcell.value !== "object") === true
                        //   ) {
                        //     doVersion = true;
                        //   }
                        // }else if(objcell.value !== undefined && originalsheet[index].rows[rowindexval].cells[colindexval].value === undefined){
                        //   // making entry on deleted cell
                        //   let tagvalue1 = JSON.parse(originalsheet[index].rows[rowindexval].cells[colindexval].tag);
                        //   console.log(tagvalue1.value)
                        //   console.log(objcell.value)
                        //   if (
                        //     (tagvalue1 !== null && (tagvalue1.value !== objcell.value) &&
                        //     tagvalue1.value !== "[" + tagvalue1.fieldname + "]" &&
                        //     objcell.value !== undefined && objcell.formula === undefined &&
                        //     typeof objcell.value !== "object") === true
                        //   ) {
                        //     console.log(((tagvalue1.value !== objcell.value)  &&
                        //     tagvalue1.value !== "[" + tagvalue1.fieldname + "]" &&
                        //     objcell.value !== undefined && objcell.formula === undefined &&
                        //     typeof objcell.value !== "object") === true)
                        //     doVersion = true;
                        //   }
                        // }
                      }
                    } else if (
                      objcell.value !== undefined &&
                      originalsheet[index].rows[rowindexval] !== undefined &&
                      originalsheet[index].rows[rowindexval].cells[colindexval] !== undefined &&
                      originalsheet[index].rows[rowindexval].cells[colindexval].value !== undefined &&
                      objcell.value !== originalsheet[index].rows[rowindexval].cells[colindexval].value &&
                      typeof originalsheet[index].rows[rowindexval].cells[colindexval].value !== "object" &&
                      objcell.formula === undefined &&
                      typeof objcell.value !== "object"
                    ) {
                      doVersion = true;
                    }
                  } else if (
                    objcell.value !== undefined &&
                    objcell.formula === undefined &&
                    typeof objcell.value !== "object"
                  ) {
                    doVersion = true;
                  }
                }
                return objcell;
              });
            }
            return objrow;
          });
        }
        return objsheet;
      });
    }
  }
  return doVersion;
}

function Sheetchangeornotfunction(originalsheetdata, versionedsheetdata) {
  let doVersion = false;

  if (originalsheetdata?.sheets && versionedsheetdata?.sheets) {
    let originalsheet = originalsheetdata.sheets;
    let versionedsheet = versionedsheetdata.sheets;
    let originalsheettags = originalsheetdata.tags;
    let versionedsheettags = versionedsheetdata.tags;
    if (originalsheettags && versionedsheettags && originalsheettags.length !== versionedsheettags.length) {
      return originalsheettags.length !== versionedsheettags.length;
    } else if (
      originalsheet !== undefined &&
      originalsheet !== null &&
      originalsheet.length > 0 &&
      versionedsheet !== undefined &&
      versionedsheet !== null &&
      versionedsheet.length > 0
    ) {
      if (versionedsheet.length === originalsheet.length || versionedsheet.filter(vs => vs.name !== "Chart").length === originalsheet.length) {
        versionedsheet.some((objsheet, index) => {
          if (
            objsheet.rows !== undefined &&
            objsheet.rows.length > 0 &&
            objsheet.name.trim() !== "Lims Batch"
          ) {
            if (
              objsheet !== undefined &&
              originalsheet[index].rows.length === objsheet.rows.length
            ) {
              objsheet.rows.some((objrow, rowindex) => {
                if (objrow.cells !== undefined && objrow.cells.length > 0) {
                  objrow.cells.some((objcell, colindex) => {
                    let rowindexval = -1;

                    if (
                      originalsheet[index] !== undefined &&
                      originalsheet[index].rows !== undefined
                    ) {
                      rowindexval = originalsheet[index].rows.findIndex(
                        (row) => row.index === objrow.index
                      );
                    }

                    let colindexval = -1;
                    if (
                      rowindexval > -1 &&
                      originalsheet[index].rows[rowindexval].cells !== undefined
                    ) {
                      colindexval = originalsheet[index].rows[rowindexval].cells.findIndex((col) => col.index === objcell.index);
                    }

                    if (colindexval !== -1) {
                      if (
                        originalsheet[index] !== undefined &&
                        originalsheet[index].rows[rowindexval] !== undefined &&
                        originalsheet[index].rows[rowindexval].cells[colindexval] !== undefined
                      ) {
                        if (
                          objcell.value !== undefined &&
                          originalsheet[index].rows[rowindexval] !== undefined &&
                          originalsheet[index].rows[rowindexval].cells[colindexval] !== undefined &&
                          originalsheet[index].rows[rowindexval].cells[colindexval].value !== undefined &&
                          objcell.value !== originalsheet[index].rows[rowindexval].cells[colindexval].value &&
                          typeof originalsheet[index].rows[rowindexval].cells[colindexval].value !== "object" &&
                          objcell.formula === undefined &&
                          typeof objcell.value !== "object"
                        ) {
                          doVersion = true;
                          return true;
                        } else if (
                          objcell.value === undefined &&
                          originalsheet[index].rows[rowindexval].cells[colindexval].value !== undefined
                        ) {
                          doVersion = true;
                          return true;
                        }
                        //for comment merged cell close discard issue 
                        // else if (
                        //   objcell.value !== undefined &&
                        //   originalsheet[index]?.rows[rowindexval]?.cells[colindexval]?.value === undefined
                        // ) {
                        //   doVersion = true;
                        //   return true;
                        // }
                      }
                    }
                    if (doVersion) {
                      return true;
                    }
                    return false;
                  });
                }
                if (doVersion) {
                  return true;
                }
                return false;
                // return objrow;
              });
            } else {
              doVersion = true;
              return true;
            }
          }
          if (doVersion) {
            return true;
          }
          return false;
        });
      } else {
        doVersion = true;
        return true;
      }
    }
  }

  return doVersion;
}

function UpdateMegedCellValues(originaldataobj) {

  // originaldataobj?.sheets?.map((sheetvalues, sheetindex) => {
  //   sheetvalues?.mergedCells?.map(items => {
  //     let [startCell, endCell] = items?.split(':');
  //     let startRow = parseInt(startCell.match(/\d+/)[0]) - 1;
  //     let startCol = startCell.charCodeAt(0) - 65;
  //     let endRow = 0;
  //     let endCol = 0;
  //     if (endCell) {
  //       endRow = parseInt(endCell.match(/\d+/)[0]) - 1;
  //       endCol = endCell.charCodeAt(0) - 65;
  //     }
  //     let values = "";

  //     for (let row = startRow; row <= endRow; row++) {
  //       for (let col = startCol; col <= endCol; col++) {
  //         // eslint-disable-next-line no-loop-func
  //         originaldataobj.sheets[sheetindex].rows?.map((rowsvalues, rowindex) => {
  //           if (rowsvalues.index === row) {
  //             rowsvalues?.cells?.map((columnvalues, index) => {
  //               if (columnvalues?.index === col) {
  //                 if (columnvalues?.value !== undefined) {
  //                   values = columnvalues.value;
  //                 } else if (columnvalues?.value === undefined) {
  //                   originaldataobj.sheets[sheetindex].rows[rowindex].cells[index].value = values;
  //                 }
  //               }
  //             });
  //           }
  //         });
  //       }
  //     }
  //   });
  // });

  // return originaldataobj;

  originaldataobj?.tags?.forEach(items => {
    if (originaldataobj.sheets[items.tagsheetindex].mergedCells > 0) {
      if (originaldataobj.sheets[items.tagsheetindex].mergedCells.includes(items?.selectionAddress)) {

        let [startCell, endCell] = items?.selectionAddress.split(':');
        let startRow = parseInt(startCell.match(/\d+/)[0]) - 1;
        let startCol = startCell.charCodeAt(0) - 65;
        let endRow = 0;
        let endCol = 0;
        if (endCell) {
          endRow = parseInt(endCell.match(/\d+/)[0]) - 1;
          endCol = endCell.charCodeAt(0) - 65;
        }

        let values = "";
        for (let row = startRow; row <= endRow; row++) {
          for (let col = startCol; col <= endCol; col++) {
            originaldataobj.sheets[items.tagsheetindex].rows?.forEach((rowsvalues, rowindex) => {
              if (rowsvalues.index === row) {
                rowsvalues?.cells?.forEach((columnvalues, index) => {
                  if (columnvalues?.index === col) {
                    if (columnvalues?.value !== undefined) {
                      values = columnvalues.value;
                    } else if (columnvalues?.value === undefined) {
                      originaldataobj.sheets[items.tagsheetindex].rows[rowindex].cells[index].value = values;
                    }
                  }
                });
              }
            });
          }
        }
      }
    }
  });
  return originaldataobj;
}


function Sheetchangeornotfunctionforsheet(
  originalsheetdata,
  versionedsheetdata
) {
  let doVersion = false;
  // let originalchart = originalsheetdata.charts
  // let versionedchart = versionedsheetdata.charts
  if (
    originalsheetdata !== null &&
    originalsheetdata !== undefined &&
    versionedsheetdata !== undefined &&
    originalsheetdata?.sheets !== undefined &&
    versionedsheetdata?.sheets !== undefined
  ) {
    let originalsheet = versionedsheetdata.sheets;
    let versionedsheet = originalsheetdata.sheets;

    if (
      originalsheet !== undefined &&
      originalsheet !== null &&
      originalsheet.length > 0 &&
      versionedsheet !== undefined &&
      versionedsheet !== null &&
      versionedsheet.length > 0
    ) {
      if (versionedsheet.length === originalsheet.length) {
        versionedsheet.some((objsheet, index) => {
          if (
            objsheet.rows !== undefined &&
            objsheet.rows.length > 0 &&
            objsheet.name.trim() !== "Lims Batch"
          ) {
            if (
              objsheet !== undefined &&
              originalsheet[index].rows.length === objsheet.rows.length
            ) {
              objsheet.rows.some((objrow, rowindex) => {
                if (objrow.cells !== undefined && objrow.cells.length > 0) {
                  objrow.cells.some((objcell, colindex) => {
                    let rowindexval = -1;
                    if (
                      originalsheet[index] !== undefined &&
                      originalsheet[index].rows !== undefined
                    ) {
                      rowindexval = originalsheet[index].rows.findIndex(
                        (row) => row.index === objrow.index
                      );
                    }

                    let colindexval = -1;
                    if (
                      rowindexval > -1 &&
                      originalsheet[index].rows[rowindexval].cells !== undefined
                    ) {
                      colindexval = originalsheet[index].rows[
                        rowindexval
                      ].cells.findIndex((col) => col.index === objcell.index);
                    }
                    if (colindexval !== -1) {
                      if (
                        originalsheet[index] !== undefined &&
                        originalsheet[index].rows[rowindexval] !== undefined &&
                        originalsheet[index].rows[rowindexval].cells[
                        colindexval
                        ] !== undefined
                      ) {
                        if (
                          objcell.value !== undefined &&
                          originalsheet[index].rows[rowindexval] !==
                          undefined &&
                          originalsheet[index].rows[rowindexval].cells[
                          colindexval
                          ] !== undefined &&
                          originalsheet[index].rows[rowindexval].cells[
                            colindexval
                          ].value !== undefined &&
                          objcell.value !==
                          originalsheet[index].rows[rowindexval].cells[
                            colindexval
                          ].value &&
                          typeof originalsheet[index].rows[rowindexval].cells[
                            colindexval
                          ].value !== "object" &&
                          objcell.formula === undefined &&
                          typeof objcell.value !== "object"
                        ) {
                          doVersion = true;
                        } else if (
                          objcell.value !== undefined &&
                          objcell.tag !== undefined &&
                          originalsheet[index].rows[rowindexval] !==
                          undefined &&
                          originalsheet[index].rows[rowindexval].cells[
                          colindexval
                          ] !== undefined &&
                          objcell.value !==
                          originalsheet[index].rows[rowindexval].cells[
                            colindexval
                          ].value &&
                          originalsheet[index].rows[rowindexval].cells[
                            colindexval
                          ].tag !== undefined &&
                          typeof originalsheet[index].rows[rowindexval].cells[
                            colindexval
                          ].value !== "object" &&
                          objcell.formula === undefined &&
                          typeof objcell.value !== "object"
                        ) {
                          doVersion = true;
                        } else if (
                          objcell.value === undefined &&
                          originalsheet[index].rows[rowindexval].cells[
                            colindexval
                          ].value !== undefined
                        ) {
                          doVersion = true;
                          return true;
                        }
                      }
                    } else {
                      doVersion = true;
                    }
                    if (doVersion) {
                      return true;
                    }
                    return false;
                  });
                }

                if (doVersion) {
                  return true;
                }
                return false;
              });
            } else {
              doVersion = true;
              return true;
            }
          } else if (
            objsheet !== undefined &&
            originalsheet[index].rows.length > 0
          ) {
            doVersion = true;
            return true;
          }
          if (doVersion) {
            return true;
          }
          return false;
        });
      } else {
        doVersion = true;
        return true;
      }
    }
  }
  return doVersion;
}

function sheetModifyiedOrNot(originalsheetdata, versionedsheetdata) {
  let doVersion = false;
  console.log(versionedsheetdata);
  console.log(originalsheetdata);


  if (
    originalsheetdata !== undefined &&
    versionedsheetdata !== undefined &&
    originalsheetdata.sheets !== undefined &&
    versionedsheetdata.sheets !== undefined
  ) {
    let originalsheet = originalsheetdata.sheets;
    let versionedsheet = versionedsheetdata.sheets;
    let originalsheettags = originalsheetdata.tags;
    let versionedsheettags = versionedsheetdata.tags;
    let originalfields = originalsheetdata.fields;
    let versionedfields = versionedsheetdata.fields;
    if (originalsheettags && versionedsheettags && originalsheettags.length !== versionedsheettags.length) {
      return originalsheettags.length !== versionedsheettags.length;
    }
    else if (originalfields && versionedfields && originalfields.length !== versionedfields.length) {
      return originalfields.length !== versionedfields.length;
    }
    else if (
      originalsheet !== undefined &&
      originalsheet !== null &&
      originalsheet.length > 0 &&
      versionedsheet !== undefined &&
      versionedsheet !== null &&
      versionedsheet.length > 0
    ) {
      if (versionedsheet.length === originalsheet.length) {
        versionedsheet.some((objsheet, index) => {
          if (
            objsheet.rows !== undefined &&
            objsheet.rows.length > 0 &&
            objsheet.name.trim() !== "Lims Batch"
          ) {
            if (objsheet !== undefined && originalsheet[index].rows.length === objsheet.rows.length) {

              objsheet.rows.some((objrow, rowindex) => {
                if (objrow.cells !== undefined && objrow.cells.length > 0) {
                  objrow.cells.some((objcell, colindex) => {
                    let rowindexval = -1;

                    if (
                      originalsheet[index] !== undefined &&
                      originalsheet[index].rows !== undefined
                    ) {
                      rowindexval = originalsheet[index].rows.findIndex(
                        (row) => row.index === objrow.index
                      );
                    }

                    if (
                      objrow.cells.length ===
                      originalsheet[index].rows[rowindexval].cells.length
                    ) {
                      let colindexval = -1;
                      if (
                        rowindexval > -1 &&
                        originalsheet[index].rows[rowindexval].cells !==
                        undefined
                      ) {

                        colindexval = originalsheet[index].rows[rowindexval].cells.findIndex(
                          (col) => {
                            const colIdx = typeof col.index === "string"
                              ? parseInt(col.index, 10)
                              : col.index;

                            return colIdx === objcell.index;
                          }
                        );

                        // colindexval = originalsheet[index].rows[rowindexval].cells.findIndex((col) => col.index === objcell.index);
                      }
                      if (colindexval !== -1) {
                        if (
                          originalsheet[index] !== undefined &&
                          originalsheet[index].rows[rowindexval] !== undefined &&
                          originalsheet[index].rows[rowindexval].cells[colindexval] !== undefined
                        ) {
                          if (
                            objcell.value !== undefined &&
                            originalsheet[index].rows[rowindexval] !== undefined &&
                            originalsheet[index].rows[rowindexval].cells[colindexval] !== undefined &&
                            originalsheet[index].rows[rowindexval].cells[colindexval].value !== undefined &&
                            objcell.value !== originalsheet[index].rows[rowindexval].cells[colindexval].value &&
                            typeof originalsheet[index].rows[rowindexval].cells[colindexval].value !== "object" &&
                            objcell.formula === undefined && typeof objcell.value !== "object"
                          ) {
                            doVersion = true;
                          } else if (
                            objcell.value !== undefined && objcell.tag !== undefined &&
                            originalsheet[index].rows[rowindexval] !== undefined &&
                            originalsheet[index].rows[rowindexval].cells[colindexval] !== undefined &&
                            objcell.value !== originalsheet[index].rows[rowindexval].cells[colindexval].value &&
                            originalsheet[index].rows[rowindexval].cells[colindexval].tag !== undefined &&
                            typeof originalsheet[index].rows[rowindexval].cells[colindexval].value !== "object" &&
                            (originalsheet[index].rows[rowindexval].cells[colindexval].value !== undefined &&
                              originalsheet[index].rows[rowindexval].cells[colindexval].tag !== undefined) &&
                            objcell.formula === undefined && typeof objcell.value !== "object"
                          ) {
                            doVersion = true;
                          } else if (
                            originalsheet[index].rows[rowindexval] !== undefined &&
                            originalsheet[index].rows[rowindexval].cells[colindexval] !== undefined &&
                            originalsheet[index].rows[rowindexval].cells[colindexval].value !== undefined &&
                            objcell.value !== originalsheet[index].rows[rowindexval].cells[colindexval].value &&
                            typeof originalsheet[index].rows[rowindexval].cells[colindexval].value !== "object" &&
                            objcell.formula === undefined && typeof objcell.value !== "object"
                          ) {
                            doVersion = true;
                          }
                        }
                      } else {
                        doVersion = true;
                      }
                    } else {
                      doVersion = true;
                    }
                    if (doVersion) {
                      return true;
                    }
                    return false;
                  });
                }
                if (doVersion) {
                  return true;
                }
                return false;
              });
            } else {
              doVersion = true;
              return true;
            }
          } else if (
            objsheet !== undefined &&
            originalsheet[index].rows.length > 0
          ) {
            doVersion = true;
            return true;
          }
          if (doVersion) {
            return true;
          }
          return false;
        });
      } else {
        doVersion = true;
        return true;
      }
    }
    else if (originalfields && versionedfields) {
      let doVersion = false;
      for (let fld = 0; fld < originalfields.length; fld++) {
        if (originalfields[fld] && versionedfields[fld]) {
          if (originalfields[fld].tag !== versionedfields[fld].tag) {
            doVersion = true;
            break;
          }
        }
      }

    }
  }
  return doVersion;
}

// function chartversionchages(originalchart, versionedchart) {
//   let doVersion = false
//   if (originalchart.length !== 0 &&
//     originalchart !== undefined
//     && originalchart !== null
//     && versionedchart !== undefined &&
//     versionedchart.length !== undefined && versionedchart.length !== 0
//     && versionedchart !== null ) {
//     let value = false;
//     let versionedchartlenth;
//     for (let i = 0; i < originalchart.length; i++) {
//       if (value) {
//         doVersion = true
//         break
//       }
//       for (let j = 0; j < versionedchart.length; j++) {
//         if (value) {
//           doVersion = true
//           break
//         }
//         if (versionedchart[j].series[j] !== undefined && originalchart[i].series[i] !== undefined) {
//           versionedchartlenth = versionedchart[j].series[j].points.length
//           value = originalchart[i].series[i].points.length === versionedchartlenth ? false : true
//         }

//       }

//     }
//   }
//   //  else {
//   //   return doVersion = true
//   // }
//   return doVersion
// }

function markversionchanges(
  originalsheetdata,
  versionedsheetdata,
  displaytype
) {
  let orgdata = originalsheetdata.fields;
  let verdata = versionedsheetdata.fields;
  let originalsheet = originalsheetdata.sheets;
  let versionedsheet = versionedsheetdata.sheets;

  if (
    originalsheet !== undefined &&
    originalsheet !== null &&
    originalsheet.length > 0 &&
    versionedsheet !== undefined &&
    versionedsheet !== null &&
    versionedsheet.length > 0
  ) {
    versionedsheet.map((objsheet, index) => {
      let sheetIndex = originalsheet.findIndex(
        (sheet) => objsheet.name === sheet.name
      );

      if (sheetIndex > -1) {
        objsheet.rows.map((objrow, rowindex) => {
          objrow.cells.map((objcell, colindex) => {
            let rowindexval = originalsheet[sheetIndex].rows.findIndex(
              (row) => row.index === objrow.index
            );

            let colindexval = -1;
            if (rowindexval > -1) {
              colindexval = originalsheet[sheetIndex].rows[
                rowindexval
              ].cells.findIndex((col) => col.index === objcell.index);
            }
            if (
              originalsheet[sheetIndex] !== undefined &&
              originalsheet[sheetIndex].rows[rowindexval] !== undefined &&
              originalsheet[sheetIndex].rows[rowindexval].cells[colindexval] !==
              undefined
            ) {

              const objnew = orgdata?.find(
                x => x.sheetindex === sheetIndex && x.topLeftrow === rowindexval && x.bottomRightrow === colindexval
              );
              const oldobj = verdata?.find(
                x => x.sheetindex === sheetIndex && x.topLeftrow === rowindexval && x.bottomRightrow === colindexval
              );

              const newtag = objnew ? JSON.parse(objnew.tag) : null;
              const oldtag = oldobj ? JSON.parse(oldobj.tag) : null;

              if (oldtag !== undefined && oldtag !== null) {
                // let newTag = originalsheet[sheetIndex].rows[rowindexval].cells[colindexval].tag !== undefined ? JSON.parse(originalsheet[sheetIndex].rows[rowindexval].cells[colindexval].tag) : undefined;
                let newTag = newtag;
                let oldTag = oldtag;
                let fieldname = "[" + oldTag.fieldname + "]";
                if (newTag === undefined) {
                  objcell.background = "#ffcccc";
                  objcell.borderBottom = { color: "#ff0000", size: 1 };
                  objcell.borderLeft = { color: "#ff0000", size: 1 };
                  objcell.borderRight = { color: "#ff0000", size: 1 };
                  objcell.borderTop = { color: "#ff0000", size: 1 };
                } else if (displaytype === 0) {
                  if (
                    originalsheet[sheetIndex].rows[rowindexval].cells[colindexval].value !== undefined &&
                    originalsheet[sheetIndex].rows[rowindexval].cells[colindexval].value !== objcell.value &&
                    typeof objcell.value !== "object"
                  ) {
                    objcell.background = "#ffcccc";
                    objcell.borderBottom = { color: "#ff0000", size: 1 };
                    objcell.borderLeft = { color: "#ff0000", size: 1 };
                    objcell.borderRight = { color: "#ff0000", size: 1 };
                    objcell.borderTop = { color: "#ff0000", size: 1 };
                  } else if (
                    originalsheet[sheetIndex].rows[rowindexval].cells[colindexval].value !== undefined &&
                    originalsheet[sheetIndex].rows[rowindexval].cells[colindexval].value === objcell.value &&
                    newTag.Parameter !== undefined &&
                    oldTag.Parameter === undefined
                  ) {
                    objcell.background = "#ffcccc";
                    objcell.borderBottom = { color: "#ff0000", size: 1 };
                    objcell.borderLeft = { color: "#ff0000", size: 1 };
                    objcell.borderRight = { color: "#ff0000", size: 1 };
                    objcell.borderTop = { color: "#ff0000", size: 1 };
                  } else if (newTag.FieldCode === 'LINK' &&
                    originalsheet[sheetIndex].rows[rowindexval].cells[colindexval].value !== objcell.value &&
                    typeof objcell.value !== "object"
                  ) {
                    objcell.background = "#ffcccc";
                    objcell.borderBottom = { color: "#ff0000", size: 1 };
                    objcell.borderLeft = { color: "#ff0000", size: 1 };
                    objcell.borderRight = { color: "#ff0000", size: 1 };
                    objcell.borderTop = { color: "#ff0000", size: 1 };
                  }
                } else {
                  if (
                    originalsheet[sheetIndex].rows[rowindexval].cells[colindexval].value !== undefined &&
                    originalsheet[sheetIndex].rows[rowindexval].cells[colindexval].value !== objcell.value &&
                    originalsheet[sheetIndex].rows[rowindexval].cells[colindexval].value !== fieldname &&
                    objcell.value !== fieldname &&
                    typeof objcell.value !== "object"
                  ) {

                    if (oldtag !== undefined && oldtag !== null) {
                      let tagField = oldtag.FieldCode !== undefined && oldtag.FieldCode !== null ? oldtag.FieldCode : undefined;
                      if (tagField === 'LINK') {

                      } else {
                        objcell.background = "#ffcccc";
                        objcell.borderBottom = { color: "#ff0000", size: 1 };
                        objcell.borderLeft = { color: "#ff0000", size: 1 };
                        objcell.borderRight = { color: "#ff0000", size: 1 };
                        objcell.borderTop = { color: "#ff0000", size: 1 };
                      }
                    }
                  } else if (
                    originalsheet[sheetIndex].rows[rowindexval].cells[
                      colindexval
                    ].value !== undefined &&
                    originalsheet[sheetIndex].rows[rowindexval].cells[
                      colindexval
                    ].value === objcell.value &&
                    newTag.Parameter !== undefined &&
                    oldTag.Parameter === undefined
                  ) {
                    objcell.background = "#ffcccc";
                    objcell.borderBottom = { color: "#ff0000", size: 1 };
                    objcell.borderLeft = { color: "#ff0000", size: 1 };
                    objcell.borderRight = { color: "#ff0000", size: 1 };
                    objcell.borderTop = { color: "#ff0000", size: 1 };
                  }
                }
              } else if (
                objcell.value !== undefined &&
                typeof objcell.value !== "object" &&
                originalsheet[sheetIndex].rows[rowindexval].cells[colindexval]
                  .value !== undefined &&
                objcell.value !==
                originalsheet[sheetIndex].rows[rowindexval].cells[colindexval]
                  .value
              ) {
                objcell.background = "#ffcccc";
                objcell.borderBottom = { color: "#ff0000", size: 1 };
                objcell.borderLeft = { color: "#ff0000", size: 1 };
                objcell.borderRight = { color: "#ff0000", size: 1 };
                objcell.borderTop = { color: "#ff0000", size: 1 };
              }
            } else if (
              objcell.value !== undefined &&
              typeof objcell.value !== "object"
            ) {
              objcell.background = "#ffcccc";
              objcell.borderBottom = { color: "#ff0000", size: 1 };
              objcell.borderLeft = { color: "#ff0000", size: 1 };
              objcell.borderRight = { color: "#ff0000", size: 1 };
              objcell.borderTop = { color: "#ff0000", size: 1 };
            }
            return objcell;
          });
          return objrow;
        });
      }
      return objsheet;
    });
  }
  return versionedsheetdata;
}

function restrictVersioncomparion(originalsheetdata) {
  let originalsheet = originalsheetdata.sheets;

  if (
    originalsheet !== undefined &&
    originalsheet !== null &&
    originalsheet.length > 0
  ) {
    originalsheet.map((objsheet, index) => {
      objsheet.rows.map((objrow, rowindex) => {
        objrow.cells.map((objcell, colindex) => {
          objcell.enable = false;
          return objcell;
        });
        return objrow;
      });
      return objsheet;
    });
  }
  return originalsheetdata;
}

function removeByAttr(arr, attr, value) {
  var i = arr.length;
  while (i--) {
    if (
      arr[i] &&
      arr[i].hasOwnProperty(attr) &&
      arguments.length > 2 &&
      arr[i][attr] === value
    ) {
      arr.splice(i, 1);
    }
  }
  return arr;
}

function getGridorderColumns(columns, type) {
  let columnsValue = columns;

  if (Number(type) === 0) {
    removeByAttr(columnsValue, "header", "Sample");
    removeByAttr(columnsValue, "header", "Project");
    removeByAttr(columnsValue, "header", "Inventory");
  } else if (Number(type) === 5) {
    removeByAttr(columnsValue, "header", "Task");
    removeByAttr(columnsValue, "header", "Sample");
    removeByAttr(columnsValue, "header", "Inventory");
  } else if (Number(type) === 4) {
    removeByAttr(columnsValue, "header", "Task");
    removeByAttr(columnsValue, "header", "Sheet");
  }

  return columnsValue;
}

function timeout(ms) {
  return new Promise((res) => setTimeout(res, ms));
}

function CheckIsMergedandreturntags(
  spread,
  Mergedcells,
  tlRow,
  tlCol,
  btRow,
  btCol
) {
  let tag = undefined;
  let sheetindex = -1;

  if (Mergedcells !== undefined && Mergedcells.length > 0) {
    let MergedCellstoModify = undefined;

    if (spread.activeSheet() !== undefined) {
      sheetindex = spread.sheetIndex(spread.activeSheet());
    }

    for (let index = 0; index < Mergedcells.length; index++) {
      if (Mergedcells[index] !== undefined) {
        if (
          Mergedcells[index].bottomRight !== undefined &&
          Mergedcells[index].topLeft !== undefined
        ) {
          if (
            Mergedcells[index].topLeft.row === tlRow &&
            Mergedcells[index].bottomRight.row === btRow &&
            Mergedcells[index].topLeft.col === tlCol &&
            Mergedcells[index].bottomRight.col === btCol
          ) {
            MergedCellstoModify = Mergedcells[index];

            let row = 0;
            let col = 0;
            let toprow = 0;
            let topleft = 0;
            row = MergedCellstoModify.bottomRight.row;
            col = MergedCellstoModify.bottomRight.col;
            toprow = MergedCellstoModify.topLeft.row;
            topleft = MergedCellstoModify.topLeft.col;

            for (let rowindex = toprow; rowindex <= row; rowindex++) {
              for (let colindex = topleft; colindex <= col; colindex++) {
                tag = spread.activeSheet().range(rowindex, colindex).tag();
                if (tag !== undefined && tag !== null) {
                  tag = {
                    tagvalue: tag,
                    sheet: sheetindex,
                    row: rowindex,
                    col: colindex,
                  };
                }

                if (tag !== null && tag !== undefined) {
                  break;
                }
              }
              if (tag !== null && tag !== undefined) {
                break;
              }
            }
          } else {
            tag = spread.activeSheet().range(tlRow, tlCol).tag();
            if (tag !== undefined && tag !== null) {
              tag = {
                tagvalue: tag,
                sheet: sheetindex,
                row: tlRow,
                col: tlCol,
              };
            }
          }

          break;
        }
      }
    }
    if (tag !== undefined && tag !== null) {
      return tag;
    } else {
      return undefined;
    }
  } else {
    if (spread.activeSheet() !== undefined) {
      sheetindex = spread.sheetIndex(spread.activeSheet());
    }
    tag = spread.activeSheet().range(tlRow, tlCol).tag();
    if (tag !== undefined && tag !== null) {
      tag = {
        tagvalue: tag,
        sheet: sheetindex,
        row: tlRow,
        col: tlCol,
      };
    }
    return tag;
  }
}

function userDateFormat(date) {
  let data = setDateAsuserDefined(date, $.session.get("userDefinedDate"));
  return data;
}

function checksheetdiffandmodifychangesheet(
  spread,
  ref,
  e,
  sheettomodify,
  istemplate
) {
  if (
    spread === null ||
    sheettomodify === undefined ||
    sheettomodify.sheets === undefined
  )
    return;

  if (e.sender.sheets().length !== sheettomodify.sheets.length) {
    checksheetsandequlize(e, sheettomodify);
  }

  // if (e.sender._workbook._imagesval !== undefined && e.sender._workbook._imagesval.length > 0) {
  //   sheettomodify.images = e.sender._workbook._imagesval.filter(obj => obj !== null && obj !== undefined && !obj.candelete);
  // }

  if (
    e.sender._workbook._tags !== undefined &&
    e.sender._workbook._tags.length > 0
  ) {
    sheettomodify.tags = e.sender._workbook._tags;
  }

  if (
    e.sender._workbook._chart !== undefined &&
    e.sender._workbook._chart.length > 0
  ) {
    sheettomodify.charts = e.sender._workbook._chart;
  }

  if (spread.activeSheet().range(ref).value() !== null) {
    updatecell(
      spread,
      ref,
      "value",
      spread.activeSheet().range(ref).value(),
      sheettomodify
    );
    if (!istemplate) {
      updateCellAudit(
        spread,
        ref,
        "value",
        spread.activeSheet().range(ref).value(),
        sheettomodify
      );
    }
  } else {
    cleancell(
      spread,
      ref,
      "value",
      spread.activeSheet().range(ref).value(),
      sheettomodify
    );
  }

  if (spread.activeSheet().range(ref).bold() !== null) {
    updatecell(
      spread,
      ref,
      "bold",
      spread.activeSheet().range(ref).bold(),
      sheettomodify
    );
  } else {
    cleancell(
      spread,
      ref,
      "bold",
      spread.activeSheet().range(ref).bold(),
      sheettomodify
    );
  }

  if (spread.activeSheet().range(ref).italic() !== null) {
    updatecell(
      spread,
      ref,
      "italic",
      spread.activeSheet().range(ref).italic(),
      sheettomodify
    );
  } else {
    cleancell(
      spread,
      ref,
      "italic",
      spread.activeSheet().range(ref).italic(),
      sheettomodify
    );
  }

  if (spread.activeSheet().range(ref).underline() !== null) {
    updatecell(
      spread,
      ref,
      "underline",
      spread.activeSheet().range(ref).underline(),
      sheettomodify
    );
  } else {
    cleancell(
      spread,
      ref,
      "underline",
      spread.activeSheet().range(ref).underline(),
      sheettomodify
    );
  }

  if (spread.activeSheet().range(ref).borderLeft() !== null) {
    updatecell(
      spread,
      ref,
      "borderLeft",
      spread.activeSheet().range(ref).borderLeft(),
      sheettomodify
    );
  } else {
    cleancell(
      spread,
      ref,
      "borderLeft",
      spread.activeSheet().range(ref).borderLeft(),
      sheettomodify
    );
  }

  if (spread.activeSheet().range(ref).borderRight() !== null) {
    updatecell(
      spread,
      ref,
      "borderRight",
      spread.activeSheet().range(ref).borderRight(),
      sheettomodify
    );
  } else {
    cleancell(
      spread,
      ref,
      "borderRight",
      spread.activeSheet().range(ref).borderRight(),
      sheettomodify
    );
  }

  if (spread.activeSheet().range(ref).borderTop() !== null) {
    updatecell(
      spread,
      ref,
      "borderTop",
      spread.activeSheet().range(ref).borderTop(),
      sheettomodify
    );
  } else {
    cleancell(
      spread,
      ref,
      "borderTop",
      spread.activeSheet().range(ref).borderTop(),
      sheettomodify
    );
  }

  if (spread.activeSheet().range(ref).borderBottom() !== null) {
    updatecell(
      spread,
      ref,
      "borderBottom",
      spread.activeSheet().range(ref).borderBottom(),
      sheettomodify
    );
  } else {
    cleancell(
      spread,
      ref,
      "borderBottom",
      spread.activeSheet().range(ref).borderBottom(),
      sheettomodify
    );
  }

  if (spread.activeSheet().range(ref).color() !== null) {
    updatecell(
      spread,
      ref,
      "color",
      spread.activeSheet().range(ref).color(),
      sheettomodify
    );
  } else {
    cleancell(
      spread,
      ref,
      "color",
      spread.activeSheet().range(ref).color(),
      sheettomodify
    );
  }

  if (spread.activeSheet().range(ref).background() !== null) {
    updatecell(
      spread,
      ref,
      "background",
      spread.activeSheet().range(ref).background(),
      sheettomodify
    );
  } else {
    cleancell(
      spread,
      ref,
      "background",
      spread.activeSheet().range(ref).background(),
      sheettomodify
    );
  }

  // if (spread.activeSheet().range(ref).enable() !== null && spread.activeSheet().range(ref).enable() === false) {
  //   updatecell(spread, ref, "enable", spread.activeSheet().range(ref).enable(), sheettomodify);
  // }
  // else {
  //   cleancell(spread, ref, "enable", null, sheettomodify);
  // }

  // if (spread.activeSheet().range(ref).wrap() !== null && spread.activeSheet().range(ref).wrap() === true) {
  //   updatecell(spread, ref, "wrap", spread.activeSheet().range(ref).wrap(), sheettomodify);
  // }
  // else {
  //   cleancell(spread, ref, "wrap", null, sheettomodify);
  // }

  return sheettomodify;
}

function cellLevelAudit(oldValue, newValue, cellRange, sheetName) {
  // this.oldCellTag = this.state.kendoSpread.activeSheet().selection().tag();
  setTimeout(() => {
    const passObj = {
      objsilentaudit: SilentauditobjectForOrder(
        "view",
        "Sheet Orders",
        this.props.t("Orders.Sheetorders.IDS_AUDIT_CELLLEVEL", {
          // param0: this.state.orderDetails.batchid,
          param1: sheetName,
          param2: oldValue === null ? "-" : oldValue,
          param3: newValue,
          // param4: store.getState().Loggeduser.username,
          // rangeR: Number(cellRange.row)+1,
          rangeR: cellRange,
          // rangeC: this.convertToAlpha(cellRange.col),
        }),
        "",
        "LSlogilablimsorderdetail",
        this.state.orderDetails.batchcode
      ),
    };
    Servicecalls(
      "" + this.ELNurl + "/AuditTrail/silentRecordHandlerForOrder",
      passObj,
      (res) => { },
      (res) => { }
    );
  }, 1);
}

function updateCellAudit(spread, ref, key, value, sheettomodify) {
  let sheetname = spread.activeSheet()._sheetName;
  let sheetindex = sheettomodify.sheets.findIndex(
    (obj) => obj.name === sheetname
  );
  if (sheetindex > -1) {
    for (
      let rowindex = ref.topLeft.row;
      rowindex <= ref.bottomRight.row;
      rowindex++
    ) {
      for (
        let colindex = ref.topLeft.col;
        colindex <= ref.bottomRight.col;
        colindex++
      ) {
        if (sheettomodify.sheets[sheetindex].rows === undefined)
          sheettomodify.sheets[sheetindex].rows = [];
        let sheetrowindex = sheettomodify.sheets[sheetindex].rows.findIndex(
          (row) => row.index === rowindex
        );
        let sheetcolindex = -1;
        if (sheetrowindex > -1) {
          if (
            sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells ===
            undefined
          )
            sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells = [];

          sheetcolindex = sheettomodify.sheets[sheetindex].rows[
            sheetrowindex
          ].cells.findIndex((col) => col.index === colindex);
          if (
            sheetcolindex > -1 &&
            sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells[
            sheetcolindex
            ][key] !== value &&
            sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells[
            sheetcolindex
            ][key] !== undefined &&
            sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells[
            sheetcolindex
            ][key] !== null
          ) {
            cellLevelAudit(
              sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells[
              sheetcolindex
              ][key],
              value,
              ref.toString(),
              sheetname
            );
          }
        }
      }
    }
  }
}

function updatecell(spread, ref, key, value, sheettomodify) {
  let sheetname = spread.activeSheet()._sheetName;
  let sheetindex = sheettomodify.sheets.findIndex(
    (obj) => obj.name === sheetname
  );
  if (sheetindex > -1) {
    for (
      let rowindex = ref.topLeft.row;
      rowindex <= ref.bottomRight.row;
      rowindex++
    ) {
      for (
        let colindex = ref.topLeft.col;
        colindex <= ref.bottomRight.col;
        colindex++
      ) {
        if (sheettomodify.sheets[sheetindex].rows === undefined)
          sheettomodify.sheets[sheetindex].rows = [];
        let sheetrowindex = sheettomodify.sheets[sheetindex].rows.findIndex(
          (row) => row.index === rowindex
        );
        let sheetcolindex = -1;
        if (sheetrowindex > -1) {
          if (
            sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells ===
            undefined
          )
            sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells = [];

          sheetcolindex = sheettomodify.sheets[sheetindex].rows[
            sheetrowindex
          ].cells.findIndex((col) => col.index === colindex);
          if (sheetcolindex > -1) {
            sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells[
              sheetcolindex
            ][key] = value;
          } else {
            sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells.push({
              index: colindex,
              [key]: value,
            });
          }
        } else {
          sheettomodify.sheets[sheetindex].rows.push({
            index: rowindex,
            cells: [{ index: colindex, [key]: value }],
          });
        }
      }
    }
  }
}

function cleancell(spread, ref, key, value, sheettomodify) {
  let sheetname = spread.activeSheet()._sheetName;
  let sheetindex = sheettomodify.sheets.findIndex(
    (obj) => obj.name === sheetname
  );
  if (sheetindex > -1) {
    for (
      let rowindex = ref.topLeft.row;
      rowindex <= ref.bottomRight.row;
      rowindex++
    ) {
      for (
        let colindex = ref.topLeft.col;
        colindex <= ref.bottomRight.col;
        colindex++
      ) {
        if (sheettomodify.sheets[sheetindex].rows === undefined)
          sheettomodify.sheets[sheetindex].rows = [];
        let sheetrowindex = sheettomodify.sheets[sheetindex].rows.findIndex(
          (row) => row.index === rowindex
        );
        let sheetcolindex = -1;
        if (sheetrowindex > -1) {
          if (
            sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells ===
            undefined
          )
            sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells = [];

          sheetcolindex = sheettomodify.sheets[sheetindex].rows[
            sheetrowindex
          ].cells.findIndex((col) => col.index === colindex);
          if (sheetcolindex > -1) {
            if (
              sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells[
              sheetcolindex
              ][key] !== undefined
            ) {
              let cell =
                sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells[
                sheetcolindex
                ];
              if (key !== "value") {
                delete cell[key];
              } else {
                cell[key] = "";
              }
              sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells[
                sheetcolindex
              ] = cell;
            }

            if (
              Object.keys(
                sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells[
                sheetcolindex
                ]
              ).length <= 1
            ) {
              sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells.splice(
                sheetcolindex,
                1
              );
            }

            if (
              sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells
                .length <= 0
            ) {
              delete sheettomodify.sheets[sheetindex].rows[sheetrowindex].cells;
            }
          }

          if (
            Object.keys(sheettomodify.sheets[sheetindex].rows[sheetrowindex])
              .length <= 1
          ) {
            sheettomodify.sheets[sheetindex].rows.splice(sheetrowindex, 1);
          }

          if (sheettomodify.sheets[sheetindex].rows.length <= 0) {
            sheettomodify.sheets[sheetindex].rows = [];
          }
        }
      }
    }
  }
}

function checksheetsandequlize(e, sheettomodify) {
  if (e.sender.sheets().length > sheettomodify.sheets.length) {
    // let insertedsheet = e.sender
    //   .sheets()
    //   .find((obj) => !sheettomodify.sheets?.filter((items)=>items.name.includes(obj._sheetName)));
    let insertedsheet = e.sender.sheets().find(
      (sheet) => !sheettomodify.sheets.some((s) => s.name === sheet._sheetName)
    );
    if (insertedsheet !== undefined) {
      sheettomodify.sheets.push({
        name: insertedsheet._sheetName,
        rows: [],
        columns: [],
        selection: "A1:A1",
        activeCell: "A1:A1",
        frozenRows: 0,
        frozenColumns: 0,
        showGridLines: true,
        gridLinesColor: null,
        mergedCells: [],
        hyperlinks: [],
        defaultCellStyle: { fontFamily: "Arial", fontSize: "12" },
        drawings: [],
      });
    }
  } else {
    let deletesheetindex = sheettomodify.sheets.findIndex(
      (obj) => !e.sender.sheets().includes(obj.name)
    );
    if (deletesheetindex > -1) {
      sheettomodify.sheets.splice(deletesheetindex, 1);
    }
  }
}

async function ongetcurentdata(curentprotocolororderstepcode) {
  try {
    let ELNurl = window.appUrl.ELN;
    const response = await fetch(
      "" +
      ELNurl +
      "/protocol/getprotocolperticulerstep/" +
      curentprotocolororderstepcode +
      "/" +
      isMultitenant +
      "/" +
      1,
      {
        method: "GET",
        // body: JSON.stringify(attachment),
        headers: new Headers({
          Authorization: $.session.get("Token"),
          "X-TenantID": $.session.get("tenantid"),
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      }
    );
    const json = await response.json();
    return json;
    // }
  } catch (error) { }

  // return information;
}

function Protocolcontentchangeornot(oldcontent, newcontent) {
  let content = newcontent;
  let information = oldcontent;
  information = information.replaceAll("&nbsp;", "");
  content = content.replaceAll("&nbsp;", "");
  content = content.replaceAll("<br>", "");
  information = information.replaceAll("<br>", "");
  content = content.replaceAll("<p>", "");
  information = information.replaceAll("<p>", "");
  content = content.replaceAll("</p>", "");
  information = information.replaceAll("</p>", "");
  content = content.replace(/ /g, "");
  information = information.replace(/ /g, "");
  // let htmlcontent = newcontent;
  if (content.length === information.length) {
    return false;
  } else {
    return true;
  }
}

function importimagetosheet(spreadsheet, url) {
  let imageId = spreadsheet.addImage(url);
  let sheet = spreadsheet.activeSheet();
  let selectedcell = sheet._viewSelection.selection;
  sheet.batch(function () {
    sheet.addDrawing({
      topLeftCell: selectedcell.topLeft,
      offsetX: 0,
      offsetY: 0,
      width: 150,
      height: 150,
      image: imageId,
    });
  });
}

function plantyprestrictedpagename(props) {
  let tenantdomain = $.session.get("tenantdomain");
  tenantdomain = isMultitenant !== 0 ? "/#" + tenantdomain : "/";
  let plantype = valiadateTenantPackage();
  if (plantype === "1" || plantype === "2") {
    if (isMultitenant !== 0) {
      props.history.push(tenantdomain);
    } else {
      props.history.push(tenantdomain);
    }
  }
}

function updateActiveUserTime() {
  let orderDetails = localStorage.getItem("_viewOrderDetail");
  let ELNurl = window.appUrl.ELN;

  if (orderDetails !== undefined && orderDetails !== null && orderDetails !== "") {
    let passObj = JSON.parse(orderDetails);

    if (passObj.length > 0) {
      passObj.map((x) => {
        Servicecalls("" + ELNurl + "/File/unlockorderOnViewClose", x, (response) => { localStorage.setItem("_viewOrderDetail", ""); }, (response) => { localStorage.setItem("_viewOrderDetail", ""); });
        return x;
      });
    }
  }

  let passObjDet = { activeusercode: Number(sessionStorage.activeUserId), };
  Servicecalls("" + ELNurl + "/Login/updateActiveUserTime", passObjDet, (response) => { }, (response) => { });

  let notification = {};
  notification["currentdate"] = GetutcDate(new Date());
  notification["usercode"] = $.session.get("User");
  notification["addedby"] = $.session.get("Username");
  notification["sitecode"] = $.session.get("Usersite");
  notification["Usersitename"] = $.session.get("Usersitename");

  // Servicecalls("" + ELNurl + "/Login/Loginnotification", notification, () => { }, () => { });
  // /Servicecalls("" + ELNurl + "/Login/Duedatenotification", notification, () => { }, () => { });
}

const pickbackgroudontype = (sampletype) => {
  switch (sampletype) {
    case "s":
      return "#90EE90"; //"lightgreen";
    case "u":
      return "yellow";
    case "q":
      return "pink";
    case "n":
      return "red";
    case "m":
      return "#A5CACC";
    case "h":
      return "#00ffcc"
    default:
      return "white";
  }
};

function checksheetformulachangeornot(orginal, version) {
  function getFormulas(
    sheets,
    value,
    change_cell_value,
    change_cell_index,
    change_orinalvalue
  ) {
    const finalarray = [];
    if (value && change_cell_value && change_cell_index) {
      for (const sheet of sheets) {
        if (
          sheet.name === orginal.activeSheet ||
          sheet.name === version.activeSheet
        ) {
          const sheetrows = sheet.rows;
          for (const row of sheetrows) {
            const temp = row.cells;
            if (temp) {
              // eslint-disable-next-line no-loop-func
              temp.forEach((cell) => {
                if (cell.formula !== undefined && cell.formula !== null) {
                  if (cell.formula === change_cell_index) {
                    cell.value = change_cell_value;
                  }
                  finalarray.push({
                    row: row.index,
                    col: cell.index,
                    value: cell.value,
                    formula: cell.formula,
                    orginalvalue: change_orinalvalue,
                  });
                }
              });
            }
          }
        }
      }

      return finalarray;
    } else {
      for (const sheet of sheets) {
        if (
          sheet.name === orginal.activeSheet ||
          sheet.name === version.activeSheet
        ) {
          const sheetrows = sheet.rows;
          for (const row of sheetrows) {
            const temp = row.cells;
            if (temp) {
              // eslint-disable-next-line no-loop-func
              temp.forEach((cell) => {
                if (cell.formula !== undefined && cell.formula !== null) {
                  finalarray.push({
                    row: row.index,
                    col: cell.index,
                    value: cell.value,
                    formula: cell.formula,
                  });
                }
              });
            }
          }
        }
      }
      return finalarray;
    }
  }
  let versionFormulas;
  let orginalFormulas;
  if (orginal) {
    orginalFormulas = getFormulas(orginal.sheets);
    console.log("original sheet - formulas");
    console.log(orginalFormulas);
  }

  if (version) {
    versionFormulas = getFormulas(version.sheets);
    console.log("version - formulas");
    console.log(versionFormulas);
  }
  let change_cell_value;
  let change_cell_index;
  let formulaarray;
  let change_orinalvalue;
  for (let i = 0; i < orginalFormulas.length; i++) {
    if (
      orginalFormulas[i].col === versionFormulas[i].col &&
      orginalFormulas[i].value !== versionFormulas[i].value &&
      orginalFormulas[i].row === versionFormulas[i].row
    ) {
      console.log("-------------------------------");
      console.log(orginalFormulas[i].value);
      console.log(versionFormulas[i].value);
      console.log("-------------------------------");
      change_cell_value = versionFormulas[i].value;
      change_cell_index = versionFormulas[i].formula;
      change_orinalvalue = orginalFormulas[i].value;

      //  let update_orginal=orginal;

      formulaarray = getFormulas(
        orginal.sheets,
        true,
        change_cell_value,
        change_cell_index,
        change_orinalvalue
      );
    }
  }

  return formulaarray;
}

// function findPathRecursive(node, targetId, currentPath) {
//   if (node.id === targetId) {
//     return currentPath + " -> " + node.text;
//   }

//   if (node.items) {
//     for (let i = 0; i < node.items.length; i++) {
//       const childNode = node.items[i];
//       const path = findPathRecursive(childNode, targetId, currentPath + " -> " + node.text);
//       if (path !== "") {
//         return path;
//       }
//     }
//   }

//   return "";
// }

function findPathInArray(nodeArray, targetId, currentPath = "") {
  for (const node of nodeArray) {
    const path = findPathRecursive(node, targetId, currentPath);
    if (path !== "") {
      return path;
    }
  }
  return "";
}

function findPathRecursive(node, targetId, currentPath) {
  if (node.id === targetId) {
    return currentPath + " -> " + node.text;
  }

  if (node.items) {
    for (let i = 0; i < node.items.length; i++) {
      const childNode = node.items[i];
      const path = findPathRecursive(childNode, targetId, currentPath + " -> " + node.text);
      if (path !== "") {
        return path;
      }
    }
  }

  return "";
}

function getCurrentDateAndTimeOnBackend() {
  return new Promise((resolve, reject) => {
    Servicecalls(
      "" +
      window.appUrl.ELN +
      "/Login/getCurrentUTCDate",
      {},
      (response) => {
        sessionStorage.setItem("currentDate", new Date(response));
        resolve(response);
      },
      (error) => {
        sessionStorage.setItem("currentDate", new Date());
        resolve(new Date());
      }
    );
  });
}

function updateOrderStatusCheck(ordercode, usercode) {
  let orderDetails = localStorage.getItem("_viewOrderDetail");
  if (
    orderDetails !== undefined &&
    orderDetails !== null &&
    orderDetails !== ""
  ) {
    let passObj = JSON.parse(orderDetails);
    if (passObj.length > 0) {
      passObj.map((x) => {
        if (
          Number(x.Batch) === Number(ordercode) &&
          Number(x.usercode) === Number(usercode)
        ) {
          Servicecalls(
            "" +
            window.appUrl.ELN +
            "/File/unlockorderOnViewClose",
            x,
            (response) => {
              localStorage.setItem("_viewOrderDetail", "");
            },
            (response) => {
              localStorage.setItem("_viewOrderDetail", "");
            }
          );
        }
        return x;
      });
    }
  }
}

function checkADSUser() {
  try {
    if (Number(sessionStorage.isadsuser) === 0) {
      return false;
    } else if (Number(sessionStorage.isadsuser)) {
      return true;
    }
  } catch (e) {
    return false;
  }
}

function filterfieldforfile(data) {
  const originaldata = data.map((object) => {
    const {
      filecode,
      filenameuser,

      fileversioncount = object.versioncout !== undefined &&
        object.versioncout !== null
        ? object.versioncout
        : 0,
      lsfileversion,

      createduser = object.createby !== null ? object.createby.username : "",
      status = object.approved === undefined &&
        object.rejected !== null &&
        object.rejected === 0
        ? "Created"
        : object.rejected !== null && object.rejected === 1
          ? "Rejected"
          : object.approved !== null && object.approved === 1
            ? "Approved"
            : "Inprogress",
      lssheetworkflowhistory,
      modifiedlist,
      createdate = object.createdate,
      modifiedby,
      createby,
      category,
      viewoption,
      approved,
      rejected,
      viewoptionstr,
    } = object;
    return {
      filecode,
      filenameuser,
      fileversioncount,
      lsfileversion,
      createduser,
      status,
      lssheetworkflowhistory,
      modifiedlist,
      createdateview: setDateAsuserDefined(
        convertUTCDateToLocalDate(
          createdate !== undefined ? new Date(createdate) : new Date()
        ),
        $.session.get("userDefinedDate")
      ),
      createdate,
      modifiedby,
      createby,
      category,
      viewoption,
      approved,
      rejected,
      viewoptionstr,
    };
  });

  return originaldata.filter((item) => item.approved === 1);
}

function OnConvertProtocolSteps(response, protocolMaster) {
  let protocol = {
    protocolname: protocolMaster.protocolmastername ? protocolMaster.protocolmastername : protocolMaster.protoclordername,
    protocolmastercode: protocolMaster.protocolmastercode ? protocolMaster.protocolmastercode : protocolMaster.protocolordercode,
    AI: {
      value: {
        data: []
      }
    },
    abstract: {},
    matrices: {},
    material: {},
    sections: [],
    result: {},
  };
  response.protocolstepLst.map((step) => {
    if ((protocolMaster.protocolmastercode && protocolMaster.protocolmastercode === step.protocolmastercode) || (protocolMaster.protocolordercode && protocolMaster.protocolordercode === step.protocolordercode)) {
      let value = step.lsprotocolstepInformation
        ? JSON.parse(step.lsprotocolstepInformation)
        : "";
      let newStep = {
        sectionno: "section " + step.stepno,
        sectionname: step.stepno + " section",
        steps: [
          {
            stepno: "step " + step.stepno,
            stepname: step.stepno + " step",
            editors: [
              {
                editorname: "editor1",
                editortype: "documenteditor",
                value:
                  value.protocolstepinfo !== null
                    ? value.protocolstepinfo
                    : value,
              },
            ],
            createddate: setDateAsuserDefined(
              step.createddate,
              $.session.get("userDefinedDate")
            ),
            createdby: step.createdbyusername,
            addfrom: Protocolscreenenum.protocoltemplate,
          },
        ],
        createddate: setDateAsuserDefined(
          step.createddate,
          $.session.get("userDefinedDate")
        ),
        createdby: step.createdbyusername,
        addfrom: Protocolscreenenum.protocoltemplate,
      };
      protocol.sections.push(newStep);
    }
    return step;
  });
  return protocol;
}


function compareProtocolDataChanges(a, b) {
  // Convert objects to JSON strings for comparison
  const aStr = JSON.stringify(a);
  const bStr = JSON.stringify(b);
  // Return true if the JSON strings are not equal (indicating changes)
  return aStr !== bStr;
}
function getHeight() {
  document.addEventListener('DOMContentLoaded', function () {
    const divElement = document.getElementById('.my-2 protocol-dropdown');
    if (divElement) {
      // Now you can safely use getBoundingClientRect on the divElement
      return divElement.getBoundingClientRect().height;
    } else {
      console.error("Element not found in the DOM");
    }
  });
}

export const sortDataByDate = (data, sortOrder) => [...data].sort((a, b) => {
  const getTimestamp = obj => obj.createdtimestamp || obj.createdate || obj.createdDate || obj.createdon || obj.createddate || obj.addedon;
  return sortOrder === 'asc' ? getTimestamp(a) - getTimestamp(b) : sortOrder === 'desc' ? getTimestamp(b) - getTimestamp(a) : 0;
});

// export const sortByDateCreated = (data, sortOrder) => {
//   return [...data].sort((a, b) => {
//     const parseDate = str => new Date(str).getTime();

//     const timeA = parseDate(a.dateCreated);
//     const timeB = parseDate(b.dateCreated);

//     if (sortOrder === 'asc') return timeA - timeB;
//     if (sortOrder === 'desc') return timeB - timeA;
//     return 0;
//   });
// };

// export const sortByDateCreated = (data, sortOrder) => {
//   const parseDate = (str) => {
//     if (!str) return 0;

//     // 1. Try native Date (works for UTC/GMT/ISO)
//     const d1 = new Date(str);
//     if (!isNaN(d1.getTime())) {
//       return d1.getTime();
//     }

//     let match;

//     // 2. Mon-DD-YYYY HH:mm:ss GMT+...
//     match = str.match(/^([A-Za-z]{3})-(\d{1,2})-(\d{4})\s+(\d{2}):(\d{2}):(\d{2})/);
//     if (match) {
//       const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
//       const [, mon, dd, yyyy, hh, mm, ss] = match;
//       return new Date(
//         parseInt(yyyy),
//         months.indexOf(mon),
//         parseInt(dd),
//         parseInt(hh),
//         parseInt(mm),
//         parseInt(ss)
//       ).getTime();
//     }

//     // 3. MM/DD/YY HH:mm:ss
//     match = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})\s+(\d{2}):(\d{2}):(\d{2})/);
//     if (match) {
//       const [, MM, dd, yyyy, hh, mm, ss] = match;
//       const fullYear = yyyy.length === 2 ? parseInt("20" + yyyy) : parseInt(yyyy);
//       return new Date(
//         fullYear,
//         parseInt(MM) - 1,
//         parseInt(dd),
//         parseInt(hh),
//         parseInt(mm),
//         parseInt(ss)
//       ).getTime();
//     }

//     // 4. YY/MM/DD HH:mm:ss
//     match = str.match(/^(\d{2,4})\/(\d{1,2})\/(\d{1,2})\s+(\d{2}):(\d{2}):(\d{2})/);
//     if (match) {
//       const [, yyyy, MM, dd, hh, mm, ss] = match;
//       const fullYear = yyyy.length === 2 ? parseInt("20" + yyyy) : parseInt(yyyy);
//       return new Date(
//         fullYear,
//         parseInt(MM) - 1,
//         parseInt(dd),
//         parseInt(hh),
//         parseInt(mm),
//         parseInt(ss)
//       ).getTime();
//     }

//     // 5. dd-MM-yy / dd-MM-yyyy HH:mm:ss
//     match = str.match(/^(\d{1,2})-(\d{1,2})-(\d{2,4})\s+(\d{2}):(\d{2}):(\d{2})/);
//     if (match) {
//       const [, dd, MM, yyyy, hh, mm, ss] = match;
//       const fullYear = yyyy.length === 2 ? parseInt("20" + yyyy) : parseInt(yyyy);
//       return new Date(
//         fullYear,
//         parseInt(MM) - 1,
//         parseInt(dd),
//         parseInt(hh),
//         parseInt(mm),
//         parseInt(ss)
//       ).getTime();
//     }

//     // Fallback → invalid date
//     return 0;
//   };

//   return [...data].sort((a, b) => {
//     const timeA = parseDate(a.dateCreated);
//     const timeB = parseDate(b.dateCreated);

//     if (sortOrder === "asc") return timeA - timeB;
//     if (sortOrder === "desc") return timeB - timeA;
//     return 0;
//   });
// };



export const sortByDateCreated = (data, sortOrder) => {
  const parseDate = (str) => {
    if (!str) return 0;

    // Handle dd-MM-yyyy HH:mm:ss GMT+H:mm format specifically
    const ddmmyyyyMatch = str.match(/^(\d{1,2})-(\d{1,2})-(\d{4})\s+(\d{2}):(\d{2}):(\d{2})\s+GMT([+-])(\d{1,2}):(\d{2})$/);
    if (ddmmyyyyMatch) {
      const [, day, month, year, hours, minutes, seconds, tzSign, tzHours, tzMinutes] = ddmmyyyyMatch;

      // Create UTC timestamp
      const utcDate = new Date(Date.UTC(
        parseInt(year),
        parseInt(month) - 1, // Month is 0-indexed
        parseInt(day),
        parseInt(hours),
        parseInt(minutes),
        parseInt(seconds)
      ));

      // Apply timezone offset
      const offsetMinutes = (parseInt(tzHours) * 60 + parseInt(tzMinutes));
      const offsetMs = offsetMinutes * 60 * 1000;

      // Subtract offset for positive timezone (GMT+), add for negative (GMT-)
      const finalTimestamp = tzSign === '+' ?
        utcDate.getTime() - offsetMs :
        utcDate.getTime() + offsetMs;

      return finalTimestamp;
    }

    // Handle dd-MM-yy HH:mm:ss GMT+H:mm format (2-digit year)
    const ddmmyyMatch = str.match(/^(\d{1,2})-(\d{1,2})-(\d{2})\s+(\d{2}):(\d{2}):(\d{2})\s+GMT([+-])(\d{1,2}):(\d{2})$/);
    if (ddmmyyMatch) {
      const [, day, month, yy, hours, minutes, seconds, tzSign, tzHours, tzMinutes] = ddmmyyMatch;
      const fullYear = parseInt("20" + yy);

      // Create UTC timestamp
      const utcDate = new Date(Date.UTC(
        fullYear,
        parseInt(month) - 1, // Month is 0-indexed
        parseInt(day),
        parseInt(hours),
        parseInt(minutes),
        parseInt(seconds)
      ));

      // Apply timezone offset
      const offsetMinutes = (parseInt(tzHours) * 60 + parseInt(tzMinutes));
      const offsetMs = offsetMinutes * 60 * 1000;

      // Subtract offset for positive timezone (GMT+), add for negative (GMT-)
      const finalTimestamp = tzSign === '+' ?
        utcDate.getTime() - offsetMs :
        utcDate.getTime() + offsetMs;

      return finalTimestamp;
    }

    // Try native Date parsing for other formats
    const nativeDate = new Date(str);
    if (!isNaN(nativeDate.getTime())) {
      return nativeDate.getTime();
    }

    // Mon-DD-YYYY HH:mm:ss TIMEZONE format
    const monddyyyyMatch = str.match(/^([A-Za-z]{3})-(\d{2})-(\d{4})\s+(\d{2}):(\d{2}):(\d{2})\s+GMT([+-])(\d{1,2}):(\d{2})$/);
    if (monddyyyyMatch) {
      const [, mon, day, year, hours, minutes, seconds, tzSign, tzHours, tzMinutes] = monddyyyyMatch;

      // Convert month name to number
      const months = {
        'Jan': 0, 'Feb': 1, 'Mar': 2, 'Apr': 3, 'May': 4, 'Jun': 5,
        'Jul': 6, 'Aug': 7, 'Sep': 8, 'Oct': 9, 'Nov': 10, 'Dec': 11
      };
      const monthIndex = months[mon];

      if (monthIndex !== undefined) {
        // Create UTC timestamp
        const utcDate = new Date(Date.UTC(
          parseInt(year),
          monthIndex,
          parseInt(day),
          parseInt(hours),
          parseInt(minutes),
          parseInt(seconds)
        ));

        // Apply timezone offset
        const offsetMinutes = (parseInt(tzHours) * 60 + parseInt(tzMinutes));
        const offsetMs = offsetMinutes * 60 * 1000;

        const finalTimestamp = tzSign === '+' ?
          utcDate.getTime() - offsetMs :
          utcDate.getTime() + offsetMs;

        return finalTimestamp;
      }
    }

    // MM/DD/YYYY and YYYY/MM/DD formats will be handled by native Date parsing above

    // fallback
    console.warn('Could not parse date:', str);
    return 0;
  };

  return [...data].sort((a, b) => {
    const timeA = parseDate(a.dateCreated);
    const timeB = parseDate(b.dateCreated);

    if (sortOrder === "asc") return timeA - timeB;
    if (sortOrder === "desc") return timeB - timeA;
    return 0;
  });
};



function reporttags(data, tags) {

  const tagvalues = tags?.map(tag => {
    const sheet = data.sheets.find((sheet, index) => index === tag.sheetindex);
    if (sheet) {
      const row = sheet.rows.find(row => row.index === tag.topLeftrow);
      if (row) {
        const cell = row.cells.find(cell => cell.index === tag.topLeftcol);
        if (cell) {
          return {
            tagname: tag.tagname,
            tagvalue: tag?.imgtag ? tag.tagvalue : (typeof cell.value === 'object' ? cell.value : checkAndFormatValue(cell).formattedValue) || null,
            tagsheetname: sheet.name,
            colindex: cell.index,
            rowindex: row.index,
            imgtag: tag?.imgtag ? true : false
          };
        }
      }
    }
    return tag;
  });
  // console.log(tagvalues);
  return tagvalues;
}

// function checkAndFormatValue(obj) {
//   const format = obj.format; // e.g., "0.000"
//   const value = obj.value;
//   if (!format) {
//     return { matches: true, formattedValue: value };
//   }
//   const decimalPlaces = format.includes(".") ? format.split('.')[1].length : 0;
//   let valueStr = value.toString();
//   if (!valueStr.includes(".")) {
//     valueStr += ".";
//   }
//   const [integerPart, fractionalPart = ""] = valueStr.split(".");
//   const adjustedFractionalPart = fractionalPart.padEnd(decimalPlaces, "0").substring(0, decimalPlaces);

//   if (adjustedFractionalPart === undefined || adjustedFractionalPart === null || adjustedFractionalPart.trim() === "") {
//     const formattedValue = `${integerPart}`;
//     const matches = value.toString() === formattedValue;

//     return { matches, formattedValue };
//   } else {
//     const formattedValue = `${integerPart}.${adjustedFractionalPart}`;
//     const matches = value.toString() === formattedValue;

//     return { matches, formattedValue };
//   }
// }

function checkAndFormatValue(obj) {
  const format = obj.format; // e.g., "0.000" or "0%"
  let value = obj.value;

  if (!format) {
    return { matches: true, formattedValue: value };
  }

  const isPercentage = format.includes('%');
  const cleanFormat = format.replace('%', '');

  // Determine decimal places from format
  const decimalPlaces = cleanFormat.includes(".") ? cleanFormat.split('.')[1].length : 0;

  // Apply percentage conversion if needed
  if (isPercentage) {
    value = parseFloat(value) * 100;
  }

  let valueStr = value?.toString();
  if (!valueStr?.includes(".")) {
    valueStr += ".";
  }

  const [integerPart, fractionalPart = ""] = valueStr?.split(".");
  const adjustedFractionalPart = fractionalPart.padEnd(decimalPlaces, "0").substring(0, decimalPlaces);

  if (adjustedFractionalPart === undefined || adjustedFractionalPart === null || adjustedFractionalPart.trim() === "") {
    let formattedValue = `${integerPart}`;
    let matches = value?.toString() === formattedValue;
    if (isPercentage) {
      formattedValue += "%";
    }
    return { matches, formattedValue };
  } else {
    let formattedValue = `${integerPart}.${adjustedFractionalPart}`;
    let matches = value?.toString() === formattedValue;
    if (isPercentage) {
      formattedValue += "%";
    }
    return { matches, formattedValue };
  }
}

function isNumberFormat(format) {
  if (!format) return false;

  // Match formats like: 0, 0.0, 0.00, 0.000, 0%, 0.00%, etc.
  return /^0(\.0+)?%?$/.test(format);
}

const updateActiveUserDetail = (lsactiveuser) => {
  const ELNurl = window.appUrl.ELN;
  Servicecalls("" + ELNurl + "/Login/updateActiveUserDetail", lsactiveuser, (response) => { }, (error) => { });
}

const sheetCache = {
  sheetIndex: null,
  sheet: null,
  targetSheetJSON: null
};

/**
 * Added by sathishkumar chandrasekar 08, August 2024
 * 
 * for performing get values from Multi tag return array * array || string
 * 
 * @param {*} rangeAddress 
 * @param {*} sheetName 
 * @returns [] | string
 */
const onSelectBatchTagContent = (kendoSpread, rangeAddress, sheetName, sheetIndex1, allFields) => {

  if (sheetCache.sheetIndex !== sheetIndex1) {
    console.log("Different");
    sheetCache.sheetIndex = sheetIndex1;
    sheetCache.sheet = kendoSpread.sheets()[sheetIndex1];
    sheetCache.targetSheetJSON = kendoSpread.toJSON().sheets[sheetIndex1];
  } else {
    console.log("Same");
  }

  const sheet = sheetCache.sheet;
  const targetSheetJSON = sheetCache.targetSheetJSON;

  // const sheet = kendoSpread.sheets()[sheetIndex];
  // const targetSheetJSON = kendoSpread.toJSON().sheets[sheetIndex];

  const contentRange = sheet.range(rangeAddress)?.select()?._sheet?._viewSelection.selection;
  const { topLeft, bottomRight } = contentRange;
  const { row: firstRow, col: firstCol } = topLeft;
  const { row: lastRow, col: lastCol } = bottomRight;

  const isSingleCell = firstRow === lastRow && firstCol === lastCol;

  // Cache merged cells
  const mergedCells = sheet._mergedCells;

  const rowsMap = new Map(targetSheetJSON.rows.map(row => [row.index, row]));
  let mergedRangeArray = [];

  const orderData = !isSingleCell && Array.from({ length: lastRow - firstRow + 1 }).map((_, rowIdx) => {
    const rowIndex = firstRow + rowIdx;
    const row = rowsMap.get(rowIndex);
    if (!row) return null;

    const rowData = Array.from({ length: lastCol - firstCol + 1 }).map((_, colIdx) => {
      const colIndex = firstCol + colIdx;
      const cellsMap = new Map(row.cells.map(cell => [cell.index, cell]));
      const cell = cellsMap.get(colIndex);

      if (!cell) return "";

      const tag = cell.tag ? (cell._parsedTag || (cell._parsedTag = JSON.parse(cell.tag))) : undefined;
      const cellValue = cell.value;

      const isPlaceholder = tag && tag.fieldname && cellValue === `[${tag.fieldname}]`;
      const isKnownField = allFields.includes(cellValue);
      const isValueCode = cellValue && cellValue.code === 'VALUE';

      const mergedRange = mergedCells.find(range =>
        range.topLeft.row <= rowIndex && range.bottomRight.row >= rowIndex &&
        range.topLeft.col <= colIndex && range.bottomRight.col >= colIndex
      );

      const isRangePresent = mergedRangeArray.some(cell =>
        mergedRange && cell && cell.range &&
        cell.range.topLeft.row === mergedRange.topLeft.row &&
        cell.range.topLeft.col === mergedRange.topLeft.col &&
        cell.range.bottomRight.row === mergedRange.bottomRight.row &&
        cell.range.bottomRight.col === mergedRange.bottomRight.col
      );

      if (!isRangePresent) {
        if (mergedRange) {
          mergedRangeArray.push({ range: mergedRange });
          const mergedCell = rowsMap.get(mergedRange.topLeft.row)?.cells.find(cell => cell.index === mergedRange.topLeft.col);
          if (mergedCell) {
            if (cellValue === undefined || isValueCode) return "";
            return mergedCell.format && !isNaN(Number(mergedCell.value))
              ? formatValue(mergedCell.value, mergedCell.format)
              : mergedCell.value;
          }
          return "";
        } else {
          if (cellValue === undefined || isPlaceholder || isKnownField || isValueCode) return "";
          return cell.format && !isNaN(Number(cellValue))
            ? formatValue(cellValue, cell.format)
            : cellValue;
        }
      }
      return null;
    });

    return rowData.some(item => item !== undefined && item !== null) ? rowData : null;
  }).filter(rowData => rowData !== null);

  if (!orderData) {
    return false;
  } else {
    const removeNullAndUndefined = (arr) => arr.map(subArray => subArray.filter(item => item !== undefined && item !== null));
    const transformArray = (arr) => (Array.isArray(arr) && arr.length === 1 && Array.isArray(arr[0]) && arr[0].length === 1)
      ? arr[0][0]
      : JSON.stringify(arr);

    let returnArray = removeNullAndUndefined(orderData);
    return transformArray(returnArray);
  }
};

const formatValue = (value, format) => {
  if (value !== undefined && value !== null && value !== "") {
    const decimalPlaces = format.replace(/[^0]/g, '').length - 1;
    return value.toFixed(decimalPlaces);
  } else {
    return "";
  }
}

/**
 * Set/update tag values for multi‑tag cases.
 * @param {*} tagvalues 
 * @param {*} tag 
 * @param {*} tagResult 
 * @returns updated array of tagvalues
 */
const setTagValuesOnMulti = (tagvalues, tag, tagResult) => {
  return tagvalues?.map(item => {
    if (item && item.tagname === tag.tagname) {
      item.tagvalue = tagResult;
      item.ismultitag = 1;
    }
    return item;
  });
};

/**
 * Update tag values for each tag based on multi‑tag selection content using reduce instead of a for‑loop.
 * @param {*} tags
 */
const getRangeValuesType = (sheetdata, tags, passObjDet, tagvalues, allFields, originTagValues) => {

  const updatedTagValues = tags.reduce((acc, tag) => {

    if (sheetCache.sheetIndex !== tag.tagsheetindex) {
      console.log("Different");
      sheetCache.sheetIndex = tag.tagsheetindex;
      sheetCache.sheet = sheetdata.sheets()[tag.tagsheetindex];
      sheetCache.targetSheetJSON = sheetdata.toJSON().sheets[tag.tagsheetindex];
    } else {
      console.log("Same");
    }

    const tagResult = onSelectBatchTagContent(sheetdata, tag.selectionAddress, tag.tagsheetname, tag.tagsheetindex, allFields);
    return tagResult !== false
      ? setTagValuesOnMulti(acc, tag, tagResult)
      : acc;
  }, tagvalues);

  let updatedArray = originTagValues.map(item => {
    const match = updatedTagValues.find(item1 => item1 && item1?.tagname === item && item?.tagname);
    if (match) {
      return match;
    }
    return item;
  });

  passObjDet.tagvalues = JSON.stringify(updatedArray);

  return passObjDet;
};

function exportToCSV(apiData, fileName) {
  const ws = XLSX.utils.json_to_sheet(apiData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
  FileSaver.saveAs(data, fileName + ".xlsx");
};

// function exporttranslationsToCSV() {
//   let apiData = [];
//   let fileName = "translations"
//   const ws = XLSX.utils.json_to_sheet(apiData);
//   const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
//   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//   const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
//   FileSaver.saveAs(data, fileName + ".xlsx");
// };

const ProtocolHistory = (props) => {

  const [activeTab, setActiveTab] = useState(props.state.activeTab ? props.state.activeTab : 1);
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const FilterType = [
    {
      id: 1,
      type: props.props.t("Dashboard.IDS_LBL_FILTERBYCURRENTDATE")
    },
    {
      id: 2,
      type: props.props.t("Dashboard.IDS_LBL_FILTERBY7DAYS")
    },
    {
      id: 3,
      type: props.props.t("Dashboard.IDS_LBL_FILTERBY30DAYS")
    },
    {
      id: 4,
      type: props.props.t("Dashboard.IDS_LBL_FILTERBYCUSTOMDATE")
    },
  ];

  const currnetthis = props.getThis();


  return (
    <>
      <Modal
        isOpen={props.isexpand}
        className="modal-md smallPopup  screen-centered-scroll protocol-history template-history"
      >
        <div className="modal-header">
          <h5 className="modal-title" id="staticBackdropLabel">
            {props.screentype === 1 ? props.props.t("Templates.Protocoltemplates.IDS_LBL_TEMPHISTORY", { param: "" }) : props.props.t("Orders.Protocolorders.IDS_LBL_ORDERHISTORY")}
          </h5>
          <button
            type="button"
            className="btn_white_bg"
            data-dismiss="modal"
            aria-label="Close"
            onClick={props.onClose}
          >
            <i className="fas fa-times" aria-hidden="true"></i>
          </button>

        </div>
        <ModalBody >

          <div className="row w-100 align-items-center mb-2">
            <span className="col-3 filter-table text-left m-0">{props.props.t("Dashboard.IDS_LBL_FILTERBY")}</span>
            <KendoCombobox
              initialValue=""
              id="protocol-history-date"
              Datasource={FilterType}
              DefaultValue={props.state.selecteddatevalue ? props.state.selecteddatevalue : FilterType[0]}
              value={props.state.selecteddatevalue ? props.state.selecteddatevalue : FilterType[0]}
              onvaluechange={props.handleChange}
              ValueMember="id"
              DisplayMember="type"
              allowCustom={true}
              additionalclass={"clshideclearbutton col-6"}
            />
          </div>

          {props.state.selecteddatevalue?.id === 4 ?
            (<div className="shadow-box filter-date-group">
              <div className="flex-form-group padding-align-form disable-callendar-input">
                <label htmlFor="inputText">
                  {props.props.t("Dashboard.IDS_LBL_FILTERFROMDATE")}
                </label>
                <Suspense fallback={<div></div>}>
                  <KendoDatepicker
                    DefaultValue={props.state.OnKendoDateFrom}
                    onDatachanges={props.OnHistoryfromDatachange}
                  // maxdate={new Date(this.state.OnKendoDateTo)}
                  />
                </Suspense>
              </div>
              <div className="flex-form-group padding-align-form disable-callendar-input">
                <label htmlFor="inputText">
                  {props.props.t("Dashboard.IDS_LBL_FILTERTO")}
                </label>
                <Suspense fallback={<div></div>}>
                  <KendoDatepicker
                    DefaultValue={props.state.OnKendoDateTo}
                    onDatachanges={props.OnHistorytoDatachange}
                  // mindate={new Date(this.state.OnKendoDateFrom)}

                  />
                </Suspense>
              </div>
              <div className="d-flex align-items-end flex-column bd-highlight mb-3">
                <button
                  className="mg-l-1 btn btn-primary-blue active"
                  onClick={props.ondatefilterreset}
                >
                  {props.props.t("Orders.Sheetorders.IDS_LBL_RESET")}
                </button>
              </div>
            </div>) : ''
          }
          {/* <div className={props?.props?.dataItem?.assignedto !== undefined ? "assigned" : null}>
            <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className={`nav-item ${activeTab === 1 ? 'active' : ''}`} role="presentation">
                <a className="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true"
                  onClick={() => handleTabClick(1)}
                >
                  {props.props.t(
                    "Templates.Protocoltemplates.IDS_LBL_VERSIONHIS",
                    { param: "" }
                  )}
                </a>
              </li>
              <li className={`nav-item ${activeTab === 2 ? 'active' : ''}`} role="presentation">
                <a className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false"
                  onClick={() => handleTabClick(2)}
                >
                  {props.props.t(
                    "Templates.Protocoltemplates.IDS_LBL_TRANS",
                    {
                      param: "",
                    }
                  )}
                </a>
              </li>
              {props.props?.dataItem?.assignedto === undefined ?
                <li className={`nav-item ${activeTab === 3 ? 'active' : ''}`} role="presentation">
                  <a className="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false"
                    onClick={() => handleTabClick(3)}
                  >
                    {props.props.t(
                      "Templates.Protocoltemplates.IDS_LBL_WORKF",
                      {
                        param: "",
                      }
                    )}
                  </a>
                </li> : ""}
            </ul>
          </div> */}
          <div>
            <div
              className={`tab-pane ${activeTab === 1 ? 'active' : ''}`}
              id="tab1"
            >
              <div className="popup-group-list-inner" >
                <KendoGridView
                  enableTooltip={true}
                  primaryKey={"id"}
                  source={props.state.screenHistoryDatas}
                  Columns={props.state.transactionscolumn}
                  DataSearchvisible={false}
                  ShowDetailsVisible={false}
                  height="calc(100vh - 165px)"
                />
              </div>
            </div>
          </div>
          {/* <div className="tab-content" id="myTabContent">
            <div className={`tab-pane ${activeTab === 1 ? 'show active' : ''}`} id="home" role="tabpanel" aria-labelledby="home-tab">
              <ul className="list-group list-group-flush">
                <li
                  className="list-group-item"
                  aria-disabled="true"
                >
                  <KendoGridView
                    enableTooltip={true}
                    primaryKey={props.screentype === 2 ? "protocolorderversioncode" : "protocolversioncode"}
                    source={props.state.versiondata && props.state.versiondata.length !== 0 ? props.state.versiondata : []}
                    Columns={props.versioncolumn}
                    DataSearchvisible={false}
                    ShowDetailsVisible={false}
                    height="calc(100vh - 165px)"
                  />
                </li>
              </ul>

            </div>
            <div className={`tab-pane fade ${activeTab === 2 ? 'show active' : ''}`} id="profile" role="tabpanel" aria-labelledby="profile-tab">
              <ul className="list-group list-group-flush">
                <li
                  className="list-group-item"
                  aria-disabled="true"
                >
                  <KendoGridView
                    enableTooltip={true}
                    primaryKey={props.screentype === 1 ? "protocolmastercode" : "protocolorderstephistorycode"}
                    source={props.screen === "protocolordereyeview" || props.screen === "protocolorderview" ? props.state.protocoltransactionhistory : props.state.transactionhistory ? props.state.transactionhistory : []}
                    Columns={props.transactionscolumn}
                    DataSearchvisible={false}
                    ShowDetailsVisible={false}
                    height="calc(100vh - 165px)"
                  />
                </li>
              </ul>


            </div>
            <div className={`tab-pane fade ${activeTab === 3 ? 'show active' : ''}`} id="contact" role="tabpanel" aria-labelledby="contact-tab">
              {props.state.lsprotocolworkflowhistory !== undefined &&
                props.state.lsprotocolworkflowhistory.length > 0 ? (
                props.screen === "protocolview" ? currnetthis.formatworkflowdetails(props.state.lsprotocolworkflowhistory, currnetthis.props) :
                  props.screen === "protocoleye" ? currnetthis.formatProtocolTemplateWorkflowHistoryDetails() : ("")) : ("")}
              {
                props.screen === "protocolordereyeview" ? currnetthis.formatworrkflowhistorydetails() : props.screen === "protocolorderview" ? currnetthis.formatworkflowdetails() : ""
              }
            </div>

          </div> */}
        </ModalBody>
      </Modal >
    </>
  )
}

function toDateFilter(todate) {
  todate = GetutcDateoncurenttime(todate);
  todate.setHours(23);
  todate.setMinutes(59);
  todate.setSeconds(59);
  return todate;
}

function checkFormulaUndefinedInSheet(sheetdata) {
  let isFormula = true;
  sheetdata?.sheets?.map((sheet) => {
    sheet?.rows?.map((row) => {
      row?.cells?.map((cell) => {
        if (cell.formula) {
          let isArray = typeof cell.formula != "string";
          // let isForumula1 = isArray ? cell?.formula?.src ? true : false : true;
          // if (!isFormula1) {
          //   isFormula = false;
          // }

          let formulaStr = isArray ? "" : cell.formula;
          if (!isArray) {
            isFormula = true;
            cell.formulaStr = formulaStr;
          } else {
            cell.formula = cell.formulaStr;
            isFormula = true;
          }
        }
        return cell;
      })
      return true;
    })
    return true;
  })
  return { isFormula, sheetdata };
}

function LogoutSessionClear() {
  const sessionKeys = [
    'UserMail', 'tenantcode', 'loginfrom', 'loggedfrom', 'Userteam', 'packagetype',
    'licencetype', 'idletime', 'Usersite', 'sSiteCode', 'name', 'multiusergroups',
    'usergroupname', 'Userprojects', 'teamusercode', 'tenantid', 'unifieduserid',
    'Usersitename', 'Userfullname', 'ServerDateFormat', 'LoginTime', 'userDefinedDate',
    'Username', 'Userworkflows', 'User', 'activeUserId', 'userpasscodeencrypted',
    'Token', 'noofusers', 'usergroupstatus', 'Protocol_Userworkflows', 'Days', 'spreadconfig'
  ];
  sessionKeys.forEach(key => sessionStorage.removeItem(key));
  if (isMultitenant === 2) {
    localStorage.clear()
  }
  localStorage.removeItem("elnLoginSiteCode");
  localStorage.removeItem("elnLoginSiteName");
}

const Onsaveactivewidgetsdata = (Passdata) => {
  let ELNurl = window.appUrl.ELN;
  Passdata.cancelstatus = 0;
  Servicecalls(
    "" + ELNurl + "/DashBoard/Onsaveactivewidgetsdata",
    Passdata,
    () => { },
    () => { }
  );
}
function ChecktrialFileuploadsize(files) {
  let size = 200 * 1024 * 1024;
  // let err = [];
  for (var x = 0; x < files.length; x++) {
    if (files[x].size > size && isMultitenant === 2) {
      return true;
    }
  }
  return false;
}

function getReportModuleRights(screen) {
  if (screen === "Reportviewer") {
    let saveRights = ControlRightsOnOrdersTask("IDS_SCN_REPORTVIEVER", "IDS_TSK_SAVE");
    let settingRights = ControlRightsOnOrdersTask("IDS_SCN_REPORTVIEVER", "IDS_TSK_SETTINGS");
    let newFolderRights = ControlRightsOnOrdersTask("IDS_SCN_REPORTVIEVER", "IDS_SCN_REPORTVIEWERNEWFOLDER");

    let save = saveRights.UserGroupRights.rights;
    let settings = settingRights.UserGroupRights.rights;
    let newFolder = newFolderRights.UserGroupRights.rights;

    const rtnObj = {
      save: save,
      settings: settings,
      newFolder: newFolder
    };

    return rtnObj;
  } else {
    let saveRights = ControlRightsOnOrdersTask("IDS_SCN_REPORTS", "IDS_TSK_SAVE");
    let insertRights = ControlRightsOnOrdersTask("IDS_SCN_REPORTS", "IDS_TSK_INSERT");
    let newFolderRights = ControlRightsOnOrdersTask("IDS_SCN_REPORTS", "IDS_SCN_REPORTDESIGNERNEWFOLDER");

    let save = saveRights.UserGroupRights.rights;
    // let save = true;
    let insert = insertRights.UserGroupRights.rights;
    let newFolder = newFolderRights.UserGroupRights.rights;

    const rtnObj = {
      save: save,
      insert: insert,
      newFolder: newFolder
    };

    return rtnObj;
  }
}

function getModuleRihtsOnModuleLoad(key) {
  let isRightsSetted = false;
  let modelLst = modelList();
  let returnObj = false;

  const records = modelLst.modelLst[key];
  if (!isRightsSetted && records && Array.isArray(records)) {
    // console.log(`Records for ${key}:`);
    records.forEach(record => {
      if (!isRightsSetted) {
        isRightsSetted = SubMenuRightsonScreenViews(record?.accordianNavTitle, record?.name, record?.supscreen);
        if (isRightsSetted) {
          returnObj = isRightsSetted;
        }
      }
    });
  }

  return returnObj;
}

function onGetUserControlRightsFolderstructure(screen) {

  console.log(screen)

  if (screen === "Sheet") {
    let dueDateRights = ControlRightsOnOrdersTask("IDS_SCN_SHEETORDERS", "IDS_TSK_DUEDATE");
    let auotoRegRights = ControlRightsOnOrdersTask("IDS_SCN_SHEETORDERS", "IDS_TSK_AUTOREGORDER");
    let newFolderRights = ControlRightsOnOrdersTask("IDS_SCN_SHEETORDERS", "IDS_TSK_FOLDERCREATION");
    let projectteamRights = ControlRightsOnOrdersTask("IDS_SCN_SHEETORDERS", "IDS_TSK_PROJECTTEAM");
    let registerRights = ControlRightsOnOrdersTask("IDS_SCN_SHEETORDERS", "IDS_TSK_REGISTER");

    let dueDate = dueDateRights.UserGroupRights.rights;
    let auotoReg = auotoRegRights.UserGroupRights.rights;
    let newFolder = newFolderRights.UserGroupRights.save;
    let projectteam = projectteamRights.UserGroupRights.rights;
    let regRights = registerRights.UserGroupRights.rights;

    const rtnObj = {
      dueDate: dueDate,
      auotoReg: auotoReg,
      newFolder: newFolder,
      projectteam: projectteam,
      newTempRights: true,
      register: regRights
    };

    return rtnObj;
  } else if (screen === "Reportviewer") {
    let dueDateRights = ControlRightsOnOrdersTask("IDS_SCN_REPORTVIEVER", "IDS_TSK_DUEDATE");
    let auotoRegRights = ControlRightsOnOrdersTask("IDS_SCN_REPORTVIEVER", "IDS_TSK_AUTOREGORDER");
    let newFolderRights = ControlRightsOnOrdersTask("IDS_SCN_REPORTVIEVER", "IDS_SCN_REPORTVIEWERNEWFOLDER");
    let newTemplateRights = ControlRightsOnOrdersTask("IDS_SCN_REPORTVIEVER", "IDS_TSK_NEWTEMPLATER");

    let dueDate = dueDateRights.UserGroupRights.rights;
    let auotoReg = auotoRegRights.UserGroupRights.rights;
    let newFolder = newFolderRights.UserGroupRights.save;
    let newTempRights = newTemplateRights.UserGroupRights.rights;

    const rtnObj = {
      dueDate: dueDate,
      auotoReg: auotoReg,
      newFolder: newFolder,
      newTempRights: newTempRights,
      projectteam: true,
      register: true
    };

    return rtnObj;
  } else if (screen === "Reportdesigner") {
    let dueDateRights = ControlRightsOnOrdersTask("IDS_SCN_REPORTS", "IDS_TSK_DUEDATE");
    let auotoRegRights = ControlRightsOnOrdersTask("IDS_SCN_REPORTS", "IDS_TSK_AUTOREGORDER");
    let newFolderRights = ControlRightsOnOrdersTask("IDS_SCN_REPORTS", "IDS_SCN_REPORTDESIGNERNEWFOLDER");
    let newTemplateRights = ControlRightsOnOrdersTask("IDS_SCN_REPORTS", "IDS_TSK_NEWTEMPLATE");

    let dueDate = dueDateRights.UserGroupRights.rights;
    let auotoReg = auotoRegRights.UserGroupRights.rights;
    let newFolder = newFolderRights.UserGroupRights.save;
    let newTempRights = newTemplateRights.UserGroupRights.rights;

    const rtnObj = {
      dueDate: dueDate,
      auotoReg: auotoReg,
      newFolder: newFolder,
      newTempRights: newTempRights,
      projectteam: true,
      register: true
    };

    return rtnObj;
  } else {
    let dueDateRights = ControlRightsOnOrdersTask("IDS_SCN_PROTOCOLORDERS", "IDS_TSK_DUEDATE");
    let auotoRegRights = ControlRightsOnOrdersTask("IDS_SCN_PROTOCOLORDERS", "IDS_TSK_AUTOREGORDER");
    let newFolderRights = ControlRightsOnOrdersTask("IDS_SCN_PROTOCOLORDERS", "IDS_TSK_FOLDERCREATIONPROTOCOL");
    let projectteamRights = ControlRightsOnOrdersTask("IDS_SCN_PROTOCOLORDERS", "IDS_TSK_PROJECTTEAM");
    let registerRights = ControlRightsOnOrdersTask("IDS_SCN_PROTOCOLORDERS", "IDS_TSK_REGISTER");

    let dueDate = dueDateRights.UserGroupRights.rights;
    let auotoReg = auotoRegRights.UserGroupRights.rights;
    let newFolder = newFolderRights.UserGroupRights.save;
    let projectteam = projectteamRights.UserGroupRights.rights;
    let regRights = registerRights.UserGroupRights.rights;

    const rtnObj = {
      dueDate: dueDate,
      auotoReg: auotoReg,
      newFolder: newFolder,
      projectteam: projectteam,
      newTempRights: true,
      register: regRights
    };

    return rtnObj;
  }
}

function compareJSONArrays(ExistContent, NewContent) {
  if (ExistContent.length !== NewContent.length) {
    return true;
  }
  for (let i = 0; i < ExistContent.length; i++) {
    const item1 = ExistContent[i];
    const item2 = NewContent[i];

    if (typeof item1 === 'object' && typeof item2 === 'object') {
      if (compareJSONObjects(item1, item2)) {
        return true;
      }
    } else if (item1 !== item2) {
      return true;
    }
  }

  return false;
}

function compareJSONObjects(ExistContent, NewContent) {
  if (ExistContent == null || NewContent == null) {
    return false;
  }
  const keys1 = Object.keys(ExistContent);
  const keys2 = Object.keys(NewContent);

  if (keys1.length !== keys2.length) {
    return true;
  }

  for (let key of keys1) {
    const val1 = ExistContent[key];
    const val2 = NewContent[key];

    if (Array.isArray(val1) && Array.isArray(val2)) {
      if (compareJSONArrays(val1, val2)) {
        return true;
      }
    } else if (typeof val1 === 'object' && typeof val2 === 'object') {
      if (compareJSONObjects(val1, val2)) {
        return true;
      }
    } else if (val1 !== val2) {
      return true;
    }
  }

  return false;
}

const fetchInstalledPrinters = async (alert) => {
  let printdevices = [];
  let printdevice = '';
  let ELNurl = window.appUrl.ELN;
  Servicecalls(
    "" + ELNurl + "/Barcode/getprinterdetails",
    {},
    (res) => {
      this.setState({ printdevices: res, printdevice: res && res.length > 0 && res[0] });

    },
    (res) => { }
  );

  return { printdevices, printdevice };

};

const readFileAsText = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsText(file);
  });
};



const sendPrintRequest = (printerName, fileString, props) => {
  if (!fileString || !printerName) {
    alert("Please select file content and a printer.");
    return { success: false, message: "Missing file content or printer" };
  }

  const blob = new Blob([fileString], { type: 'text/plain' });

  const data = new FormData();
  data.append("file", blob);
  data.append("usercode", sessionStorage.getItem("User"));
  data.append("printer", printerName);
  data.append("isMultitenant", isMultitenant);

  Servicecallsforwithougzip(window.appUrl.ELN + "/Barcode/insertprintjob", data, (res) => { props.alert.success("Print Queued successfully") }, (res) => { });
};

function BarcodeDesign(props) {
  const [barcodeurl, setBarcodeurl] = useState(undefined);
  const [height, setHeight] = useState(4);
  const [width, setWidth] = useState(6);
  const [printDensity, setPrintDensity] = useState({ value: "8dpmm", display: "8dpmm" });
  const [printDensityList, setPrintDensityList] = useState([
    { value: "6dpmm", display: "6dpmm" },
    { value: "8dpmm", display: "8dpmm" },
    { value: "12dpmm", display: "12dpmm" },
    { value: "24dpmm", display: "24dpmm" }]);

  const barcodes = props.selectedMaterialInventoryFile && props.selectedMaterialInventoryFile.materialtype && props.selectedMaterialInventoryFile.materialtype.lstbarcodes ?
    props.selectedMaterialInventoryFile.materialtype.lstbarcodes.map(bar => { return bar.barcode }) : props.selectedSamplelnventoryFile && props.selectedSamplelnventoryFile.sampletype
      && props.selectedSamplelnventoryFile.sampletype.lstbarcodes ? props.selectedSamplelnventoryFile.sampletype.lstbarcodes.map(bar => { return bar.barcode }) :
      props.selectedSamples && props.selectedSamples.length > 0 && props.selectedSamples[0].sampletype.lstbarcodes ? props.selectedSamples[0].sampletype.lstbarcodes.map(bar => { return bar.barcode }) :
        props.BarcodeMasterList?.length > 0 ? props.BarcodeMasterList : [];

  const [selectedbarcode, setSelectedbarcode] = useState(barcodes && barcodes.length > 0 ? barcodes[0] : undefined);

  useEffect(() => {

    if (props.barcodeurl !== undefined && props.barcodeurl !== "") {
      if (props.passobject) {
        let object = props.passobject;
        object.density = printDensity.value;
        object.height = height;
        object.width = width;
        fetchBarcode(props.barcodeurl, 'POST', object);
      } else {
        let url = props.barcodeurl + "/" + printDensity.value + "/" + height + "/" + width;
        fetchBarcode(url, 'GET');
      }
    }
    // else if (props.Screen === undefined && props.Screen === "SheetOrder") {
    //   setBarcodeurl(props.barcodeurl)
    // }
  }, [props.barcodeurl, props.passobject, selectedbarcode, printDensity.value, height, width])

  const onBarChange = (value) => {
    setSelectedbarcode(value);
    if (props.OnBarcodeChangeevent !== undefined) {
      props.OnBarcodeChangeevent(value, barcodes);
    }
  }

  const fetchBarcode = async (url, method, body) => {
    try {
      url = props.Screen !== undefined && props.Screen !== "SheetOrder" ? url.replace("$barcode$", selectedbarcode.barcodeno.toString()) : url;
      const response = await fetch(url, {
        method: method,
        headers: new Headers({
          Authorization: sessionStorage.getItem("Token"),
          "X-TenantID": sessionStorage.getItem("tenantid"),
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
        body: body ? JSON.stringify(body) : null,
      });

      if (response.ok) {
        const blob = await response.blob();
        const objectURL = window.URL.createObjectURL(blob);
        setBarcodeurl(objectURL);
      } else {
        console.error('Failed to fetch barcode:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching barcode:', error);
    }
  };

  const onPrintDensityChange = (value) => {
    setPrintDensity(value);
    if (props.barcodeurl !== undefined && props.barcodeurl !== "") {
      if (props.passobject) {
        let object = props.passobject;
        object.density = value.value;
        object.height = height;
        object.width = width;
        fetchBarcode(props.barcodeurl, 'POST', object);
      } else {
        let url = props.barcodeurl + "/" + value.value + "/" + height + "/" + width;
        fetchBarcode(url, 'GET');
      }
    }
  }

  const onHeightChange = (e) => {
    setHeight(e.target.value);

    if (props.barcodeurl !== undefined && props.barcodeurl !== "") {
      if (props.passobject) {
        let object = props.passobject;
        object.density = printDensity.value;
        object.height = e.target.value;
        object.width = width;
        fetchBarcode(props.barcodeurl, 'POST', object);
      } else {
        let url = props.barcodeurl + "/" + printDensity.value + "/" + e.target.value + "/" + width;
        fetchBarcode(url, 'GET');
      }
    }
  }

  const onWidthChange = (e) => {
    setWidth(e.target.value);

    if (props.barcodeurl !== undefined && props.barcodeurl !== "") {
      if (props.passobject) {
        let object = props.passobject;
        object.density = printDensity.value;
        object.height = height;
        object.width = e.target.value;
        fetchBarcode(props.barcodeurl, 'POST', object);
      } else {
        let url = props.barcodeurl + "/" + printDensity.value + "/" + height + "/" + e.target.value;
        fetchBarcode(url, 'GET');
      }
    }
  }

  const onfiledownload = (name) => {
    if (props.barcodeurl !== undefined && props.barcodeurl !== "") {
      FileSaver.saveAs(barcodeurl, name);
    }
  }

  const ongeneratePDF = (name) => {
    if (props.barcodeurl !== undefined && props.barcodeurl !== "") {
      const doc = new jsPDF();
      doc.addImage(barcodeurl, 'png', 0, 0, 0, 0);
      doc.save(name);
    }
  };
  const setValueOnScreen = (value) => {
    if (value !== undefined && value !== null && value.toString().trim() !== "") {
      return value;
    } else {
      return "-";
    }
  };

  const formatStaticData = (staticData) => {
    if (staticData !== undefined && staticData !== null) {

      const propertiesToExtract =
        [
          { 'Material ID': 'sequenceid' },
          { 'Material Name': 'smaterialname' },
          { 'Material Category': 'materialtype.smaterialtypename' },
          { 'Material Type': 'materialcategory.smaterialcatname' },
          // { 'Basic Unit': 'unit.sunitname' },
          { 'Status': 'displaystatus' },
          { 'Created On': 'sDate' },
          { 'Modified By': 'modifiedby' },
          { 'Last Modified': 'mDate' }
        ];

      let staticArray = [];

      propertiesToExtract.forEach(property => {
        const key = Object.keys(property)[0];
        if (key === 'Material Name' || key === 'Material Type' || key === 'Last Modified' || key === 'Created On' || key === 'Status' || key === "Material Category") {
          let obj = {};
          if (key === 'Material Type') {
            obj = { 'fieldname': key, 'value': staticData.materialtype !== undefined && staticData.materialtype !== null ? staticData.materialtype.smaterialtypename : "-" };
          } else if (key === 'Created On') {
            obj = { 'fieldname': key, 'value': staticData.createddate !== undefined && staticData.createddate !== null ? setDateAsuserDefined(convertUTCDateToLocalDate(new Date(staticData.createddate)), sessionStorage.userDefinedDate) : "-" };
          } else if (key === 'Last Modified') {
            obj = { 'fieldname': key, 'value': staticData.modifieddate !== undefined && staticData.modifieddate !== null ? setDateAsuserDefined(convertUTCDateToLocalDate(new Date(staticData.modifieddate)), sessionStorage.userDefinedDate) : "-" };
          } else if (key === 'Modified By') {
            obj = { 'fieldname': key, 'value': staticData.modifiedby !== undefined && staticData.modifiedby !== null ? staticData?.modifiedby : "-" };
          } else if (key === 'Material Name') {
            obj = { 'fieldname': key, 'value': staticData.smaterialname !== undefined && staticData.smaterialname !== null ? staticData.smaterialname : "-" };
          } else if (key === 'Status') {
            obj = { 'fieldname': key, 'value': staticData.nstatus !== undefined && staticData.nstatus !== null ? staticData.nstatus === 1 ? "Active" : "Retired" : "-" };
          } else if (key === 'Material Category') {
            obj = { 'fieldname': key, 'value': staticData.materialcategory !== undefined && staticData.materialcategory !== null ? staticData.materialcategory.smaterialcatname : "-" };
          } else {
            obj = { 'fieldname': key, 'value': staticData.createby !== undefined && staticData.createby !== null ? staticData.createby.username : "-" };
          }
          staticArray.push(obj);
        } else {
          const value = staticData[property[key]];
          let obj = { 'fieldname': key, 'value': value };
          staticArray.push(obj);
        }
      });

      return (
        <div>
          <Row>
            {staticArray?.map((staticValue, index) => (
              <Col md={12} key={index}>
                <FormGroup>
                  {/* <FormLabel>{this.props.t("Inventory." + staticValue.fieldname, { param: "", })}</FormLabel> */}
                  <FormLabel>{staticValue.fieldname}</FormLabel>
                  <ReadOnlyText>{setValueOnScreen(staticValue?.value)}</ReadOnlyText>
                </FormGroup>
              </Col>
            ))}
          </Row>
        </div>
      )
    }
  }



  const formatMaterialDynamicData = (dynamicValues) => {
    if (dynamicValues && dynamicValues.length > 0) {
      return (
        <Row>
          {dynamicValues.map((dynamicValue, index) => (
            <Col md={12} key={index}>
              <FormGroup>
                <FormLabel>{dynamicValue.fieldname}</FormLabel>
                <ReadOnlyText>
                  {dynamicValue.datatypevalue === "Combo box" || dynamicValue.datatypevalue === "Dropdown"
                    ? (dynamicValue.value
                      ? (dynamicValue.value.value !== undefined
                        ? setValueOnScreen(dynamicValue?.value?.value)
                        : setValueOnScreen(dynamicValue?.value))
                      : "")
                    : setValueOnScreen(dynamicValue?.value || "")}
                </ReadOnlyText>
              </FormGroup>
            </Col>
          ))}
        </Row>
      );
    }
    return null;
  };



  const selectedFile = props?.selectedMaterialInventoryFile;
  let materialfields = selectedFile?.jsondata !== undefined && selectedFile?.jsondata !== null &&
    JSON.parse(selectedFile?.jsondata) !== undefined && JSON.parse(selectedFile?.jsondata) !== null
    ? JSON.parse(selectedFile?.jsondata) : []
  let dynamicfields = [];
  materialfields.dynamicfields !== undefined && materialfields?.dynamicfields?.map((item) => {
    if (item.used === undefined || item.used === true) {
      item.used = true;
      dynamicfields.push(item);
    }
    return item;
  });

  if (!dynamicfields || dynamicfields?.length >= 0) {
    materialfields?.sections && materialfields?.sections.map(sec => {
      sec.df && sec.df.map((item) => {
        if (item.used === undefined || item.used === true) {
          item.used = true;
          dynamicfields.push(item);
        }
        return item;
      });
      return sec
    });
  }

  return (<Modal isOpen={props.show} className="screen-centered-scroll inventory-modal transaction-history">
    <div className="modal-header">
      <h5 className="modal-title" id="staticBackdropLabel">
        {props.Screen === "SheetOrder" ? props.t("Orders.Sheetorders.IDS_LBL_PRINTBARCODE") : props.Screen === "sheet" ? "Material Details " : props.t("Inventory.MaterialInventory.IDS_LBL_LABLEPRINT")}
      </h5>
      <button id="id-materialinv-closedetails" type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={props.hideModal}>
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <ModalBody>
      <Row>
        <Col md={12}>
          {!props.labelshow && props.Screen !== undefined && props.Screen !== "Sample" ? <ContentPanel className="panel-main-content">
            <Card className="border-0">
              <Card.Body>
                <Container>
                  <Row>
                    <Col>
                      <div>
                        <h4>{props.t("Inventory.IDS_LBL_STATIC.", {
                          param: ""
                        })}</h4>
                        <div>
                          {props.selectedMaterialInventoryFile !== undefined && props.selectedMaterialInventoryFile !== null ? props.Screen === "sheet" ? formatStaticData(props.selectedMaterialInventoryFile) : props.formatStaticData(props.selectedMaterialInventoryFile) : ""}
                        </div>
                      </div>
                    </Col>

                    <Col>
                      <div>
                        <h4>{props.t("Inventory.IDS_LBL_DYNAMIC.", {
                          param: ""
                        })}</h4>
                        <div>
                          {props.Screen === "sheet" && dynamicfields.length > 0 ? formatMaterialDynamicData(dynamicfields) :
                            props.state?.selectedMaterialInventoryFile !== undefined && props.state?.selectedMaterialInventoryFile !== null &&
                              props.selectedMaterialInventoryFile?.material?.jsondata !== undefined && props.selectedMaterialInventoryFile?.material?.jsondata !== null &&
                              JSON.parse(props.selectedMaterialInventoryFile?.material?.jsondata).dynamicfields !== undefined && JSON.parse(props.selectedMaterialInventoryFile?.material?.jsondata).dynamicfields !== null &&
                              JSON.parse(props.selectedMaterialInventoryFile?.material?.jsondata).dynamicfields.length > 0 ?
                              props.formatMaterialDynamicData(JSON.parse(props.selectedMaterialInventoryFile?.material?.jsondata).dynamicfields) : props.t("Inventory.Materials.IDS_MSG_DYNAMICFIELD", {
                                param: ""
                              })}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {props?.selectedMaterialInventoryFile?.materialtype?.lstbarcodes?.length > 0 ? <>
                    <Row>
                      <Col>
                        <Button type="button" className="textBtn btn_white_bg" onClick={props.handlelabel}>{props.t("Inventory.MaterialInventory.IDS_LBL_LABLEPRINT")}</Button>
                      </Col>
                      <Col></Col>
                    </Row>
                  </>
                    : <span> {valiadateTenantPackage() === "2" || isMultitenant === 2 || props.Screen === "sheet" ? "" : <b>{props.t("Inventory.IDS_LBL_LABELNOTMAP")}</b>}</span>}
                </Container>
              </Card.Body>
            </Card>
          </ContentPanel> : <div>
            {/* <h4>{"Label"}</h4> */}
            <div>

              {/* {props.Screen !== undefined && props.Screen === "SheetOrder" &&
                <>
                  <Row className="border-box">
                    <Col md={4} style={{ top: "10px", left: "20px" }}>
                      <Label className="required align-to-filter-label">    {props.t("Inventory.IDS_LBL_BARCODE", {
                        param: "",
                      })}</Label>

                    </Col>
                    <Col md={8}>
                      <KendoCombobox
                        id="id-TemplateMapping"
                        Datasource={props?.BarcodeMasterList}
                        DefaultValue={props?.SlectedBarcode}
                        onvaluechange={props?.OnBarcodeChangeevent}
                        ValueMember={"barcodeno"}
                        DisplayMember={"barcodename"}
                        Placeholder={props.t("Setup.Usergroup.IDS_LBL_BARCODEMASTER", {
                          param: "",
                        })}
                        disabled={false}
                      />
                    </Col>

                  </Row>
                </>} */}
              <dd className="k-line-break"></dd>
              <Row className="barcode">
                <Col className="col mt-1">
                  <Label className="required align-to-filter-label">{props.t("Inventory.IDS_LBL_SELECTPRINTER")}</Label>
                </Col>
                <Col lg={4}>
                  <KendoCombobox initialValue="" id="id-combo-Printer" Datasource={props.printdevices} DefaultValue={props.printdevice} onvaluechange={props.onDeviceChange} ValueMember="printerId" DisplayMember="printerName" Placeholder="Printer" additionalclass="printcombo" />
                </Col>
              </Row>
              <Row className="barcode">
                <Col className="col mt-1">
                  <Label className="required align-to-filter-label">{props.t("Inventory.IDS_LBL_SELECTLABELS")}</Label>
                </Col>
                <Col lg={4}>
                  <KendoCombobox initialValue="" id="id-combo-Printer" Datasource={barcodes} DefaultValue={selectedbarcode} onvaluechange={onBarChange} ValueMember="barcodeno" DisplayMember="barcodename" Placeholder="Printer" additionalclass={"clshideclearbutton printcombo"} />
                </Col>

                <Col className="" >
                  {barcodeurl !== "" &&
                    <Button type="button" className="textBtn btn_white_bg" onClick={() => { props.onBarcodeprint(selectedbarcode, barcodeurl) }}>{props.t("Inventory.IDS_LBL_PRINTBAR")}</Button>
                  }
                  {props.Screen !== undefined && props.Screen === "Material" &&
                    <Button type="button" className="textBtn btn_white_bg" onClick={props.onBarcodehide}>{props.t("Inventory.IDS_LBL_BACKBAR")}</Button>
                  }

                </Col>

              </Row>
              {!props.barcodeurls && <>
                <Row className="barcode mt-2">
                  <Col className="col mt-1">
                    <Label className="required align-to-filter-label">{props.t("Inventory.IDS_LBL_BACKBAR")}{"Print Density"}</Label>
                  </Col>
                  <Col lg={4}>
                    <KendoCombobox initialValue="" id="id-combo-Density" Datasource={printDensityList} DefaultValue={printDensity}
                      onvaluechange={onPrintDensityChange} ValueMember="value" DisplayMember="display" Placeholder="Density" additionalclass="printcombo" />
                  </Col>
                </Row>
                <Row className="mt-3">
                  {/* <Col xs={3}>
                  <Label className="required align-to-filter-label">{"Label Size"}</Label>
                </Col> */}
                  <Col xs="3">
                    <Label className="required align-to-filter-label">{props.t("Inventory.IDS_LBL_LABELSIZE")}</Label>
                  </Col>
                  <Col>
                    <input type={"number"} max={"50"} value={height} onChange={onHeightChange} className="form-control d-inline-block mr-2" style={{ width: "60px" }}></input>
                    <Label className="align-to-filter-label d-inline-block">{"X"}</Label>
                    <input type={"number"} max={"50"} value={width} onChange={onWidthChange} className="form-control d-inline-block mr-2" style={{ width: "60px" }} />
                    <Label className="align-to-filter-label d-inline-block">{"inches"}</Label>
                  </Col>

                </Row>
                <Row className="mt-3">
                  <Col xs="3">
                    <Label className="align-to-filter-label">{props.t("Inventory.IDS_LBL_DOWNLOADBAR")}</Label>
                  </Col>
                  <Button type="button" className="textBtn btn_white_bg" onClick={() => { onfiledownload(props.name + ".png") }}><i className="fas fa-cloud-download-alt mr-1"></i>{props.t("Inventory.IDS_LBL_PNG")}</Button>
                  <Button type="button" className="textBtn btn_white_bg mr-4" onClick={() => { ongeneratePDF(props.name + ".pdf") }}><i className="fas fa-cloud-download-alt mr-1"></i>{props.t("Inventory.IDS_LBL_PDF")}</Button>
                </Row>

                {barcodeurl && <div className="clslabelimage mt-2"><img width={"100%"} src={barcodeurl} alt="" ></img></div>}
              </>}
            </div>
          </div>}
        </Col>
      </Row>
    </ModalBody>
  </Modal >);
}

const renderSwitch = (type) => {
  switch (type) {
    case "LPO":
      return 0;
    case "EPO":
      return 2;
    case "RPO":
      return 3;
    case "MPO":
      return 4;
    case "SPO":
      return 5;
    case "LCO":
      return 0;
    case "ECO":
      return 2;
    case "RCO":
      return 3;
    case "MCO":
      return 4;
    case "SCO":
      return 5;
    default:
      return 2;
  }
};


const fetchOrderDetails = async (t, ELNurl) => {
  try {
    let limsorder = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_LIMSTASKORDER");
    let elnorder = ControlRights("IDS_MDL_ORDERS", "IDS_TSK_ELNTASKORDER");
    const intl = useInternationalization;
    const getDateFormatted = (date, userDefinedDateFormat, intl) => {
      return convertDateFormat(
        new Date(date || new Date()),
        userDefinedDateFormat || intl
      );
    };
    const createFolderObject = (directoryCode, parentDirCode, fileFor, directoryName, intl, icon, path) => {
      return {
        directorycode: directoryCode,
        parentdircode: parentDirCode,
        dateCreated: getDateFormatted(sessionStorage.getItem("currentDate"), intl),
        dateModified: getDateFormatted(new Date(), intl),
        size: 124,
        path,
        directoryname: directoryName,
        icon: convertExtensionToIcon(fileFor, null),
        filefor: fileFor,
        items: [],
      };
    };
    const limsorderVisible = limsorder.UserGroupRights.rights;
    const elnorderVisible = elnorder.UserGroupRights.rights;
    const passObj = isMultitenant === 0 && limsorderVisible ?
      createFolderObject(
        -7,
        -5,
        "LPO",
        t("Orders.Sheetorders.IDS_LBL_LIMSORDER"),
        intl,
        "Lims Order",
        `${"Sheet"}/${"Pending Orders"}/${"Lims Order"}`
      ) :
      elnorderVisible ?
        createFolderObject(
          -8,
          -5,
          "EPO",
          isMultitenant === 2
            ? t("Dashboard.IDS_LBL_ELNTASKS")
            : t("Orders.Sheetorders.IDS_LBL_ELNTASKORDER"),
          intl,
          "ELN Order",
          `${"Sheet"}/${"Pending Orders"}/${"ELN Order"}`
        ) : undefined;

    const userDefinedDate =
      sessionStorage.userDefinedDate === "dd-MM-yyyy HH:mm:ss" ||
        sessionStorage.userDefinedDate === "dd-MM-yy HH:mm:ss" ||
        sessionStorage.userDefinedDate === "UTC Format"
        ? "YY/MM/DD HH:mm:ss"
        : sessionStorage.userDefinedDate;
    const toRange = setDateAsuserDefined(new Date(), userDefinedDate);
    const sheetdaydiff = localStorage.getItem("sheetdaydiff");
    let daydiff = 7;
    if (typeof sheetdaydiff === "string" && sheetdaydiff !== "NaN") {
      daydiff = parseInt(JSON.parse(sheetdaydiff));
    }
    let diffdate = new Date().setDate(new Date().getDate() - daydiff);
    const sheetfiltertype = localStorage.getItem("sheetfiltertype");
    let filtertype = 2;
    if (typeof sheetfiltertype === "string") {
      filtertype = parseInt(JSON.parse(sheetfiltertype));
    }
    const fromRange =
      filtertype === 1
        ? setDateAsuserDefined(
          new Date(
            new Date().setDate(new Date().setHours(0, 0, 0, 0)),
            sessionStorage.userDefinedDate
          )
        )
        : setDateAsuserDefined(
          diffdate,
          userDefinedDate
        )
    const passObjDet4 = {
      filetype: renderSwitch(passObj?.filefor),
      fromdate: GetutcDateaudi(GetutcDate(new Date(fromRange))),
      todate: GetutcDate(new Date(toRange)),
      lstproject: Getuserprojectfromsession(),
      lstworkflow: Getuserworkflowfromsession(),
      lstuserMaster: Getteamusersfromsession(),
      directorycode: passObj?.directorycode,
      orderflag: ["LPO", "EPO", "RPO", "MPO", "SPO"].includes(passObj?.filefor) ? "N" : "R",
      filefor: passObj?.filefor,
      lsuserMaster: store.getState().Loggeduser,
      searchCriteria: {
        contentsearchtype: undefined,
        contentsearch: undefined,
      },
      ismultitenant: isMultitenant,
    };
    const response = await fetch(`${ELNurl}/Instrument/Getorderbyflaganduseronstart`, {
      method: 'POST',
      headers: {
        'Authorization': $.session.get("Token"),
        'X-TenantID': $.session.get("tenantid"),
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Content-Encoding': 'gzip',
      },
      body: await gzip(JSON.stringify(passObjDet4)),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const arrayBuffer = await response.arrayBuffer();
    const compressedData = new Uint8Array(arrayBuffer);
    const decompressedData = pako.inflate(compressedData, { to: 'string' });
    const parsedData = JSON.parse(decompressedData);
    store.dispatch(SheetandProtocolOrders(parsedData?.Orders));


  } catch (error) {
    if (error.name === 'AbortError') {
      console.error('Request timed out');
    } else {
      console.error('Error fetching data:', error.message);
    }
  } finally {

  }
};

const formsequenceformatview = (format, seperator, type, data) => {
  let id = ""

  Object.keys(format).forEach((key, index) => {

    if (index !== 0) {
      let addseperator = true;

      if ((key === "sp" || key === "pj") && !data["projectname"]) {
        addseperator = false;
      }
      else if ((key === "ts" || key === "st") && !data["task"]) {
        addseperator = false;
      }
      else if (key === "pc" && !data["projectcode"]) {
        addseperator = false;
      }

      if (addseperator) {
        id += seperator;
      }
    }

    if (key === "t") {
      id += format[key].t;
    }
    else if (key === "s") {
      if (type === "f") {
        for (let si = 0; si < format[key].l; si++) {
          id += "9";
        }
      }
      else {
        id += "{s&" + zeroPad(0, format[key].l) + "$s}";
      }
    } else if (key === "sp" && data["projectname"]) {
      if (type === "f") {
        for (let si = 0; si < format[key].l; si++) {
          id += "9";
        }
      }
      else {
        id += "{sp&" + zeroPad(0, format[key].l) + "$sp}";
      }
    } else if (key === "st" && data["task"]) {
      if (type === "f") {
        for (let si = 0; si < format[key].l; si++) {
          id += "9";
        }
      }
      else {
        id += "{st&" + zeroPad(0, format[key].l) + "$st}";
      }
    }
    else if (key === "pj" && data["projectname"]) {
      if (format[key].p === "p") {
        id += data["projectname"].substring(0, format[key].l);
      }
      else {
        id += data["projectname"].slice(-format[key].l);
      }
    }
    else if (key === "pc" && data["projectcode"]) {
      if (format[key].p === "p") {
        id += data["projectcode"].substring(0, format[key].l);
      }
      else {
        id += data["projectcode"].slice(-format[key].l);
      }
    }
    else if (key === "sn") {
      if (format[key].p === "p") {
        id += sessionStorage.Usersitename.substring(0, format[key].l);
      }
      else {
        id += sessionStorage.Usersitename.slice(-format[key].l);
      }
    }
    else if (key === "ts" && data["task"]) {
      if (format[key].p === "p") {
        id += data["task"].substring(0, format[key].l);
      }
      else {
        id += data["task"].slice(-format[key].l);
      }
    }
    else if (key === "o" && data["ordertype"]) {
      if (format[key].p === "p") {
        id += data["ordertype"].substring(0, format[key].l);
      }
      else {
        id += data["ordertype"].slice(-format[key].l);
      }
    }
    else if (key === "mt" && data["materialtype"]) {
      if (format[key].p === "p") {
        id += data["materialtype"].substring(0, format[key].l);
      }
      else {
        id += data["materialtype"].slice(-format[key].l);
      }
    }
    else if (key === "mc" && data["materialcategory"]) {
      if (format[key].p === "p") {
        id += data["materialcategory"].substring(0, format[key].l);
      }
      else {
        id += data["materialcategory"].slice(-format[key].l);
      }
    }
    else if (key === "mn" && data["material"]) {
      if (format[key].p === "p") {
        id += data["material"].substring(0, format[key].l);
      }
      else {
        id += data["material"].slice(-format[key].l);
      }
    }
    else if (key === "et" && data["equipmenttype"]) {
      if (format[key].p === "p") {
        id += data["equipmenttype"].substring(0, format[key].l);
      }
      else {
        id += data["equipmenttype"].slice(-format[key].l);
      }
    }
    else if (key === "ec" && data["equipmentcategory"]) {
      if (format[key].p === "p") {
        id += data["equipmentcategory"].substring(0, format[key].l);
      }
      else {
        id += data["equipmentcategory"].slice(-format[key].l);
      }
    }
    else if (key === "en" && data["equipment"]) {
      if (format[key].p === "p") {
        id += data["equipment"].substring(0, format[key].l);
      }
      else {
        id += data["equipment"].slice(-format[key].l);
      }
    }
    else if (key === "snt" && data["sampletype"]) {
      if (format[key].p === "p") {
        id += data["sampletype"].substring(0, format[key].l);
      }
      else {
        id += data["sampletype"].slice(-format[key].l);
      }
    }
    else if (key === "snc" && data["samplecategory"]) {
      if (format[key].p === "p") {
        id += data["samplecategory"].substring(0, format[key].l);
      }
      else {
        id += data["samplecategory"].slice(-format[key].l);
      }
    }
    else if (key === "snn" && data["sample"]) {
      if (format[key].p === "p") {
        id += data["sample"].substring(0, format[key].l);
      }
      else {
        id += data["sample"].slice(-format[key].l);
      }
    }
    else if (key === "d" || key === "m" || key === "y") {
      const dateObj = new Date();
      const month = dateObj.getUTCMonth() + 1; // months from 1-12
      const day = dateObj.getUTCDate();
      const year = dateObj.getUTCFullYear();

      const pMonth = month.toString().padStart(2, "0");
      const pDay = day.toString().padStart(2, "0");

      if (type === "f") {
        if (key === "d") {
          id += pDay;
        }
        else if (key === "m") {
          if (format[key].f === "m") {
            id += pMonth;
          }
          else {
            id += montharray[dateObj.getUTCMonth()];
          }
        }
        else if (key === "y") {
          if (format[key].f === "yy") {
            id += year;
          }
          else {
            id += year.toString().slice(-2);
          }
        }
      }
      else {
        if (key === "d") {
          id += "{dd&" + pDay + "$dd}";
        }
        else if (key === "m") {
          if (format[key].f === "m") {
            id += "{m&" + pMonth + "$m}";
          }
          else {
            id += "{mm&" + montharray[dateObj.getUTCMonth()] + "$mm}";
          }
        }
        else if (key === "y") {
          if (format[key].f === "yy") {
            id += "{yy&" + year + "$yy}";
          }
          else {
            id += "{y&" + year.toString().slice(-2) + "$y}";
          }
        }
      }

    }

  });
  return id;
}

const formatGridDate = (material) => {
  return material.map((x) => {
    if (x.nstatus === 1) {
      // x.displaystatus = this.props.t("Setup.Usermaster.IDS_LBL_ACTIVE")
      x.displaystatus = "Active"
    } else {
      // x.displaystatus = this.props.t("Templates.Protocol.IDS_LBL_RETIRED")
      x.displaystatus = "Retired"
    }
    if (x.createddate !== undefined) {
      x.sDate = setDateAsuserDefined(convertUTCDateToLocalDate(new Date(x.createddate)), sessionStorage.userDefinedDate)
    }
    if (x.modifieddate !== undefined) {
      x.mDate = setDateAsuserDefined(convertUTCDateToLocalDate(new Date(x.modifieddate)), sessionStorage.userDefinedDate)
    }
    x.openexpiryneedvalue = x.openexpiry ? "Yes" : "No";
    x.quarantinevalue = x.quarantine ? "Yes" : "No";

    if (x.sequenceid === undefined) {
      x.sequenceid = x.smaterialname;
    }
    return x
  });
}

function isNumeric(str) {
  if (typeof str != "string") return false // we only process strings!  
  return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

function updateimagesonsave(sheet, isnew, version, chartImageObj) {
  let images = sheet.images;
  let ELNurl = window.appUrl.ELN;
  if (images.length === 0 && chartImageObj !== undefined) {
    images.unshift(null);
  }
  chartImageObj && chartImageObj.map((obj) => {
    return images.push(obj);
  })
  let copyobject = [];
  let deletelist = [];
  let validate;
  if ((window.appUrl.ELN).includes("ELN-0.0.1-SNAPSHOT") ||
    (window.appUrl.ELN).includes("ELNPOSTGRE-0.0.1-SNAPSHOT")) {
    validate = true;
  }

  if (validate === undefined) {
    if (images !== undefined) {
      if (isnew) {
        images = images.map((obj) => {
          if (obj !== null && obj !== undefined && typeof obj === "object") {
            let copy = {};
            let url = obj.url;
            let urlarray = url.split("/");

            // if(isMultitenant === 0){
            //   urlarray = urlarray.filter(function(value, index, arr){
            //     return value !== "";
            //   });
            // }

            copy.copyfrom = urlarray[5];
            copy.oldfileid = urlarray[5];
            urlarray[4] = "downloadsheetimages";
            urlarray[5] = urlarray[5] + "_0";
            copy.copyto = urlarray[5];
            copy.isnew = "true";
            let modifiedurl = "";
            urlarray.map((subval, index) => {
              if (index === 0) {
                modifiedurl = subval;
              } else {
                modifiedurl = modifiedurl + "/" + subval;
              }
              return modifiedurl;
            });
            obj.url = modifiedurl;

            if (obj.candelete) {
              obj.isdeleted = true;
              deletelist.push({ fieldid: urlarray[5] });
            }

            copyobject.push(copy);
          }
          return obj;
        });
      } else {
        images = images.map((obj) => {
          if (obj !== null && obj !== undefined && typeof obj === "object") {
            let copy = {};
            let url = obj.url;
            let urlarray = url.split("/");

            // if(isMultitenant === 0){
            //   urlarray = urlarray.filter(function(value, index, arr){
            //     return value !== "";
            //   });
            // }

            let fileid = urlarray[5];
            let fileidarray = fileid.split("_");
            if (fileidarray !== undefined && fileidarray.length === 1) {
              copy.copyfrom = urlarray[5];
              copy.oldfileid = urlarray[5];
              let updatedversionname = urlarray[5] + "_" + version;
              urlarray[5] = updatedversionname;
              urlarray[4] = "downloadsheetimages";


              copy.copyto = updatedversionname;
              let modifiedurl = "";
              urlarray.map((subval, index) => {
                if (index === 0) {
                  modifiedurl = subval;
                } else {
                  modifiedurl = modifiedurl + "/" + subval;
                }
                return modifiedurl;
              });
              obj.url = modifiedurl;

              copy.isnew = "true";
              copyobject.push(copy);
            }

            if (obj.candelete) {
              obj.isdeleted = true;
              deletelist.push({ fieldid: urlarray[5] });
            }
          }
          return obj;
        });
      }

      sheet.images = images;

      if (copyobject !== undefined && copyobject.length > 0) {
        if (sessionStorage.tenantid === "null" || $.session.get("tenantid") === undefined) {
          Servicecalls(
            "" + ELNurl + "/Instrument/updatesheetimagesforversionSql",
            copyobject,
            (res) => { },
            (res) => { }
          );

        } else {
          Servicecalls(
            "" + ELNurl + "/Instrument/updatesheetimagesforversion",
            copyobject,
            (res) => { },
            (res) => { }
          );
        }

      }

      if (deletelist !== undefined && deletelist.length > 0) {
        if (sessionStorage.tenantid === "null" || $.session.get("tenantid") === undefined) {
          Servicecalls(
            "" + ELNurl + "/Instrument/deletesheetimagesforversionSql",
            deletelist,
            (res) => { },
            (res) => { }
          );
        } else {
          Servicecalls(
            "" + ELNurl + "/Instrument/deletesheetimagesforversion",
            deletelist,
            (res) => { },
            (res) => { }
          );
        }
      }
    }
  }
  else {
    if (images !== undefined) {
      if (isnew) {
        images = images.map((obj) => {
          if (obj !== null && obj !== undefined && typeof obj === "object") {
            let copy = {};
            let url = obj.url;
            let urlarray = url.split("/");

            copy.copyfrom = urlarray[6];
            copy.oldfileid = urlarray[6];

            urlarray[5] = "downloadsheetimages";
            urlarray[6] = urlarray[6] + "_0";
            copy.copyto = urlarray[6];
            copy.isnew = "true";
            let modifiedurl = "";
            urlarray.map((subval, index) => {
              if (index === 0) {
                modifiedurl = subval;
              } else {
                modifiedurl = modifiedurl + "/" + subval;
              }
              return modifiedurl;
            });
            obj.url = modifiedurl;

            if (obj.candelete) {
              obj.isdeleted = true;
              deletelist.push({ fieldid: urlarray[5] });
            }

            copyobject.push(copy);
          }
          return obj;
        });
      } else {
        images = images.map((obj) => {
          if (obj !== null && obj !== undefined && typeof obj === "object") {
            let copy = {};
            let url = obj.url;
            let urlarray = url.split("/");

            // if(isMultitenant === 0){
            //   urlarray = urlarray.filter(function(value, index, arr){
            //     return value !== "";
            //   });
            // }

            let fileid = urlarray[6];
            let fileidarray = fileid.split("_");
            if (fileidarray !== undefined && fileidarray.length === 1) {
              copy.copyfrom = urlarray[6];
              copy.oldfileid = urlarray[6];
              let updatedversionname = urlarray[6] + "_" + version;
              urlarray[6] = updatedversionname;
              urlarray[5] = "downloadsheetimages";
              //urlarray[4] = urlarray[4] === "downloadsheetimagestempsql" ?"downloadsheetimagestempsql":urlarray[4];

              copy.copyto = updatedversionname;
              let modifiedurl = "";
              urlarray.map((subval, index) => {
                if (index === 0) {
                  modifiedurl = subval;
                } else {
                  modifiedurl = modifiedurl + "/" + subval;
                }
                return modifiedurl;
              });
              obj.url = modifiedurl;

              copy.isnew = "true";
              copyobject.push(copy);
            }

            if (obj.candelete) {
              obj.isdeleted = true;
              deletelist.push({ fieldid: urlarray[6] });
            }
          }
          return obj;
        });
      }

      sheet.images = images;

      if (copyobject !== undefined && copyobject.length > 0) {
        if (sessionStorage.tenantid === "null" || $.session.get("tenantid") === undefined) {
          Servicecalls(
            "" + ELNurl + "/Instrument/updatesheetimagesforversionSql",
            copyobject,
            (res) => { },
            (res) => { }
          );

        } else {
          Servicecalls(
            "" + ELNurl + "/Instrument/updatesheetimagesforversion",
            copyobject,
            (res) => { },
            (res) => { }
          );
        }

      }

      if (deletelist !== undefined && deletelist.length > 0) {
        if (sessionStorage.tenantid === "null" || $.session.get("tenantid") === undefined) {
          Servicecalls(
            "" + ELNurl + "/Instrument/deletesheetimagesforversionSql",
            deletelist,
            (res) => { },
            (res) => { }
          );
        } else {
          Servicecalls(
            "" + ELNurl + "/Instrument/deletesheetimagesforversion",
            deletelist,
            (res) => { },
            (res) => { }
          );
        }
      }
    }
  }

  return sheet;
}


function getfieldindexondatafill(fields, sheetindex, sheetname, rowindex, colindex) {
  let fieldindex = fields !== undefined && fields.findIndex(fld => {
    return fld.sheetindex === sheetindex && fld.sheetname === sheetname
      && ((fld.bottomRightrow === rowindex && fld.bottomRightcol === colindex &&
        fld.topLeftrow === rowindex && fld.topLeftcol === colindex) || (
          rowindex <= fld.bottomRightrow
          && rowindex >= fld.topLeftrow
          && colindex <= fld.bottomRightcol
          && colindex >= fld.topLeftcol));
  });

  return {
    fieldindex: fieldindex, sheetindex: sheetindex, bottomRightrow: rowindex,
    bottomRightcol: colindex, topLeftrow: rowindex, topLeftcol: colindex
  };
}

const ToggleSwitch = ({
  isOn = false,
  onToggle,
  disabled = false,
  size = "medium",
  variant = "default",
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <button
      type="button"
      className={`toggle-switch ${isOn ? "on" : "off"} ${isFocused ? "focus" : ""
        } ${disabled ? "disabled" : ""} ${size} ${variant}`}
      onClick={() => !disabled && onToggle && onToggle(!isOn)}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      disabled={disabled}
      role="switch"
      aria-checked={isOn}
    >
      <span className="thumb" />
    </button>
  );
};

function getColumnName(column) {
  var letters = "";
  while (column > 0) {
    var num = column % 26;
    if (num === 0) {
      letters = "Z" + letters;
      column--;
    } else {
      letters = String.fromCharCode("A".charCodeAt(0) + num - 1) + letters;
    }
    column = parseInt((column / 26).toString());
  }
  return letters;
}


const csvEscape = (v) => {
  if (v == null) return "";
  const s = String(v);
  if (/[",\n]/.test(s)) return '"' + s.replace(/"/g, '""') + '"';
  return s;
};

const gridDtatExportToolBar = (event, excelExportRef, screen, Grid_Type) => {
  if (excelExportRef.current !== undefined && excelExportRef.current !== null) {
    if (event?.item?.text === "Excel") {
      // if (Grid_Type === "grid") {
      //   excelExportRef.current?.save();
      // } else {
      const allResult = excelExportRef.current?.allResult;
      const Data = allResult.data;
      const columns = allResult.columns.filter((c) => c.show !== false);
      ExcelExport({ data: Data, headers: columns, fileName: screen + "_export" });
      // }
    } else {
      const allResult = excelExportRef.current?.allResult;
      const Data = allResult.data;
      const columns = allResult.columns.filter((c) => c.show !== false);

      const header = columns.map((c) => csvEscape(c.title)).join(",");
      const lines = Data.map((r) =>
        columns
          .map((c) => {
            let val = r[c.field];
            if (val instanceof Date) {
              val = val.toISOString();
            }
            if (typeof val === "boolean") {
              val = val ? "Yes" : "No";
            }
            return csvEscape(val);
          })
          .join(",")
      );
      const csv = [header, ...lines].join("\n");
      const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, screen + "_export.csv");
    }
  }

}

const gridDtatExport = (event, excelExportRef, screen, Grid_Type) => {
  if (excelExportRef.current !== undefined && excelExportRef.current !== null) {
    if (event?.item?.text === "Excel") {
      if (Grid_Type === "grid") {
        excelExportRef.current?.save();
      } else {
        const allResult = excelExportRef.current?.allResult;
        const Data = allResult.data;
        const columns = allResult.columns.filter((c) => c.show !== false);
        ExcelExport({ data: Data, headers: columns, fileName: screen + "_export" });
      }
    } else {
      const allResult = excelExportRef.current?.allResult;
      const Data = allResult.data;
      const columns = allResult.columns.filter((c) => c.show !== false);

      const header = columns.map((c) => csvEscape(c.title)).join(",");
      const lines = Data.map((r) =>
        columns
          .map((c) => {
            let val = r[c.field];
            if (val instanceof Date) {
              val = val.toISOString();
            }
            if (typeof val === "boolean") {
              val = val ? "Yes" : "No";
            }
            return csvEscape(val);
          })
          .join(",")
      );
      const csv = [header, ...lines].join("\n");
      const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, screen + "_export.csv");
    }
  }

}


const ExcelExport = ({ data, headers, fileName }) => {
  const workbook = XLSX.utils.book_new();
  const headerRow = headers.map(header => header.title || header.datatype);
  const dataRows = data.map(item =>
    headers.map(header => item[header.field || header.datatype])
  );
  const worksheetData = [headerRow, ...dataRows];
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(blob, `${fileName}.xlsx`);
};


// const KendoEditor = ({ t, isscriptformatopen, onInsertScript, onScriptFormatClick, ActiveSheet }) => {

//   // const [UpdatedContent, setUpdatedContent] = useState("");
//   const editorRef = useRef(null);

//   if (editorRef.current) {
//     const sheet = ActiveSheet;
//     if (!sheet) return;
//     const selection = sheet.selection();
//     const range = sheet.range(selection);
//     const htmlContent = `
//     <span
//       style="
//         color: ${range.color() || "black"};
//         background-color: ${range.background() || "transparent"};
//         font-weight: ${range.bold() ? "bold" : "normal"};
//         font-style: ${range.italic() ? "italic" : "normal"};
//         text-decoration: ${range.underline() ? "underline" : "none"};
//         font-family: ${range.fontFamily() || "Arial"};
//         font-size: ${range.fontSize() || 12}px;
//       "
//     >
//       ${range.value() || ""}
//     </span>
//   `;
//     editorRef.current.content(htmlContent);
//   }

//   const handleInsertClick = () => {
//     const view = editorRef.current.view;
//     if (view) {
//       let html = EditorUtils.getHtml(view.state);
//       let values = htmlToUnicodeTextRecursive(html);
//       console.log(values);
//       if (values !== "" && onInsertScript !== undefined) {
//         onInsertScript(values);
//       }
//     }

//   }

//   const supMap = {
//     "0": "⁰", "1": "¹", "2": "²", "3": "³", "4": "⁴", "5": "⁵", "6": "⁶", "7": "⁷", "8": "⁸", "9": "⁹",
//     "a": "ᵃ", "b": "ᵇ", "c": "ᶜ", "d": "ᵈ", "e": "ᵉ", "f": "ᶠ", "g": "ᵍ", "h": "ʰ", "i": "ⁱ", "j": "ʲ", "k": "ᵏ",
//     "l": "ˡ", "m": "ᵐ", "n": "ⁿ", "o": "ᵒ", "p": "ᵖ", "q": "ᑫ", "r": "ʳ", "s": "ˢ", "t": "ᵗ", "u": "ᵘ", "v": "ᵛ",
//     "w": "ʷ", "x": "ˣ", "y": "ʸ", "z": "ᶻ",
//     "+": "⁺", "-": "⁻", "=": "⁼", "(": "⁽", ")": "⁾"
//   };

//   const subMap = {
//     "0": "₀", "1": "₁", "2": "₂", "3": "₃", "4": "₄", "5": "₅", "6": "₆", "7": "₇", "8": "₈", "9": "₉",
//     "a": "ₐ", "e": "ₑ", "h": "ₕ", "i": "ᵢ", "j": "ⱼ", "k": "ₖ", "l": "ₗ", "m": "ₘ", "n": "ₙ", "o": "ₒ", "p": "ₚ",
//     "r": "ᵣ", "s": "ₛ", "t": "ₜ", "u": "ᵤ", "v": "ᵥ", "x": "ₓ", "y": "ᵧ", "z": "ᶻ",
//     "+": "₊", "-": "₋", "=": "₌", "(": "₍", ")": "₎"
//   };

//   const convertNode = (node, parentTag = null) => {
//     let result = "";

//     node.childNodes.forEach((child) => {
//       if (child.nodeType === Node.TEXT_NODE) {
//         // Plain text
//         if (parentTag === "sup") {
//           result += child.textContent.split("").map(c => supMap[c.toLowerCase()] || "").join("");
//         } else if (parentTag === "sub") {
//           result += child.textContent.split("").map(c => subMap[c.toLowerCase()] || "").join("");
//         } else {
//           result += child.textContent;
//         }
//       } else if (child.nodeType === Node.ELEMENT_NODE) {
//         const tag = child.tagName.toLowerCase();
//         if (tag === "sup" || tag === "sub") {
//           result += convertNode(child, tag); // recursive
//         } else {
//           result += convertNode(child, parentTag); // inherit parent formatting
//         }
//       }
//     });

//     return result;
//   }

//   const htmlToUnicodeTextRecursive = (html) => {
//     const tempDiv = document.createElement("div");
//     tempDiv.innerHTML = html;
//     return convertNode(tempDiv);
//   }

//   return (
//     <Modal
//       centered
//       isOpen={isscriptformatopen}
//       className="largePopup logbook-popup  screen-centered-scroll"
//       style={{ width: "95%" }}
//     >
//       <div className="modal-header">
//         <h5 className="modal-title" id="staticBackdropLabel">
//           {t("Orders.Sheetorders.IDS_LBL_TEXTFORMATTING")}
//         </h5>
//         <button
//           id="id-dialog-closemodel"
//           type="button"
//           className="close"
//           data-dismiss="modal"
//           aria-label="Close"
//           // onClick={props.closeModel() !== undefined ? props.closeModel() : closefunction}
//           onClick={() => onScriptFormatClick()}
//         >
//           <span aria-hidden="true">&times;</span>
//         </button>
//       </div>
//       <ModalBody>
//         <>

//           <Editor
//             ref={editorRef}
//             tools={[
//               [Subscript, Superscript],
//               [Bold, Italic, Underline, Strikethrough],
//             ]}
//             contentStyle={{ height: 500 }}
//             defaultContent={""}
//           // onChange={handleChange}
//           />
//         </>

//       </ModalBody>

//       <div id="UserMasterADD-modal-footer" className="modal-footer">
//         <button
//           type="button"
//           id="id-dialog-savemodel"
//           className="btn btn-user btn-primary-blue"
//           onClick={handleInsertClick}
//         // disabled={savebuttondisabled}
//         >
//           {t("Templates.Protocoltemplates.IDS_LBL_INSERT", { param: "" })}
//         </button>
//         <button
//           type="button"
//           className="btn modalbluebtn button"
//           data-dismiss="modal"
//           id="id-dialog-closemodel"
//           onClick={() => onScriptFormatClick()}
//         >
//           {t("Templates.Protocoltemplates.IDS_LBL_CLOSE", { param: "" })}
//         </button>
//       </div>

//     </Modal>





//   );

// }


const KendoEditor = ({ t, isscriptformatopen, onInsertScript, onScriptFormatClick, ActiveSheet }) => {

  const [DefaultContent, setDefaultContent] = useState("");
  const editorRef = useRef(null);
  const supMap = {
    "0": "⁰", "1": "¹", "2": "²", "3": "³", "4": "⁴", "5": "⁵", "6": "⁶", "7": "⁷", "8": "⁸", "9": "⁹",
    "a": "ᵃ", "b": "ᵇ", "c": "ᶜ", "d": "ᵈ", "e": "ᵉ", "f": "ᶠ", "g": "ᵍ", "h": "ʰ", "i": "ⁱ", "j": "ʲ", "k": "ᵏ",
    "l": "ˡ", "m": "ᵐ", "n": "ⁿ", "o": "ᵒ", "p": "ᵖ", "q": "ᑫ", "r": "ʳ", "s": "ˢ", "t": "ᵗ", "u": "ᵘ", "v": "ᵛ",
    "w": "ʷ", "x": "ˣ", "y": "ʸ", "z": "ᶻ",
    "+": "⁺", "-": "⁻", "=": "⁼", "(": "⁽", ")": "⁾"
  };
  const subMap = {
    "0": "₀", "1": "₁", "2": "₂", "3": "₃", "4": "₄", "5": "₅", "6": "₆", "7": "₇", "8": "₈", "9": "₉",
    "a": "ₐ", "e": "ₑ", "h": "ₕ", "i": "ᵢ", "j": "ⱼ", "k": "ₖ", "l": "ₗ", "m": "ₘ", "n": "ₙ", "o": "ₒ", "p": "ₚ",
    "r": "ᵣ", "s": "ₛ", "t": "ₜ", "u": "ᵤ", "v": "ᵥ", "x": "ₓ", "y": "ᵧ", "z": "ᶻ",
    "+": "₊", "-": "₋", "=": "₌", "(": "₍", ")": "₎"
  };

  const convertNode = (node, parentTag = null) => {
    let result = "";
    node.childNodes.forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE) {
        if (parentTag === "sup") {
          result += child.textContent.split("").map(c => supMap[c.toLowerCase()] || c).join("");
        } else if (parentTag === "sub") {
          result += child.textContent.split("").map(c => subMap[c.toLowerCase()] || c).join("");
        } else {
          result += child.textContent;
        }
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        const tag = child.tagName.toLowerCase();
        if (tag === "sup" || tag === "sub") {
          result += convertNode(child, tag);
        } else {
          result += convertNode(child, parentTag);
        }
      }
    });
    return result;
  }

  const htmlToUnicodeTextRecursive = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return convertNode(tempDiv);
  }

  // // NEW: Extract styles from HTML
  // const extractStylesFromHtml = (html) => {
  //   const tempDiv = document.createElement("div");
  //   tempDiv.innerHTML = html;

  //   // Get the first span or any styled element
  //   const firstElement = tempDiv.querySelector('span, strong, em, u, s, sub, sup') || tempDiv.firstChild;

  //   const styles = {
  //     color: null,
  //     background: null,
  //     bold: false,
  //     italic: false,
  //     underline: false,
  //     fontFamily: null,
  //     fontSize: null
  //   };

  //   if (firstElement && firstElement.style) {
  //     styles.color = firstElement.style.color || null;
  //     styles.background = firstElement.style.backgroundColor || null;
  //     styles.fontFamily = firstElement.style.fontFamily || null;

  //     const fontSizeMatch = firstElement.style.fontSize?.match(/(\d+)/);
  //     if (fontSizeMatch) {
  //       styles.fontSize = parseInt(fontSizeMatch[1]);
  //     }

  //     styles.bold = firstElement.style.fontWeight === 'bold' || firstElement.tagName === 'STRONG' || firstElement.tagName === 'B';
  //     styles.italic = firstElement.style.fontStyle === 'italic' || firstElement.tagName === 'EM' || firstElement.tagName === 'I';
  //     styles.underline = firstElement.style.textDecoration?.includes('underline') || firstElement.tagName === 'U';
  //   }

  //   // Check for bold, italic, underline in parent elements
  //   const checkParentTags = (element) => {
  //     let current = element;
  //     while (current && current !== tempDiv) {
  //       const tag = current.tagName?.toUpperCase();
  //       if (tag === 'STRONG' || tag === 'B') styles.bold = true;
  //       if (tag === 'EM' || tag === 'I') styles.italic = true;
  //       if (tag === 'U') styles.underline = true;
  //       current = current.parentElement;
  //     }
  //   };

  //   if (firstElement) {
  //     checkParentTags(firstElement);
  //   }

  //   return styles;
  // }

  const extractStylesFromHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    const styles = {
      color: null,
      background: null,
      bold: false,
      italic: false,
      underline: false,
      strikethrough: false,
      fontFamily: null,
      fontSize: null
    };

    const checkElement = (el) => {
      if (!el) return;

      const tag = el.tagName?.toUpperCase();

      if (tag === 'STRONG' || tag === 'B') styles.bold = true;
      if (tag === 'EM' || tag === 'I') styles.italic = true;
      if (tag === 'U') styles.underline = true;
      if (tag === 'DEL' || tag === 'S') styles.strikethrough = true;

      if (el.style) {
        if (el.style.color) styles.color = el.style.color;
        if (el.style.backgroundColor) styles.background = el.style.backgroundColor;
        if (el.style.fontFamily) styles.fontFamily = el.style.fontFamily;
        const fontSizeMatch = el.style.fontSize?.match(/(\d+)/);
        if (fontSizeMatch) styles.fontSize = parseInt(fontSizeMatch[1]);
        if (el.style.fontWeight === 'bold') styles.bold = true;
        if (el.style.fontStyle === 'italic') styles.italic = true;
        if (el.style.textDecoration?.includes('underline')) styles.underline = true;
        if (el.style.textDecoration?.includes('line-through')) styles.strikethrough = true;
      }

      Array.from(el.children).forEach(checkElement);
    };

    Array.from(tempDiv.children).forEach(checkElement);

    return styles;
  };


  useEffect(() => {
    const sheet = ActiveSheet;
    if (!sheet) return;
    const selection = sheet.selection();
    const range = sheet.range(selection);
    //     const htmlContent = `
    //   <span
    //     style="
    //       color: ${range.color() || "black"};
    //       background-color: ${range.background() || "transparent"};
    //       font-weight: ${range.bold() ? "bold" : "normal"};
    //       font-style: ${range.italic() ? "italic" : "normal"};
    //       text-decoration: ${range.underline() ? "underline" : "none"};
    //       font-family: ${range.fontFamily() || "Arial"};
    //       font-size: ${range.fontSize() || 12}px;
    //     "
    //   >
    //     ${range.value() || ""}
    //   </span>
    // `.trim();
    setDefaultContent(range.value());

  }, [isscriptformatopen, ActiveSheet]);

  const handleInsertClick = () => {
    const view = editorRef.current.view;
    if (!view) return;

    const html = EditorUtils.getHtml(view.state);
    const values = htmlToUnicodeTextRecursive(html);
    const styles = extractStylesFromHtml(html);

    if (values && onInsertScript) {
      onInsertScript(values, styles);
    }
  };

  useEffect(() => {
    if (editorRef.current && DefaultContent) {
      setEditorHtml(DefaultContent);
    }
  }, [DefaultContent]);

  const setEditorHtml = (html) => {
    if (!editorRef.current) return;
    const view = editorRef.current.view;
    if (!view) return;

    const { state } = view;
    const safeHtml = String(html);
    const documentFragment = EditorUtils.createDocument(state.schema, safeHtml);

    const transaction = state.tr.replaceWith(
      0,
      state.doc.content.size,
      documentFragment
    );
    view.dispatch(transaction);
  };

  return (
    <Modal
      centered
      isOpen={isscriptformatopen}
      className="largePopup logbook-popup screen-centered-scroll"
      style={{ width: "95%" }}
    >
      <div className="modal-header">
        <h5 className="modal-title" id="staticBackdropLabel">
          {t("Orders.Sheetorders.IDS_LBL_TEXTFORMATTING")}
        </h5>
        <button
          type="button"
          className="close"
          aria-label="Close"
          onClick={onScriptFormatClick}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <ModalBody>
        <Editor
          ref={editorRef}
          tools={[
            [Subscript, Superscript],
            // [Bold, Italic, Underline, Strikethrough],
          ]}
          contentStyle={{ height: 500 }}
          defaultContent={""}
        />
      </ModalBody>

      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-user btn-primary-blue"
          onClick={handleInsertClick}
        >
          {t("Templates.Protocoltemplates.IDS_LBL_INSERT", { param: "" })}
        </button>
        <button
          type="button"
          className="btn modalbluebtn button"
          onClick={onScriptFormatClick}
        >
          {t("Templates.Protocoltemplates.IDS_LBL_CLOSE", { param: "" })}
        </button>
      </div>
    </Modal>
  );
}

const getfieldsfromsheetdata = (data) => {
  if (!data.fields) {
    data.fields = [];
    data.sheets.map((sheetobj, sheetindex) => {
      sheetobj.rows = sheetobj.rows && sheetobj.rows.filter((rowobj, rowindex) => {
        rowobj.cells = rowobj.cells && rowobj.cells.filter((cellobj, cellindex) => {
          if (cellobj.tag) {
            data.fields.push({
              sheetindex: sheetindex, sheetname: sheetobj.name,
              tag: cellobj.tag, bottomRightrow: rowobj.index, bottomRightcol: cellobj.index,
              topLeftrow: rowobj.index, topLeftcol: cellobj.index
            });
          }
          return cellobj;
        });
        return rowobj;
      });
      return sheetobj;
    });
  }

  return data;
}

function SpreadConfig(t) {
  let passobject = {};
  let ELNurl = window.appUrl.ELN;
  Servicecalls(
    "" + ELNurl + "/Login/SpreadConfig",
    passobject,
    (response) => {
      localStorage.setItem("spreadconfig", response.valuesettings === t("Setup.Usermaster.IDS_LBL_ACTIVE") ? false : true);
    },
    (response) => { }
  );
}

const SheettemplateTransactionDataUpdate = (PassData) => {
  let PassDataToList = Array.isArray(PassData) ? PassData : [PassData];
  let ELNurl = window.appUrl.ELN;
  Servicecalls(
    "" + ELNurl + "/File/updatetSheetTemplateTransactionlislist",
    PassDataToList,
    (res) => {
      console.log("kumu");
    },
    (res) => { }
  );

}

const ProtocoltemplateTransactionDataUpdate = (PassData) => {
  let PassDataToList = Array.isArray(PassData) ? PassData : [PassData];
  let ELNurl = window.appUrl.ELN;
  Servicecalls(
    "" + ELNurl + "/File/updatetprotocolTransactionlislist",
    PassDataToList,
    (res) => {
      console.log("kumu");
    },
    (res) => { }
  );

}

const ProtocolOrderTransactionDataUpdate = (PassData) => {
  let PassDataToList = Array.isArray(PassData) ? PassData : [PassData];
  let ELNurl = window.appUrl.ELN;
  Servicecalls(
    "" + ELNurl + "/protocol/updateTransactionHistoryList",
    PassDataToList,
    (res) => {
      console.log("kumu");
    },
    (res) => { }
  );
}

function excelSerialDateToJSDate(serial) {
  // Excel's epoch starts at 1899-12-30
  const excelEpoch = new Date(Date.UTC(1899, 11, 30));
  const days = Math.floor(serial);
  const msPerDay = 24 * 60 * 60 * 1000;
  const fractionalDay = serial - days;
  const msFromFraction = Math.round(fractionalDay * msPerDay);

  // Combine whole days and fractional days
  return new Date(excelEpoch.getTime() + (days * msPerDay) + msFromFraction);
}

function validateDateformat(dateformat) {

  switch (dateformat) {
    case "m/d/yyyy":
      return true;
    case "YYYY-MM-DD":
      return true;
    case "dd-MM-YYYY":
      return true;
    case "dd/MM/yyyy":
      return true;
    case "dd/MM/yy":
      return true;
    case "dd/MM/yy HH:mm":
      return true;
    case "dd/MM/yy HH:mm tt":
      return true;
    case "dd/MM/yy HH:mm:ss":
      return true;
    default:
      return false;
  }
}

function validateCommaSeparate(value, props) {

  // handle object input safely
  const text = typeof value === "string" ? value : value?.value;

  if (typeof text !== "string") {
    props.alert.error(props.t("Logbook.IDS_MSG_INVALIDVALUE"));
    return false;
  }

  let items = text.split(",");
  let isEmpty = items.some(item => item.trim() === "");
  if (isEmpty) {
    props.alert.error(props.t("Logbook.IDS_MSG_INVALIDVALUE"));
    return false;
  } else {
    return true;
  }
}

function downloadattachment(data, filename) {
  if (data.name !== undefined && data.name !== null && data.name !== "" || data instanceof Blob) {
    const url = URL.createObjectURL(data);   // file is a Blob/File
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;                  // "UserMaster (2).xlsx"
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } else {
    // ✅ Get current workbook state
    const workbookOptions = JSON.parse(data);

    // ✅ Create Excel workbook
    const workbook = new Workbook(workbookOptions);

    // ✅ Save Excel file
    workbook.toDataURL().then((dataURL) => {
      saveAs(dataURL, filename);
    });
  }

}

export {
  ProtocolHistory,
  checkADSUser,
  userdetails,
  PercentageCalculator,
  SPCCalculation,
  convertdoubledigitdate,
  convertfulldateformat,
  convertdoubledigittime,
  AuditTrailValidation,
  ControlRights,
  ControlRightsOnOrdersTask,
  onGetUserControlRights,
  AuditTrailValidationOnScreen,
  IsJSON,
  isINT,
  killSessionLogout,
  Silentauditobject,
  SilentauditobjectForOrder,
  ModuleRights,
  Manualauditobject,
  compareObjs,
  Silentauditobjectonlogout,
  returnMIMEtype,
  returnICON,
  extractValuefromsheet,
  convertUTCDateToLocalDate,
  CF_encryptionData,
  CF_decrypt,
  extractValueforDynamiccombo,
  predefineddatabase,
  linkSheetLogin,
  linkSheetnontenantLogin,
  linkOTPLogin,
  linkLIMSLogin,
  capitalizeFirstLetter,
  isNumericvalue,
  getDecimalSeparator,
  replacedecimalwithdot,
  replacedotwithdecimal,
  GetutcDate,
  GetutctoDate,
  GetutcDateoncurenttime,
  GetutcDateaudi,
  dateDiffInDays,
  setDateAsuserDefined,
  Servicecalls,
  ServicecallsMAIN,
  onAuditHandler,
  Serviceuserworkflowdetails,
  Serviceprojectdetails,
  Servicesequencedetails,
  Getuserprojectfromsession,
  Getuserworkflowfromsession,
  valiadateTenantPackage,
  formatprotocolsteps,
  Getteamusersfromsession,
  Getteamfromsession,
  Serviceforuserrights,
  Serviceprojectteam,
  Serviceforauditconfig,
  Serviceforusersettings,
  Serviceforserverdateformat,
  ServiceforMainFormUserLicense,
  SubMenuRights,
  SubMenuRightsonScreenViews,
  getModuleRihtsOnOrderModule,
  getSubMenuRightsonScreenViews,
  mainModuleRights,
  onHelpClick,
  uniq,
  decryptdata,
  encryptdata,
  formatdata,
  ServicecallsToken,
  Servicecallsforfiles,
  ServicecallsforSDMS,
  Servicecallsforwithougzip,
  setDateTimeAsuserDefined,
  validatesheetforversioning,
  checkChangesinSheet,
  checkChangesinSheetReact,
  Sheetchangeornotfunction,
  Sheetchangeornotfunctionforsheet,
  sheetModifyiedOrNot,
  restrictSheetEditonFields,
  markversionchanges,
  restrictVersioncomparion,
  generateLink,
  getGridorderColumns,
  removeByAttr,
  AuditDatetimeDefined,
  rangearray,
  addShowClass,
  showOrderBlock,
  compareObjsOperation,
  timeout,
  CheckIsMergedandreturntags,
  userDateFormat,
  checksheetdiffandmodifychangesheet,
  ongetcurentdata,
  Protocolcontentchangeornot,
  importimagetosheet,
  plantyprestrictedpagename,
  updateActiveUserTime,
  orderType,
  orderTypeforprotocol,
  checksheetsandequlize,
  pickbackgroudontype,
  checksheetformulachangeornot,
  getCurrentDateAndTimeOnBackend,
  findPathRecursive,
  findPathInArray,
  updateOrderStatusCheck,
  filterfieldforfile,
  OnConvertProtocolSteps,
  compareProtocolDataChanges,
  getHeight,
  reporttags,
  exportToCSV, getRangeValuesType,
  toDateFilter,
  Getprotocoluserworkflowfromsession,
  checkFormulaUndefinedInSheet,
  LogoutSessionClear,
  Onsaveactivewidgetsdata,
  GetSheetorders,
  GetUtcDateFormat,
  ChecktrialFileuploadsize,
  onGetUserControlRightsFolderstructure,
  getModuleRihtsOnModuleLoad,
  getReportModuleRights,
  compareJSONArrays,
  compareJSONObjects,
  UpdateMegedCellValues,
  BarcodeDesign,
  fetchInstalledPrinters,
  sendPrintRequest,
  renderSwitch,
  fetchOrderDetails,
  formsequenceformatview,
  formatGridDate,
  GetTabActiveOrNot,
  isNumeric,
  updateActiveUserDetail,
  updateimagesonsave,
  Servicecallforuserrightscallback,
  getfieldindexondatafill,
  setDateDetails,
  ToggleSwitch,
  getColumnName,
  gridDtatExport, gridDtatExportToolBar,
  KendoEditor,
  getfieldsfromsheetdata,
  SpreadConfig,
  SheettemplateTransactionDataUpdate,
  ProtocoltemplateTransactionDataUpdate,
  ProtocolOrderTransactionDataUpdate,
  ExcelExport,
  excelSerialDateToJSDate,
  validateDateformat,
  validateCommaSeparate,
  downloadattachment,
  isNumberFormat,
  checkAndFormatValue
};
// export const compareObjs = withTranslation(compareObjsFx);
